<template>
<div :style="( ( sticky && fluxo && dados && procedimentos && procedimentos.length ) ? 'margin-left: 300px; ' : '' )">

    <div class="alert alert-warning d-flex justify-content-between" v-if="( remarcacao || espera ) && dadosRemarcacao"
        :style="( ( sticky && fluxo && dados && procedimentos && procedimentos.length ) ? 'margin-right: 350px; ' : '' )">
        <span>
            <span class="text-muted mr-1">
                <i class="fas fa-retweet mr-1" v-if="!espera"></i>
                {{ this.trocarmedico
                    ? 'Alterar Profissional de'
                    : ( this.espera
                        ? ( 'Lista de Espera: ' + dadosRemarcacao.nome_paciente )
                        : 'Remarcação de ' + dadosRemarcacao.nome_paciente + ': ' ) }}
            </span>
            <span v-if="!espera">
                <span v-if="!sticky">
                    {{ getHumanDate (dadosRemarcacao.dt_inicio) }}, {{ getHumanDay (dadosRemarcacao.dt_inicio) }}, às
                    {{ dadosRemarcacao.dt_inicio.substr(11,5) }}
                </span>
            </span>
            <div class="text-muted small" v-if="!dadosRemarcacao.qtd || dadosRemarcacao.qtd == 1">
                <span v-if="!espera && sticky">
                    {{ $util.getFormatDate (dadosRemarcacao.dt_inicio).substr(0,5) }} {{ dadosRemarcacao.dt_inicio.substr(11,5) }}
                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                </span>
                {{ dadosRemarcacao.procedimento.search }}
            </div>
        </span>

        <div v-if="remarcacao">
            <div class="row" v-if="( !dadosRemarcacao.qtd || dadosRemarcacao.qtd == 1 ) && ( !cc || remarcar_filtro )">
                <div class="col col-12">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="remarcarfiltro" v-model="remarcar_filtro">
                        <label class="custom-control-label" for="remarcarfiltro">Horários para o mesmo profissional</label>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col col-12">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="remarcarfiltrounidade" v-model="remarcar_filtro_unidade">
                        <label class="custom-control-label" for="remarcarfiltrounidade">Horários para a mesmo unidade</label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="alert alert-warning d-flex justify-content-between" v-if="( medico_revisao && horarios )"
        :style="( ( sticky && fluxo && dados && procedimentos && procedimentos.length ) ? 'margin-right: 350px; ' : '' )">
        <span>
            <span class="text-muted mr-1">
                <i class="fas fa-undo-alt mr-2"></i>
                Revisão para {{ medico_revisao.st_nome_exibicao }} 
            </span>
            <span class="mr-2" v-if="dt_prazo_revisao">
                até {{ $util.getFormatDate(dt_prazo_revisao) }}
            </span>
            <span class="badge badge-light mr-2" v-if="unidade_revisao && unidade_revisao.st_sigla"
                :title="unidade_revisao.st_nome">
                {{ unidade_revisao.st_sigla }}
            </span>
        </span>

        <div>
            <div class="row">
                <div class="col col-12">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="remarcarfiltro" v-model="revisao_filtro">
                        <label class="custom-control-label" for="remarcarfiltro">Horários para o mesmo profissional</label>
                    </div>
                </div>
            </div>

            <div class="row" v-if="unidades.length > 0">
                <div class="col col-12">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="remarcarfiltround" v-model="revisao_filtro_unidade">
                        <label class="custom-control-label" for="remarcarfiltround">Horários para a mesma unidade</label>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="alert alert-warning" v-else-if="( adicao && dadosRemarcacao )"
        :style="( ( sticky && fluxo && dados && procedimentos && procedimentos.length ) ? 'margin-right: 350px; ' : '' )">
        <div class="row">
            <div class="col col-12">
                <celula-dados-paciente :hor="{ marcacao: dadosRemarcacao }" />
            </div>
        </div>
    </div>

    <div class="alert alert-warning" v-if="marcacao_alterar_proc">
        <div class="row">
            <div class="col col-12">
                <celula-dados-paciente 
                    :hor="{ marcacao: marcacao_alterar_proc }" 
                    :blockplano="marcacao_alterar_proc ? true : false" />

                <div v-if="marcacao_alterar_proc && marcacao_alterar_proc.id_marcacao && !marcacao_alterar_proc.id_atendimento 
                    && marcacao_alterar_proc.js_outros_campos && marcacao_alterar_proc.js_outros_campos.senha_ch && marcacao_alterar_proc.js_outros_campos.senha_ch == marcacao_alterar_proc.nome_paciente" class="mt-3">
                    <button type="button" class="btn btn-sm btn-danger" :disabled="$store.state.loading" @click="cancelar_senha(marcacao_alterar_proc)">Cancelar Senha: {{ marcacao_alterar_proc.js_outros_campos.senha_ch }}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="form-row justify-content-center" v-if="!horarios || adicao_procedimento_pos">
        <div class="col col-12 col-md-12 col-lg-8">

            <!-- Start da Marcação -->

            <div class="row" v-if="data">
                <div class="col col-12">
                    <p class="alert alert-primary text-center">
                        <i class="far fa-calendar-plus"></i>
                        {{ getHumanDate (data) }} | {{ getHumanDay (data) }}
                        <strong v-if="hora">
                            <i class="fas fa-clock ml-3"></i>
                            <span v-if="hg">
                                {{ hg }}
                                <span class="badge badge-primary ml-2">
                                   {{ hora.substr(3,2) }}
                                </span>
                            </span>
                            <span v-else>
                                {{ hora }}
                            </span>
                        </strong>
                        <span class="badge badge-light ml-3" v-if="extra">
                            extra
                        </span>
                    </p>

                    <div class="alert alert-danger text-center lead" v-if="data != $util.hoje()">
                        <i class="fa-solid fa-triangle-exclamation mr-3"></i>

                        <strong v-if="data < $util.hoje()">
                            Lançamento Retroativo
                        </strong>
                        <strong v-else-if="data > $util.hoje()">
                            Lançamento Futuro
                            <span class="badge badge-danger ml-2" v-if="dados && dados.reservar">Reservar</span>
                        </strong>
                    </div>
                </div>
            </div>

            <div v-if="cc && !fluxo && !aviso_final && !espera && !remarcacao && !autorizacao" class="alert alert-info">
                <template v-if="infusao">
                    <i class="fa-solid fa-circle-chevron-down mr-3"></i>
                    Infusão
                </template>
                <template v-else>
                    <i class="fa-solid fa-house-medical mr-3" aria-hidden="true"></i>
                    Centro Cirúrgico
                </template>
            </div>

            <div class="form-row d-flex justify-content-center" v-if="!fluxo">

                <div v-if="aviso_final && ( $route.path != '/recepcao' ) && tem_resumo_final && resumo && resumo.lista_resumo && resumo.lista_resumo[0] && resumo.lista_resumo[0].id_marcacao">
                    <documento ref="documento" :recepcao="true" refresh="imprimir_documento" />
                </div>

                <div class="col my-3 text-center" v-if="aviso_final" id="resumo-final">
                    <div>
                        <span v-if="$route.path == '/recepcao'" class="display-4">
                            <i class="fas fa-check text-success mb-3" :class="tem_resumo_final ? '' : 'fa-3x'"></i>
                        </span>
                        <span v-else-if="msg_final == 'Inclusão Realizada!'" class="display-4">
                            <i class="fas fa-list-ol text-success mb-3" :class="tem_resumo_final ? '' : 'fa-3x'"></i>
                        </span>
                        <span v-else class="display-4">
                            <i class="far fa-calendar-check text-success mb-3" :class="tem_resumo_final ? '' : 'fa-3x'"></i>
                        </span>

                        <div :class="tem_resumo_final ? 'lead' : 'display-4'">
                            <span v-if="$route.path == '/recepcao'">
                                Atendimento Registrado!
                            </span>
                            <span v-else-if="msg_final">
                                {{ msg_final }}
                            </span>
                            <span v-else>
                                Marcação Realizada!
                            </span>
                        </div>
                    </div>

                    <template v-if="resumo && tem_resumo_final">

                        <div class="d-flex my-3 d-print-none justify-content-center">
                            <a href="#" @click.prevent="avancar_aviso_final()" v-if="aviso_final" class="btn btn-success btn-lg mr-1">
                                Avançar
                            </a>

                            <a href="#" @click.prevent="imprimir_resumo()" v-if="aviso_final" class="btn btn-secondary btn-lg">
                                Imprimir
                            </a>

                            <a href="#" @click.prevent="copiar_resumo()" v-if="aviso_final" class="btn btn-secondary btn-lg ml-1">
                                Copiar Resumo
                            </a>
                        </div>

                        <div v-if="resumo.paciente">
                            <a href="#" @click.prevent="$root.perfil(resumo.paciente)" title="Paciente" class="card-link">
                                <i class="fa-solid fa-id-badge mr-2"></i>
                                {{ resumo.paciente.st_nome }}
                            </a>
                        </div>

                        <div v-else-if="resumo.cadastro_temporario">
                            <a href="#" @click.prevent="$root.perfil_temp(resumo.cadastro_temporario)" title="Paciente" class="card-link">
                                <i class="fa-solid fa-id-badge mr-2 text-secondary"></i>
                                {{ resumo.cadastro_temporario.st_nome }}
                            </a>
                        </div>

                        <span class="badge badge-success mt-2" v-if="resumo.lista_resumo && resumo.lista_resumo.length">
                            {{ resumo.lista_resumo.length }} 
                        </span>

                        <ul class="list-group mt-2 mb-3" v-if="resumo.lista_resumo && resumo.lista_resumo.length">
                            <li class="list-group-item" v-for="(proced, ipx) in resumo.lista_resumo" :key="ipx">
                                <div class="d-flex justify-content-between">
                                    <div class="text-left">
                                        <div>
                                            No.: M{{ proced.id_marcacao}}
                                            <a href="#" @click.prevent="abrir_anexar_arquivo(proced)" title="Anexar Arquivos." class="ml-3">
                                                <i class="fa fa-plus" aria-hidden="true" v-if="proced && ( !proced.arquivos || !proced.arquivos.length )"></i>
                                                <i class="fa-solid fa-paperclip" v-else></i>
                                            </a>

                                            <a href="#" @click.prevent="novoDocumento(proced)" class="ml-3 d-print-none" title="Gerar documento para esta marcação." v-if="( $route.path != '/recepcao' ) && tem_resumo_final">
                                                <i class="fa fa-file-o" aria-hidden="true"></i>
                                            </a>
                                        </div>

                                        {{ proced.procedimento.search }}
                                        
                                        <span class="badge badge-light ml-2" v-if="proced.unidade_operacao && proced.unidade_operacao.st_sigla">
                                            {{ proced.unidade_operacao.st_sigla }}
                                        </span>

                                        <div class="small text-muted">
                                            {{ proced.medico.st_nome_exibicao }}
                                        </div>

                                        <div class="small text-muted" v-if="proced.st_observacoes">
                                            Obs.: {{ proced.st_observacoes }}
                                        </div>
                                    </div>

                                    <div v-if="proced.dt_inicio" class="text-right">
                                        <span>{{ $util.getFormatDate(proced.dt_inicio) }} {{ proced.dt_inicio.slice(11,16) }}</span>
                                        <div class="small text-muted">
                                            {{ $util.getFormatDate(proced.dt_inicio, 'ddd') }}
                                        </div>
                                    </div>
                                </div>

                                <div class="text-left text-muted" v-if="proced.procedimento && proced.procedimento.unidade_procedimento && proced.procedimento.unidade_procedimento.instrucao && proced.procedimento.unidade_procedimento.instrucao.st_instrucao_agenda_online">
                                    <hr>
                                    <vue-markdown :source="proced.procedimento.unidade_procedimento.instrucao.st_instrucao_agenda_online" />
                                </div>

                                <div class="text-left" v-if="proced.js_outros_procedimentos && proced.js_outros_procedimentos.length">
                                    <table class="table table-sm small mb-0">
                                        <tbody>
                                            <tr v-for="(outro_proced, iox) in proced.js_outros_procedimentos" :key="iox">
                                                <td width="30%">
                                                    {{ outro_proced.search }}
                                                </td>
                                                <td width="70%">
                                                    <template v-if="outro_proced.unidade_procedimento && outro_proced.unidade_procedimento.instrucao && outro_proced.unidade_procedimento.instrucao.st_instrucao_agenda_online">
                                                        <vue-markdown :source="outro_proced.unidade_procedimento.instrucao.st_instrucao_agenda_online" />
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </li>
                        </ul>

                        <div v-if="resumo.resumo_unidades && resumo.resumo_unidades.length" class="text-left">
                            <div class="alert alert-light" v-for="(unidade, iux) in resumo.resumo_unidades" :key="iux">
                                <div>
                                    <strong>{{ unidade.st_nome }}</strong>
                                </div>
                                <div v-if="unidade.endereco">
                                    {{ unidade.endereco.exibir }}
                                </div>
                                <div v-if="unidade.st_email">
                                    <strong>e-mail:</strong>
                                    <span>
                                        {{ unidade.st_email }}
                                    </span>
                                </div>
                                <div v-if="unidade.telefone_unidade_operacaos && unidade.telefone_unidade_operacaos.length">
                                    <strong>Telefones:</strong>
                                    <span v-for="(tel, itx) in unidade.telefone_unidade_operacaos" :key="itx" class="mr-4">
                                        {{ $util.formatMask(tel.telefone.st_numero, 'tel') }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div v-if="resumo.resumo_instrucao" class="text-left alert alert-light" style="white-space: pre-wrap;">{{ resumo.resumo_instrucao }}</div>

                    </template>
                    
                </div>

                <div class="col" v-if="!aviso_final && !espera && !remarcacao && !autorizacao">
                    <a href="#" @click.prevent="startFluxo(2)" @shortkey="startFluxo(2)"
                        class="card border-0 card-templates dashcard card-link az-anime-surgir">
                        <div class="card-body d-flex align-items-center flex-column text-center text-white atalho" style="--height: 400px;"
                            :class="'bg-success'">
                            <i class="fas fa-user-check fa-4x"></i>
                            <div class="display-4 atalho-titulo mt-2">
                                <small>Paciente</small>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col" v-if="!aviso_final && !espera && !remarcacao && !autorizacao">
                    <a href="#" @click.prevent="startFluxo(1)" @shortkey="startFluxo(1)"
                        class="card border-0 card-templates dashcard card-link az-anime-surgir">
                        <div class="card-body d-flex align-items-center flex-column text-center text-white atalho" style="--height: 400px;"
                            :class="'bg-danger'">
                            <i class="fas fa-user-check fa-4x"></i>
                            <div class="display-4 atalho-titulo mt-2">
                                <small class="text-nowrap text-truncate">Primeira Vez</small>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col" v-if="tem_atend_outro && !aviso_final && !espera && !remarcacao && !autorizacao && id_recepcao">
                    <a href="#" @click.prevent="startFluxo(3)" @shortkey="startFluxo(3)"
                        class="card border-0 card-templates dashcard card-link az-anime-surgir">
                        <div class="card-body d-flex align-items-center flex-column text-center text-white atalho" style="--height: 400px;"
                            :class="'bg-dark'">
                            <i class="fas fa-user-tie fa-4x"></i>
                            <div class="display-4 atalho-titulo mt-2">
                                <small class="text-nowrap text-truncate">Outro</small>
                            </div>
                        </div>
                    </a>
                </div>
            </div>

            <div class="form-row w3-animate-opacity" v-else-if="!data">
                <div class="col col-6 mb-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-secondary">
                        <i class="fas fa-stopwatch"></i>
                        {{ tempo }}
                    </button>
                </div>
                <div class="col col-6 mb-3 d-flex flex-column" @click="reiniciar ()">
                    <button type="button" class="btn btn-outline-danger">
                        {{ ( consultorio && orcamento ) ? 'Voltar' : 'Reiniciar' }}
                    </button>
                </div>
            </div>

            <div class="row w3-animate-opacity" v-else-if="!marcacao_alterar_proc && !adicao_outro">
                <div class="col col-12 mb-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-secondary" @click="reiniciar ()">
                        Voltar
                    </button>
                </div>
            </div>

            <!-- Campos de Buscar -->

            <div v-if="!buscando || data">

                <!-- Seleção de Outros Visitante -->
                <visita-medico ref="visita" v-if="fluxo && fluxo == 3" @refresh="$emit('refresh')" />

                <!-- Seleção da Unidade -->

                <div class="row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="fluxo && !data && this.$store.state.unidade.unidade_operacaos.length > 1">

                    <div class="col col-12">

                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa fa-building fa-fw" aria-hidden="true"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="dados.unidade_operacao">
                                <option value="">Todas as Unidades</option>
                                <option v-for="(und, iux) in lista_unidades" :value="und" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>
                    </div>

                </div>

                <div class="form-row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="informa_regiao">

                    <div class="col col-12 col-md-9">
                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa-solid fa-location-dot fa-fw"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="dados.regiao_cd">
                                <option value="">Região...</option>
                                <option v-for="(regiao, iux) in lista_regioes" :value="regiao" :key="iux">{{ regiao.search }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa-solid fa-user-group fa-fw"
                            type="number"
                            placeholder="Pacientes..."
                            v-model="dados.qt_pac" />
                    </div>

                </div>

                <!-- Seleção do Paciente-->

                <div class="row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="fluxo == 2">

                    <div class="col col-12">

                        <az-input
                            placeholder="Informe o nome ou CPF do paciente..."
                            icon="fas fa-user"
                            type="autocomplete"
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            :optionsParm="{ mrc: ( origem == 'confirm' ? false : true ) }"
                            ref="info_paciente"
                            v-model="dados.paciente"
                            :optimized_ac="true"
                            @onEnter="focusOn('info_plano')"
                            @input="selecionarPaciente()">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="is_coopeder() && !dados.paciente">
                                    <button class="btn btn-outline-secondary" 
                                        type="button" id="button-addon2" 
                                        @click="migrar_paciente(dados.paciente)" 
                                        title="Migrar paciente">
                                        <i class="fa-solid fa-cloud-download"></i>
                                    </button>
                                </div>

                                <div class="input-group-append" v-else-if="dados.paciente && dados.paciente.id_pessoa">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="verPerfil(dados.paciente)" title="Histórico do paciente.">
                                        <i class="fa-solid fa-id-badge"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                    </div>

                </div>

                <!-- Seleção da Operadora / Plano -->

                <div class="row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="fluxo && ( fluxo == 1 || dados.paciente )">

                    <div class="col col-12" v-if="dados">

                        <az-input
                            placeholder="Operadora/Plano..."
                            icon="far fa-credit-card"
                            type="autocomplete"
                            optionsMode="aql"
                            optionsName="planos.atendimento"
                            :optionsParm="{
                                atendimento: true,
                                plano_id_unidade_operacao: id_unidade_operacao_selecionado
                            }"
                            service="planos.index"
                            :optionsSync="false"
                            v-model="dados.plano"
                            ref="info_plano"
                            :edicao="!dados.selected && !$store.state.user.id_plano"
                            @input="selecionarPlano(dados.plano)"
                            @onEnter="focusOn('info_procedimento')" />

                    </div>

                    <div class="col col-12" v-if="!$store.state.user.id_plano && this.$store.state.options.marcacoesStats && dados && !dados.plano">

                        <ul class="list-group">
                            <button type="button" class="list-group-item list-group-item-action"
                                v-for="(item, id) in this.$store.state.options.marcacoesStats.planos" :key="id"
                                @click="selecionarPlano (item.plano)">
                                {{ item.plano.search }}
                            </button>
                        </ul>

                    </div>

                </div>

                <!-- Seleção do Procedimento -->

                <div class="row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="fluxo && dados && dados.plano && !hide_proc">

                    <div class="col col-12">

                        <div v-if="!dados.procedimento && adicoes && adicoes.length" class="mb-2">
                            <button type="button" class="btn btn-sm btn-outline-primary mr-1" @click="selecionarAdicao(adicao)" v-for="(adicao, iax) in adicoes" :key="iax">
                                {{ adicao.st_titulo }}
                            </button>
                        </div>

                        <az-input
                            placeholder="Selecione o Procedimento..."
                            icon="fas fa-play"
                            type="autocomplete"
                            optionsMode="aql"
                            :optionsName="( $store.state.user.proc_oper ? 'procedimentos.agenda.op.' + ( dados.plano.id_operadora == 1 ? 'p.' + dados.plano.id_plano : dados.plano.id_operadora ) : 'procedimentos.agenda' ) 
                                + ( id_unidade_operacao_selecionado ? '.uo' + id_unidade_operacao_selecionado : '' )
                                + ( cc ? '.cc' : '' ) + ( infusao ? '.infusao' : '' ) "
                            :optionsParm="$store.state.user.proc_oper 
                                ? { 
                                    id_operadora: dados.plano.id_operadora, 
                                    id_plano: dados.plano.id_plano, 
                                    id_unidade_operacao: id_unidade_operacao_selecionado,
                                    cc: cc, 
                                    infusao: infusao, 
                                } 
                                : {
                                    id_unidade_operacao: id_unidade_operacao_selecionado, 
                                    cc: cc,
                                    infusao: infusao, 
                                }"
                            :optionsSync="false"
                            v-model="dados.procedimento"
                            ref="info_procedimento"
                            :procsigla="orcamento"
                            :edicao="!dados.selected"
                            @input="selecionarProcedimento (dados.procedimento)"
                            @onEnter="enterNoProcedimento ()">

                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="info_revisao_manual && dados && dados.procedimento && dados.procedimento.id_classe_procedimento == 1">
                                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{ traduzir_tipo_consulta(dados.tipo_consulta) }}
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="definir_tipo_consulta('C')">-</a>
                                        <a class="dropdown-item" href="#" @click.prevent="definir_tipo_consulta('I')">Inicial</a>
                                        <a class="dropdown-item" href="#" @click.prevent="definir_tipo_consulta('P')">Pré-Natal</a>
                                        <a class="dropdown-item" href="#" @click.prevent="definir_tipo_consulta('R')">Revisão</a>
                                        <a class="dropdown-item" href="#" @click.prevent="definir_tipo_consulta('S')">Subsequente</a>
                                    </div>
                                </div>

                                <div class="input-group-append" v-if="dados.procedimento && dados.procedimento.js_complementos && dados.procedimento.js_complementos.length">
                                    <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        {{ dados.st_regiao ? dados.st_regiao  : 'Região...' }}
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-scroll" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" 
                                            href="#" v-for="(regiao, irx) in dados.procedimento.js_complementos" 
                                            :key="irx"
                                            @click.prevent="regiao_add(dados, regiao)" :class="regiao_tem(dados, regiao) ? 'active' : ''">
                                            {{ regiao }}
                                        </a>
                                    </div>
                                </div>
                            </template>

                        </az-input>

                    </div>

                    <div class="col col-12" v-if="!orcamento && dados.procedimento && dados.procedimento_equipamentos">
                        <selecao-recursos v-model="dados.procedimento_equipamentos" :equipamentos="recursos" :procedimento="dados.procedimento" />
                        <pre v-if="false">{{ dados.procedimento_equipamentos }}</pre>
                    </div>

                    <div class="col col-12" v-if="procStats && !dados.procedimento && !cc">

                        <ul class="list-group">
                            <button type="button" class="list-group-item list-group-item-action list-group-item-light"
                                v-for="(item, id) in procStats" :key="id"
                                @click="selecionarProcedimento (item.procedimento)">
                                {{ item.procedimento.search }}
                            </button>
                        </ul>

                    </div>

                </div>

                <!-- Selecionar Médico -->

                <div class="row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="!cc && !orcamento && info_oferta && fluxo && dados && dados.plano && dados.procedimento">

                    <div class="col col-12">
                        <az-input
                            type="checkbox-group"
                            label="Ofertado pela Clínica"
                            v-model="ofertado" />
                    </div>

                </div>

                <div class="row d-flex justify-content-center mb-2 w3-animate-opacity" v-if="!cc && !orcamento && dados && dados.plano && procedimentos.find(pr => pr.regiao_cd)">

                    <div class="col col-12">
                        <az-input
                            type="checkbox-group"
                            label="Filtrar por Região"
                            v-model="filtro_por_regiao" />
                    </div>

                </div>

                <!-- Selecionar Médico -->

                <div class="row d-flex justify-content-center mb-3 w3-animate-opacity" v-if="fluxo && dados && dados.plano && dados.procedimento && ( !orcamento || dados.procedimento.id_especialidade != 2 )">

                    <div class="col col-12">

                        <!-- optionsMode="aql" service="medicos.index" -->

                        <az-input
                            placeholder="Profissional..."
                            icon="fas fa-briefcase-medical"
                            type="autocomplete"
                            :optionsList="listaMedicos"
                            optionsData=""
                            optionsDisplay="st_nome_exibicao"
                            :optionsSync="false"
                            v-model="dados.medico"
                            ref="info_medico"
                            :edicao="!block_medico"
                            @input="selecionarMedico (dados.medico)"
                            @onEnter="enterNoMedico ()" />

                    </div>

                    <div class="col col-12" v-if="!data && subespecialidades && subespecialidades.length && !dados.medico && !block_medico">
                        <div class="my-1">
                            <button type="button" class="btn btn-sm"
                                :class="subesp.selecionado ? 'btn-success' : 'btn-outline-success'"
                                v-for="(subesp, isx) in subespecialidades" :key="isx"
                                @click="subesp.selecionado = !subesp.selecionado">
                                {{ subesp.tag }}
                            </button>
                        </div>
                    </div>

                    <div class="col col-12" v-if="!orcamento && pacienteMedicoStats && !dados.medico && !block_medico">

                        <ul class="list-group">
                            <button type="button" class="list-group-item list-group-item-action list-group-item-light"
                                v-for="(item, id) in pacienteMedicoStats" :key="id"
                                @click="selecionarMedico (item.medico)">
                                {{ item.medico.st_nome_exibicao }}
                                <div v-if="item.medico.subespecialidades && item.medico.subespecialidades.length">
                                    <span v-for="(subesp, isx) in item.medico.subespecialidades" :key="isx" class="badge badge-success mr-1">
                                        {{ subesp }}
                                    </span>
                                </div>
                            </button>
                        </ul>

                    </div>

                    <div class="col col-12" v-else-if="!orcamento && !dados.medico && listaMedicos && listaMedicos.length > 0 && listaMedicos.length <= 5 && !block_medico">

                        <ul class="list-group">
                            <button type="button" class="list-group-item list-group-item-action list-group-item-light"
                                v-for="(item, id) in listaMedicos" :key="id"
                                @click="selecionarMedico (item)">
                                {{ item.st_nome_exibicao }}
                                <div v-if="item.subespecialidades && item.subespecialidades.length">
                                    <span v-for="(subesp, isx) in item.subespecialidades" :key="isx" class="badge badge-success mr-1">
                                        {{ subesp }}
                                    </span>
                                </div>
                            </button>
                        </ul>

                    </div>

                </div>

            </div>

            <div v-else>

                <div class="card dashcard">
                    <div class="card-body text-center">
                            <div class="display-4 my-3">Buscando horários...</div>

                            <az-loading msg="..." />

                            <div class="mt-3 text-muted lead">
                                {{ $util.formatNumber(tempo_busca, 1) }}s
                            </div>

                            <div class="spinner-border text-success mb-3" v-if="1 == 0"
                                style="width: 3rem; height: 3rem;"
                                role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                    </div>
                </div>

            </div>

            <!-- Agendamento de Demanda Espontânea -->

            <div v-if="data">

                <div v-if="dados && dados.plano && dados.procedimento && dados.medico">

                    <template v-if="marcacao_alterar_proc">

                        <div class="row d-flex justify-content-center mt-3 mb-3">

                            <div class="col col-12 d-flex flex-column">
                                <az-submit :disabled="( !espontaneaHora && !hora ) || buscando_procedimento" @click="adicao_direta ()">
                                    Concluir
                                </az-submit>
                            </div>

                        </div>

                    </template>

                    <template v-else>

                        <pre class="alert-info" v-if="false">{{ cadastro_temporario }}</pre>
                        <pre class="alert-warning" v-if="false && dados.paciente">{{ dados.paciente }}</pre>

                        <template v-if="true">

                            <cadastro-temporario
                                v-model="cadastro_temporario"
                                v-if="( fluxo == 1 && !dados.paciente ) || ( fluxo == 2 && dados.paciente && dados.paciente.id_pessoa < 0 && cadastro_temporario )"
                                :validate="validarCadTemp"
                                @selecionar="identificar_paciente" />

                            <div class="mt-3" v-else-if="fluxo == 2 && dados.paciente && dados.paciente.id_pessoa > 0">
                                <div class="form-row">
                                    <div class="col col-12 col-md-6">
                                        <az-input
                                            sizing="sm"
                                            label="e-mail"
                                            type="email"
                                            v-model="dados.paciente.cadastro.st_email"
                                            :validate="validarCadTemp" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input label="Telefone"
                                            sizing="sm"
                                            type="fone"
                                            :validate="validarCadTemp"
                                            v-model="dados.paciente.cadastro.telefones.telefone" />
                                    </div>
                                    <div class="col col-12 col-md-3">
                                        <az-input label="Celular"
                                            sizing="sm"
                                            type="fone"
                                            :validate="validarCadTemp"
                                            v-model="dados.paciente.cadastro.telefones.celular" />
                                    </div>
                                </div>
                            </div>

                        </template>

                        <div class="form-row">
                            <div class="col col-12 col-md-3" v-if="!hora">
                                <az-sub-title title="Horário">
                                    <small class="text-muted">{{ faixaHorarios.texto ? faixaHorarios.texto : '' }}</small>
                                </az-sub-title>
                                <label class="form form-control" v-if="!faixaHorarios.texto">
                                    <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="buscando">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>
                                        Horário não disponível...
                                    </span>
                                </label>
                                <az-input sizing="sm" type="time" v-model="espontaneaHora" v-else @input="atualizarHoraRepeticao()" />
                            </div>

                            <div class="col col-12 col-md-3" v-if="!hora">
                                <az-sub-title title="Horário" />
                                <az-input sizing="sm"  type="checkbox-group" label="Extra" v-model="extra" />
                            </div>

                            <div class="col col-12" :class="!hora ? 'col-md-3' : 'col-md-6'" v-if="tem_tele_atendimento">
                                <az-sub-title title="Teleatendimento" />
                                <az-input sizing="sm" type="checkbox-group" label="Teleatendimento" v-model="fl_tele_atendimento" />
                            </div>

                            <div class="col col-12" :class="( !hora || tem_tele_atendimento ) ? 'col-md-3' : ''">
                                <az-sub-title title="Observação" />
                                <az-input sizing="sm" type="text" v-model="st_observacoes">
                                    <template v-slot:button-pos>
                                        <div class="input-group-append"
                                            v-if="( hora || espontaneaHora ) &&
                                                ( dados ) &&
                                                ( dados.procedimento && ( dados.procedimento.id_classe_procedimento == 17 || dados.procedimento.id_classe_procedimento == 18 ) ) &&
                                                ( dados.repetir === true || dados.repetir === false )">
                                            <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                                                @click="toggle_repeticao(dados)">
                                                Recorrência...
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div v-if="dados && ( ( origem == 'confirm' ) || force_exibir_campos_customizados )">
                            <div v-if="campos_customizados_base && campos_customizados_base.js_campos.length" class="row">
                                <div class="col col-12">
                                    <az-sub-title :title="campos_customizados_base.st_titulo" />
                                    <formulario
                                        sizing="sm" 
                                        :gutters="true"
                                        v-model="campos_customizados_base.js_campos"
                                        :saved="saved"
                                        :validate="validarCadTemp"
                                        mode="fixed"
                                        :config="true" />
                                </div>
                            </div>

                            <div class="alert alert-info d-flex justify-content-between mt-3" v-if="dados.coleta_dom && dados.paciente && dados.paciente.cadastro && dados.paciente.cadastro.endereco && exibir_endereco">
                                <div>
                                    <i class="fa-solid fa-location-dot mr-2"></i>
                                    {{ exibir_endereco }}
                                </div>
                                <div>
                                    <a href="#" @click.prevent="copiar_texto(exibir_endereco, 'Endereço Copiado')">
                                        <i class="fas fa-copy"></i>
                                    </a>
                                </div>
                            </div>

                            <!-- Formulários de Pré-Atendimento -->
                            <div class="mt-3" v-if="confirm_docs && confirm_docs.length">
                                <pre-atendimento-edit 
                                    v-model="confirm_docs" 
                                    :validate="validarCadTemp" />
                            </div>
                        </div>

                        <div class="form-row" v-if="unidade_operacao_selecionada && unidade_operacao_selecionada.carros && unidade_operacao_selecionada.carros.length">
                            <div class="col col-12 col-md-6" v-if="lista_regioes && lista_regioes.length">
                                <az-input   
                                    sizing="sm"
                                    label="Região"
                                    type="select"
                                    :optionsList="lista_regioes"
                                    :validate="validarCadTemp"
                                    v-model="dados.regiao_cd" />
                            </div>

                            <div class="col col-12" :class=" ( lista_regioes && lista_regioes.length ) ? 'col-md-6' : ''">
                                <az-input
                                    sizing="sm"
                                    type="select"
                                    label="Carro"
                                    :optionsList="unidade_operacao_selecionada.carros"
                                    optionsData="id_local"
                                    required
                                    :validate="validarCadTemp"
                                    v-model="dados.id_local" />
                            </div>
                        </div>

                        <!-- Selecionar Solicitação de Autorização na Adição Direta -->
                         <template v-if="$refs.instruc_conf && $refs.instruc_conf.checar_agenda_com_solic_aut_rest()">
                            <button type="button" class="btn btn-outline-secondary btn-sm mt-1" @click="selecionar_autorizacao_adicao_direta()">Autorização</button>
                        </template>

                        <div class="row d-flex justify-content-center mt-3 mb-3">

                            <div class="col col-12 d-flex flex-column">
                                <az-submit :disabled="( !espontaneaHora && !hora ) || buscando_procedimento" @click="adicao_direta ()">
                                    Concluir
                                </az-submit>
                            </div>

                        </div>

                        <div v-if="dados && origem == 'confirm'">
                            <adicionar-procedimento v-model="dados" />
                            <pre v-if="false">{{ dados }}</pre>
                        </div>

                    </template>

                </div>

                <!-- Histórico -->
                <HistoricoMarcacoes
                    ref="historico"
                    :historico="historicoMarcacoes"
                    :retornos="pacienteProcStats ? pacienteProcStats.retornos : []"
                    :legado="historicoLegado"
                    :autorizacao="historicoAutorizacao"
                    :nps="pacienteProcStats ? pacienteProcStats.nps : null"
                    v-else-if="dados.paciente"
                    :poderevisar="false"
                    :podeconfirmar="false"
                    :naoalterar="true" />

                <br><br><br><br><br>
                <br><br><br><br><br>

            </div>

            <!-- Agendamento com seleção do horário -->

            <div v-else>

                <!-- Sinalizador Bloqueio de Marcação -->
                <div v-if="fluxo && !buscando && lista_sinalizadores && lista_sinalizadores.length">
                    <div v-for="(sinal, isx) in lista_sinalizadores" :key="isx" class="alert lead" :class="'alert-' + ( sinal.sinalizador_completo.st_cor ? sinal.sinalizador_completo.st_cor : 'danger' )">
                        {{ sinal.sinalizador_completo.st_acao_mensagem ? sinal.sinalizador_completo.st_acao_mensagem : sinal.sinalizador_completo.search }}
                    </div>
                </div>

                <!-- Inclusão da Marcação -->
                <div class="form-row d-flex justify-content-center mt-3 mb-3 w3-animate-opacity" v-else-if="fluxo && !buscando">

                    <div class="col d-flex flex-column" :class="orcamento ? 'col-12' : 'col-4'">
                        <button type="button" class="btn" @click="adicionarProcedimento ()"
                            ref="btn_add"
                            :class="dados.procedimento ? ' btn-primary' : 'btn-outline-primary'"
                            :disabled="!dados.procedimento || buscando || $store.state.loading">
                            Adicionar
                        </button>
                    </div>

                    <template v-if="!orcamento">
                        <div class="col col-4 d-flex flex-column" >
                            <button type="button" class="btn" :disabled="buscando || ( !dados.procedimento && !procedimentos.length ) || $store.state.loading"
                                @click="buscarHorarios ()"
                                :class="dados.procedimento || !procedimentos.length ? 'btn-outline-success' : 'btn-success'">
                                <span class="spinner-border spinner-border-sm" v-if="buscando"></span>
                                Buscar Horários
                            </button>
                        </div>

                        <div class="col col-4 d-flex flex-column" >
                            <button type="button" class="btn btn-outline-success" :disabled="buscando || ( !dados.procedimento && !procedimentos.length ) || $store.state.loading"
                                @click="buscarHorariosDe ()">
                                <span class="spinner-border spinner-border-sm" v-if="buscando"></span>
                                Buscar a partir de...
                            </button>
                        </div>
                    </template> 

                </div>

                <!-- Orçamento -->
                <procedimentos-orcados 
                    ref="orcamento" 
                    :dados="dados"
                    :regioes="regioes"
                    :orc_convert_unidades="orc_convert_unidades" 
                    v-model="procedimentos" 
                    v-if="orcamento"
                    @selecionado="orcamento_selecionado" />

                <!-- Histórico -->
                <HistoricoMarcacoes
                    ref="historico"
                    :historico="historicoMarcacoes"
                    :retornos="pacienteProcStats ? pacienteProcStats.retornos : []"
                    :legado="historicoLegado"
                    :autorizacao="historicoAutorizacao"
                    :nps="pacienteProcStats ? pacienteProcStats.nps : null"
                    v-else-if="dados.paciente"
                    :poderevisar="!buscando"
                    :podeconfirmar="true"
                    @confirmar="confirmar_marcacao"
                    @revisao="marcar_revisao"
                    @agendar="selecionarProcedimento"
                    @refresh="selecionarPaciente()" />

                <pre v-if="false">{{ dados }}</pre>

            </div>

        </div>

        <div class="col col-12 col-md-12 col-lg-4" v-if="fluxo && dados">

            <div class="row" v-show="procedimentos.length && !orcamento">

                <div class="col col-12">

                    <procedimentos-solicitados
                        :agrupavel="true"
                        v-model="procedimentos"
                        :cores="cores"
                        :removeOnUnSelect="horarios ? false : true"
                        :link_edit="true"
                        :sticky="sticky"
                        @removido="refresh_instrucoes()" 
                        @editar="editar_proc" 
                        @sticky="toggle_sticky()">

                        <div class="mb-3"></div>

                    </procedimentos-solicitados>

                </div>

            </div>

            <repetir-agenda
                :id_medico="dados.medico.id_pessoa"
                v-if="data && dados.medico && dados.repetir && !remarcacao"
                :coluna_unica="true"
                v-model="dados.repeticao" />

            <az-instrucoes
                v-else
                ref="instruc_conf"
                :autorizacao="autorizacao"
                :dados="dados"
                :cores="cores"
                :id_unidade_operacao="id_unidade_operacao"
                :procedimentos="data && dados.procedimento ? [dados] : procedimentos"
                :historico="historicoMarcacoes"
                :pacotes="pacienteProcStats ? pacienteProcStats.pacotes : []"
                :contexto="orcamento ? 'O' : 'C'"
                :orcamento="orcamento"
                :sinalizadores="pacienteProcStats ? pacienteProcStats.sinalizadores : []"
                :link_regiao="!horarios || adicao_procedimento_pos"
                :nps="pacienteProcStats ? pacienteProcStats.nps : null"
                @selecionar="selecionar_regiao"
                v-model="podeMarcar" />

        </div>

    </div>

    <!-- Exibição dos @HORÁRIOS encontrados -->

    <div class="form-row" v-if="horarios && !adicao_procedimento_pos" :style="sticky ? 'margin-right: 350px; ' :  ''">

        <div class="col col-12" :class="sticky ? '' : 'col-md-8'">

            <div class="form-row">
                <div class="col col-6 mb-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-secondary">
                        <i class="fas fa-stopwatch"></i>
                        {{ tempo }}
                    </button>
                </div>

                <div class="col col-6 mb-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-secondary" @click="voltar ()">
                        Voltar
                    </button>
                </div>
            </div>

            <div class="mb-3">

                <az-empty-state
                    icon="far fa-calendar-times"
                    msg="Nenhum horário disponível"
                    v-if="!Object.keys(exibicao).length" />

                <ul class="list-group dashcard w3-animate-opacity" v-shortkey="{up: ['shift', 'arrowup'], down: ['shift', 'arrowdown']}" @shortkey="navegarDias">
                    <li class="list-group-item fixo-topo" v-if="procedimentos && procedimentos.length > 1">
                        <div class="row">
                            <div class="col col-12">
                                <div class="mb-0">
                                    <span class="badge ml-1" :class="'badge-' + cores[ipx]" v-for="(proc, ipx) in procedimentos" :key="ipx">
                                        {{ proc.procedimento.st_sigla 
                                            ? proc.procedimento.st_sigla 
                                            : ( proc.procedimento.st_procedimento 
                                                ? proc.procedimento.st_procedimento 
                                                    + ( ( proc.procedimento.fl_exibir_especialidade && proc.procedimento.especialidade )
                                                        ? ' - ' + proc.procedimento.especialidade.st_especialidade : '' )
                                                : proc.procedimento.search
                                             ) }}
                                        <i class="fa fa-times ml-1" v-if="proc.conjunto && proc.conjunto_index === null"></i>
                                        <i class="fas fa-check ml-1" v-else-if="proc.hora || proc.conjunto"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </li>
                    <template v-for="(dia, index, linha) in exibicao">
                        <li  :key="index" class="list-group-item" :class="( dados && dados.infusao && dados.infusao.in_qt_data && dados.infusao.in_qt_data == index ) ? 'list-group-item-warning' : ''" v-if="true">
                            <div class="row">
                                <div class="col col-12 col-md-2 d-flex flex-column justify-content-center align-items-center" :class="linha === selecao.dia ? 'bg-primary text-white' : ''">
                                    <div>
                                        <h4 class="mb-0">
                                            <a href="#" @click.prevent="listaPacientes(index)" class="card-link" :class="linha === selecao.dia ? 'text-white' : 'text-primary'">
                                                <div>{{ getFormatDate (index, 'DD/MM') }}</div>
                                            </a>
                                        </h4>
                                    </div>
                                    <div class="mb-2">
                                        <small :class="linha === selecao.dia ? '' : 'text-muted'">
                                            {{ getFormatDate (index, 'dddd') }}
                                        </small>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-10 text-center text-md-left">
                                    <div class="mb-2" v-for="(proca, ida) in dia" :key="ida">
                                        <button class="btn mr-1 mb-1"
                                            :class="'btn-outline-' + cores[hora[0].index]"
                                            data-toggle="tooltip" data-placement="top" title="Marcações Realizadas"
                                            v-if="hora.length">
                                            <i class="fas fa-list"></i>
                                        </button>
                                        <button v-for="(hora, ih) in grupo_hora(proca)" :key="ih"
                                            @click="selecionar_hora(hora)"
                                            class="btn mr-1 mb-1"
                                            :class="'btn-' + ( !hora_sem_teto(hora) ? 'outline-' : '' ) + ( check_marcado (hora) ? 'outline-' : '' ) + cores[hora[0].index]"
                                            data-html="true"
                                            data-toggle="tooltip" data-placement="top" :title="lista_hora(hora)">
                                            <i class="fas fa-ban mr-1" v-if="!hora_sem_teto(hora)"></i>
                                            <span v-if="hora.length > 0 && ( hora[0].ordem_chegada || hora[0].extra || hora[0].bloqueado )">
                                                {{ hora[0].exibir }}
                                            </span>
                                            <span v-else>
                                                {{ ih }}h
                                            </span>
                                        </button>
                                        <div>
                                            <small class="text-muted">
                                                {{ local_dia(proca) }}
                                            </small>
                                        </div>
                                        <pre v-if="false">{{ grupo_hora (proca) }}</pre>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li :key="index + '-lim-rev'" class="list-group-item list-group-item-dark text-center" v-if="limite_revisao(index)">
                            Prazo para revisão até {{ $util.getFormatDate(dt_prazo_revisao) }}
                        </li>
                    </template>
                </ul>

                <p class="alert alert-info" v-if="this.remarcacao && this.trocarmedico">
                    Confirme o horário para seleção do profissional.
                </p>

                <div class="mt-3 d-flex flex-column" v-else>
                    <button class="btn btn-outline-secondary" type="button" @click="buscarHorarios ()"
                        :disabled="buscando">
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="buscando">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <span>Buscar mais horários {{ buscadoAte ? ' depois de ' + $util.getFormatDate(buscadoAte) : '' }}</span>
                    </button>

                    <button class="btn btn-outline-secondary mt-2" type="button" @click="buscarHorariosDe ()" :disabled="buscando">
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-if="buscando && buscadoAte">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <span>Buscar mais horários a partir de...</span>
                    </button>
                </div>

                <div class="mt-3 d-flex flex-column" v-if="1 == 0">
                    <button class="btn btn-outline-secondary" type="button"
                        v-if="this.dados.plano.id_operadora == 1 && !this.remarcacao">
                        Registrar Orçamento
                    </button>
                </div>



                <span v-if="1 == 0">{{ exibicao }}</span>

            </div>

            <div v-if="1 == 0">
                <ul class="list-group">
                    <li class="list-group-item list-group-item-primary">{{ hora_selecionada[0].base }}h</li>
                    <li class="list-group-item d-flex align-items-center" v-for="(item, index) in grupo_hora_selecione ()" :key="index">
                        <h3 class="mr-2 pb-0">
                            <span class="badge badge-primary">{{ index }}</span>
                        </h3>
                        <div>
                            <button type="button" class="btn btn-success btn-sm mr-2"
                                v-for="(medico, im) in item" :key="im" @click="selecionar_horario (medico)">
                                {{ medico.medico.st_nome_exibicao }}
                            </button>
                        </div>
                    </li>
                </ul>

                <div class="mt-2" v-if="1 == 0 && horario_selecionado">

                    <CadastroTemporario v-if="!dados.paciente"></CadastroTemporario>

                    <div class="row d-flex justify-content-center mt-3 mb-3">

                        <div class="col col-12 d-flex flex-column">
                            <button type="button" class="btn btn-success">
                                Concluir
                            </button>
                        </div>

                    </div>

                </div>

            </div>

        </div>

        <!-- Filtros -->

        <div class="col col-12 col-md-4">

            <div>
                <procedimentos-solicitados 
                    v-model="procedimentos" 
                    :cores="cores"
                    :link_edit="true"
                    :sticky="sticky"
                    @editar="editar_proc" 
                    @sticky="toggle_sticky()"
                    @selecionar="mudanca_selecao_proc"
                    @marcar_medicos="filtrar_unico_medico(true)">

                    <div v-if="procedimentos 
                        && procedimentos.filter(item => item.selected).length > 1 
                        && tem_medico_unico"
                        class="alert alert-light" :class="sticky ? 'p-2 small' : ''">
                        <div class="custom-control custom-switch mb-2 mb-md-0">
                            <input type="checkbox" class="custom-control-input" id="marcacaoUnicaSwitch"
                                v-model="marcacao_unico_profissional" @click="filtrar_unico_medico()">
                            <label class="custom-control-label" for="marcacaoUnicaSwitch">
                                Marcação única com o mesmo profissional
                            </label>
                        </div>
                    </div>

                    <div v-if="horarios_selecionados" class="d-flex flex-column mt-3" :class="sticky ? 'mx-2' : ''">
                        <button class="btn btn-dark" @click="exibir_confirmacao()">
                            <i class="far fa-calendar-check mr-2"></i>
                            Confirmar
                        </button>
                    </div>

                    <div v-else-if="procedimentos.length == 1 && !espera" class="d-flex flex-column mt-3" :class="sticky ? 'mx-2' : ''">
                        <button class="btn btn-secondary" @click="exibir_confirmacao(true)">
                            <i class="fas fa-list-ol mr-2"></i>
                            Incluir na Lista de Espera
                        </button>
                    </div>

                    <div v-if="procedimentos.length && sticky" class="d-flex flex-column mt-3" :class="sticky ? 'mx-2' : ''">
                        <button class="btn btn-outline-dark" @click="voltar(true)">
                            <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                            Incluir Outro Procedimento
                        </button>
                    </div>

                    <span class="mb-3"></span>

                    <!-- Outros Procedimentos Agendas na Remarcação -->
                    <div v-if="sticky && outras_agendas && outras_agendas.length">
                        <ul class="list-group mt-3">
                            <li class="list-group-item small p-2">Outras Agendas para {{ $util.getFormatDate(outras_agendas[0].dt_inicio) }}</li>
                            <li class="list-group-item small p-2" v-for="(outra, iox) in outras_agendas" :key="iox">
                                <div>
                                    {{ outra.procedimento.search }}
                                    <span class="badge badge-primary" v-if="outra.outros_proc" :title="outra.outros_proc_lista">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                        {{ outra.outros_proc }}
                                    </span>
                                </div>
                                <div class="text-muted">
                                    {{ outra.dt_inicio.substr(11, 5) }} 
                                    <i class="fa fa-caret-right mx-2"></i>
                                    {{ outra.medico.search }}
                                </div>
                            </li>
                        </ul>
                    </div> 
                    <!-- Fim outros procedimentos agendados na remarcação -->

                </procedimentos-solicitados>
            </div>

            <div :class="sticky ? 'sticky-info-right bg-white w3-animate-right' : ''" :style="sticky ? 'width: 350px;' : ''">

                <div class="card" style="padding: 0px;" v-if="$store.state.unidade.unidade_operacaos.length > 1 && unidades.length == 1">
                    <div class="card-header d-flex justify-content-between">
                        {{ unidades[0].search }}
                    </div>
                </div>

                <div class="card" style="padding: 0px;" v-if="unidades.length > 1">
                    <div class="card-header d-flex justify-content-between">
                        <a class="card-link" href="#" @click.prevent="filtro_collapse('col_unidades')">
                            UNIDADES
                        </a>
                        <div>
                            <span class="badge badge-secondary">
                                {{ unidadesSelecionadas.filter (item => item).length }} / {{ unidades.length }}
                            </span>
                        </div>
                    </div>
                    <div class="card-body collapse" id="col_unidades">

                        <div class="row">

                            <div class="col col-12">

                                <div>
                                    <div class="custom-control custom-switch mb-2 mb-md-0">
                                        <input type="checkbox" class="custom-control-input" id="unidadeSwitchAll"
                                            v-model="unidadesTodas" @click="marcar_unidade_todas ()">
                                        <label class="custom-control-label" for="unidadeSwitchAll">Todas</label>
                                    </div>
                                    <div class="custom-control custom-switch mb-2 mb-md-0" v-for="(un, id) in unidades" :key="id">
                                        <input type="checkbox" class="custom-control-input" :id="'unidadeSwitch' + id"
                                            v-model="unidadesSelecionadas[id]" value="abc">
                                        <label class="custom-control-label" :for="'unidadeSwitch' + id">
                                            {{ un.search }}
                                        </label>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>

                <div class="card" style="padding: 0px;" v-if="medicos.length > 1">
                    <div class="card-header d-flex justify-content-between">
                        <a class="card-link" href="#" @click.prevent="filtro_collapse('col_medicos')">
                            PROFISSIONAIS
                        </a>
                        <div>
                            <span class="badge badge-secondary">
                                {{ medicosSelecionados.filter (item => item).length }} / {{ medicos.length }}
                            </span>
                        </div>
                    </div>
                    <div class="card-body collapse" id="col_medicos">

                        <div class="custom-control custom-switch mb-2 mb-md-0">
                            <input type="checkbox" class="custom-control-input" id="medicoSwitchAll"
                                v-model="medicosTodos" @click="marcar_medicos_todos ()">
                            <label class="custom-control-label" for="medicoSwitchAll">Todos</label>
                        </div>
                        <div class="custom-control custom-switch mb-2 mb-md-0" v-for="(md, id) in medicos" :key="id">
                            <input type="checkbox" class="custom-control-input" :id="'medicoSwitch' + id"
                                v-model="medicosSelecionados[id]" value="abc">
                            <label class="custom-control-label" :for="'medicoSwitch' + id">
                                <a href="#" @click.prevent="marcar_medicos_todos(id)" class="card-link" :class="md.tem_proc_selec ? 'font-weight-bold' : 'font-weight-light'"> 
                                    {{ md.st_nome_exibicao }}
                                </a>
                                <span class="badge badge-secondary ml-2" v-if="md.ocupados">
                                    {{ md.ocupados }}
                                </span>
                            </label>
                        </div>

                    </div>
                </div>

                <div class="card" style="padding: 0px;">
                    <div class="card-header">
                        <a class="card-link" href="#" @click.prevent="filtro_collapse('col_dia')">
                            DIAS / HORÁRIOS
                        </a>
                    </div>
                    <div class="card-body collapse" id="col_dia">

                        <div class="row">

                            <div class="col col-12 col-lg-4">

                                <div>
                                    <div class="custom-control custom-switch mb-2 mb-md-0">
                                        <input type="checkbox" class="custom-control-input" id="customSwitchAll"
                                            v-model="diasTodos" @click="marcar_dias_todos ()">
                                        <label class="custom-control-label" for="customSwitchAll">Todos</label>
                                    </div>
                                    <div class="custom-control custom-switch  mb-2 mb-md-0">
                                        <input type="checkbox" class="custom-control-input" id="customSwitch1"
                                            v-model="diasDaSemana[0]">
                                        <label class="custom-control-label" for="customSwitch1">Dom</label>
                                    </div>
                                    <div class="custom-control custom-switch mb-2 mb-md-0">
                                        <input type="checkbox" class="custom-control-input" id="customSwitch2"
                                            v-model="diasDaSemana[1]">
                                        <label class="custom-control-label" for="customSwitch2">Seg</label>
                                    </div>
                                    <div class="custom-control custom-switch mb-2 mb-md-0">
                                        <input type="checkbox" class="custom-control-input" id="customSwitch3"
                                            v-model="diasDaSemana[2]">
                                        <label class="custom-control-label" for="customSwitch3">Ter</label>
                                    </div>
                                    <div class="custom-control custom-switch mb-2 mb-md-0">
                                        <input type="checkbox" class="custom-control-input" id="customSwitch4"
                                            v-model="diasDaSemana[3]">
                                        <label class="custom-control-label" for="customSwitch4">Qua</label>
                                    </div>
                                    <div class="custom-control custom-switch mb-2 mb-md-0">
                                        <input type="checkbox" class="custom-control-input" id="customSwitch5"
                                            v-model="diasDaSemana[4]">
                                        <label class="custom-control-label" for="customSwitch5">Qui</label>
                                    </div>
                                    <div class="custom-control custom-switch mb-2 mb-md-0">
                                        <input type="checkbox" class="custom-control-input" id="customSwitch6"
                                            v-model="diasDaSemana[5]">
                                        <label class="custom-control-label" for="customSwitch6">Sex</label>
                                    </div>
                                    <div class="custom-control custom-switch mb-2 mb-md-0">
                                        <input type="checkbox" class="custom-control-input" id="customSwitch7"
                                            v-model="diasDaSemana[6]">
                                        <label class="custom-control-label" for="customSwitch7">Sab</label>
                                    </div>
                                </div>

                            </div>

                            <div class="col col-12 col-lg-8">

                                <div>
                                    <label for="customRange1" class="d-flex justify-content-between">
                                        <span>Faixa Inicial de Horário</span>
                                        <span class="badge badge-secondary">{{ faixaInicio }}h</span>
                                    </label>
                                    <input type="range" class="custom-range" min="0" max="24" step="1" v-model="faixaInicio">
                                </div>

                                <div>
                                    <label for="customRange1" class="d-flex justify-content-between">
                                        <span>Faixa Final de Horário</span>
                                        <span class="badge badge-secondary align-items-center">{{ faixaFim }}h</span>
                                    </label>
                                    <input type="range" class="custom-range" min="0" max="24" step="1" v-model="faixaFim">
                                </div>

                                <div class="d-flex flex-column mt-3">
                                    <div class="btn-group" role="group" aria-label="Basic example">
                                        <button type="button" class="btn btn-secondary btn-sm"
                                            @click="faixaInicio = 8; faixaFim = 12;">Manhã</button>
                                        <button type="button" class="btn btn-secondary btn-sm"
                                            @click="faixaInicio = 14; faixaFim = 18;">Tarde</button>
                                        <button type="button" class="btn btn-secondary btn-sm"
                                            @click="faixaInicio = 0; faixaFim = 24;">Geral</button>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                <az-instrucoes
                    :id_unidade_operacao="id_unidade_operacao"
                    ref="instrucoes"
                    :dados="dados"
                    :cores="cores"
                    :procedimentos="procedimentos"
                    :historico="historicoMarcacoes"
                    :autorizacao="autorizacao"
                    :pacotes="pacienteProcStats ? pacienteProcStats.pacotes : []"
                    :sinalizadores="pacienteProcStats ? pacienteProcStats.sinalizadores : []"
                    contexto="C"
                    :orcamento="orcamento"
                    @selecionar="selecionar_regiao"
                    v-model="podeMarcar" />

            </div>

        </div>
    </div>

    <!-- Seleção de Horário Final (hora, minuto e médico) -->
    <div class="modal fade" id="minutoModal" tabindex="-1" role="dialog" aria-labelledby="minutoModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel" v-if="hora_selecionada">
                        {{ getHumanDate (hora_selecionada[0].data, 'dddd') }} |
                        {{ getFormatDate (hora_selecionada[0].data, 'dddd') }} |
                        {{ hora_selecionada[0].base }}h
                        <template v-if="dt_valid_termino_autorizacao">
                            <template v-if="dataTerminoAutorizacaoDiff(hora_selecionada[0].data, dt_valid_termino_autorizacao) < 0">
                                | Autorização {{getFormatDate (dt_valid_termino_autorizacao, 'DD/MM/YYYY')}}: <span class="badge badge-danger" >Vencida</span>
                            </template>
                            <template v-else-if="dataTerminoAutorizacaoDiff(hora_selecionada[0].data, dt_valid_termino_autorizacao) <= 3">
                                | Autorização {{getFormatDate (dt_valid_termino_autorizacao, 'DD/MM/YYYY')}}: <span class="badge badge-warning" >Próxima</span>
                            </template>
                        </template>

                        <div v-if="procedimentos && procedimentos[hora_selecionada[0].index]" class="small text-muted">
                            {{ procedimentos[hora_selecionada[0].index].procedimento.search }}
                        </div>

                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <template v-if="1 == 0">

                        <ul class="list-group" v-if="hora_selecionada">
                            <li class="list-group-item d-flex align-items-center" v-for="(item, index) in grupo_hora_selecione ()" :key="index">
                                <div class="mr-2">
                                    <label class="form form-control text-center" style="width: 100px">
                                        <i class="far fa-clock"></i>
                                        {{ index }}
                                    </label>
                                </div>
                                <div>
                                    <button type="button" class="btn mr-2 mb-2" :class="( medico.teto || medico.restricao ) ? 'btn-secondary' : 'btn-success'"
                                        v-for="(medico, im) in medicosParaMarcar(item)" :key="im"
                                        @click="selecionar_horario (medico, $store.state.unidade.unidade_operacaos.length > 1 ? medico.unidade_operacao.search : '')">
                                        {{ medico.medico.st_nome_exibicao }}
                                        <span v-if="$store.state.unidade.unidade_operacaos.length > 1">/ {{ medico.unidade_operacao.search }}</span>
                                        <span class="ml-2" v-if="medico.extra">(Extra)</span>
                                    </button>
                                </div>
                            </li>
                        </ul>

                    </template>

                    <template v-else>

                        <template>

                            <span v-if="procedimentos.filter(item => ( item.selected).length > 1 && marcacao_unico_profissional ) 
                                    || procedimentos.filter(item => item.selected && item.outros_procedimentos && item.outros_procedimentos.length).length">
                                <div class="btn-group mb-3">
                                    <button class="btn btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                        :class="slots > 1 ? 'btn-primary' : 'btn-secondary'">
                                        Ocupar
                                        <template v-if="slots">
                                            {{ slots ? slots : 1 }}
                                            {{ slots > 1 ? 'horários' : 'horário' }}
                                        </template>
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-scroll-sm" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="#" @click="slots = ''" :class="!slots ? 'active' : ''">
                                            Ocupação Padrão
                                        </a>
                                        <a class="dropdown-item" href="#" @click="slots = 1" :class="slots == 1 ? 'active' : ''">
                                            Ocupar 1 horário da agenda
                                        </a>
                                        <span v-if="false">
                                            ( procedimentos.filter(item => item.selected).length + 2 )
                                        </span>
                                        <a class="dropdown-item" href="#" v-for="idx in 17" :key="idx"
                                            @click="slots = idx + 1" :class="slots == idx + 1 ? 'active' : ''">
                                            Ocupar {{ idx + 1 }} horários da agenda
                                        </a>
                                    </div>
                                </div>
                            </span>

                            <div class="progress mt-0 mb-2">
                                <div class="indeterminate" v-if="$store.state.loading"></div>
                                <div class="determinate" v-else></div>
                            </div>

                            <div v-for="(horarios, id, idx) in grupo_medico_selecione()" :key="idx">
                                <div class="row">
                                    <template v-if="cc">
                                        <div class="col col-12 col-md-8">
                                            <div v-if="horarios[0] && horarios[0].unidade_operacao" class="text-muted">
                                                {{ horarios[0].unidade_operacao.search }}
                                            </div>
                                            <div>
                                                {{ id }}
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="col col-12 col-md-2 text-center">
                                            <avatar
                                                class="ml-3"
                                                :username="get_medico(id, 'st_nome_exibicao')"
                                                :src="get_medico(id, 'logo.arquivo.temporary_url')"
                                                :size="100"></avatar>
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <template v-if="get_medico(id, 'st_assinatura')">
                                                <span class="" v-html="$util.nl2br(get_medico(id, 'st_assinatura'))"></span>
                                            </template>
                                            <template v-else>
                                                <div>{{ get_medico(id, 'st_nome_exibicao') }}</div>
                                                <div>{{ get_medico(id, 'numero_formatado') }}</div>
                                            </template>

                                            <div v-if="get_medico(id, 'st_sub_especialidade')">
                                                <i class="fas fa-certificate mr-2"></i>
                                                {{ get_medico(id, 'st_sub_especialidade') }}
                                            </div>

                                            <div v-if="get_medico(id, 'medico_unidade.st_instrucao')">
                                                <blockquote class="blockquote mb-0">
                                                    <footer class="blockquote-footer text-nowrap text-truncate" :id="'instr-proc-sel-med-' + idx"
                                                        @mouseover="hover('instr-proc-sel-med-' + idx, true)"
                                                        @mouseleave="hover('instr-proc-sel-med-' + idx, false)">
                                                        {{ get_medico(id, 'medico_unidade.st_instrucao') }}
                                                    </footer>
                                                </blockquote>
                                            </div>
                                            <div v-if="get_ocupados(id, 'ocupados_por_data.' + hora_selecionada[0].data) > 0">
                                                <span class="badge badge-secondary" title="Marcados na data.">
                                                    D: {{ get_ocupados(id, 'ocupados_por_data.' + hora_selecionada[0].data) }}
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="col col-12 col-md-4">
                                        <!-- 'unidade_operacao.search' -->
                                        <div v-for="(horarios_por_unidade, horarios_unidade, ihux) in agrupar_func(horarios, agrupar_horarios_unidade)" :key="ihux">
                                            <div class="small" v-if="$store.state.unidade.unidade_operacaos.length > 1 && !cc">{{ horarios_unidade }}</div>
                                            <span class="mr-2 mb-2" v-for="(horario, ihx) in horarios_por_unidade" :key="ihx">
                                                <button type="button" class="btn btn-sm btn-success"
                                                    :disabled="$store.state.loading"
                                                    @click="selecionar_horario (horario, $store.state.unidade.unidade_operacaos.length > 1 ? horario.unidade_operacao.search : '')">
                                                    <i class="fa fa-ban mr-2" aria-hidden="true" v-if="horario.teto && !horario.teto_livre"></i>
                                                    <i class="fa fa-exclamation-circle mr-2" aria-hidden="true" v-else-if="horario.teto && horario.teto_livre"></i>
                                                    <i class="fas fa-satellite-dish mr-1" v-if="horario.tele"></i>
                                                    {{ horario.hg ? horario.hg : horario.hora }}
                                                    <span class="ml-2" v-if="horario.tipo_consulta == 'R'">
                                                        <i class="fa fa-registered" aria-hidden="true"></i>
                                                    </span>
                                                    <span class="ml-2" v-if="horario.paralela && !cc">
                                                        {{ horario.titulo }}
                                                    </span>
                                                    <span class="ml-2" v-if="horario.lims">
                                                        {{ horario.lims.qtd }}/{{ horario.lims.lim }}
                                                    </span>
                                                </button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                            </div>

                        </template>

                    </template>
                </div>
            </div>
        </div>
    </div>

    <!-- Confirmacão Final -->
    <div class="modal fade" id="cadastroModal" tabindex="-1" role="dialog" aria-labelledby="cadastroModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
            <div class="modal-content" v-if="procedimentos && procedimentos.length && dados">
                <div class="modal-body">

                    <h2 class="alert bg-dark text-white d-flex justify-content-between mb-3" v-if="dados && dados.lista_de_espera">
                        <span>Incluir na LISTA DE ESPERA</span>
                        <i class="fas fa-list-ol mr-2"></i>
                    </h2>

                    <procedimentos-solicitados
                        :value="procedimentos.filter(item => item.selected)"
                        :cores="cores"
                        :listOnly="true"
                        :ordem="true"
                        :resumo_marcacao="true"
                        @clonar="clonar" />

                    <!-- Infusão -->
                    <div v-if="dados.infusao">
                        <div class="card mt-2 mb-0">
                            <div class="card-header alert-info py-1 px-2">
                                {{ dados.infusao.st_titulo }}
                            </div>
                            <div class="card-body p-2">
                                <div class="form-row" v-if="dados.infusao.protocolo && dados.infusao.protocolo.receita && dados.infusao.protocolo.receita.in_ciclos">
                                    <div class="col col-12 col-md-2">
                                        <az-input sizing="sm" type="number" label="Quantidade de Ciclos" :edicao="false" v-model="dados.infusao.protocolo.receita.in_ciclos" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input sizing="sm" type="number" label="Duração do Ciclo" :edicao="false" v-model="dados.infusao.protocolo.receita.in_duracao">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">dia(s)</span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input sizing="sm" type="number" label="Intervalo entre os Ciclos" :edicao="false" v-model="dados.infusao.protocolo.receita.in_intervalo">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon2">dia(s)</span>
                                                </div>
                                            </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input sizing="sm" type="number" label="Duração da Sessão" :edicao="false" v-model="dados.infusao.protocolo.receita.in_tempo_sessao">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                            <span class="input-group-text" id="basic-addon2">min</span>
                                            </div>
                                        </template>
                                        </az-input>
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input sizing="sm" type="number" label="Ciclo" :edicao="false" v-model="dados.infusao.in_qt_ciclo" />
                                    </div>
                                    <div class="col col-12 col-md-2">
                                        <az-input sizing="sm" type="number" label="Dia" :edicao="false" v-model="dados.infusao.in_qt_dia" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <pre v-if="false">{{ dados.infusao }}</pre>
                    </div>
                    <!-- Fim Infusão -->

                    <pacotes-do-paciente
                        class="mt-3"
                        :pacotes="pacienteProcStats ? pacienteProcStats.pacotes : []"
                        :link="procedimentos.filter(item => item.selected).length == 1"
                        @selecionar="selecionar_regiao($event, true)"
                        v-if="pacienteProcStats && pacienteProcStats.pacotes && pacienteProcStats.pacotes.length" />

                    <div class="mt-3" v-if="!dados.paciente">
                        <cadastro-temporario 
                            :cpf_obrig="dados.plano && ( ( chapp_id_plano && dados.plano.id_plano == chapp_id_plano ) || ( chapp_id_operadora && dados.plano.id_operadora == chapp_id_operadora ) )"
                            :email_obrig="dados.plano && ( ( chapp_id_plano && dados.plano.id_plano == chapp_id_plano ) || ( chapp_id_operadora && dados.plano.id_operadora == chapp_id_operadora ) )"
                            v-model="cadastro_temporario" 
                            :validate="validarCadTemp" 
                            @selecionar="identificar_paciente" 
                            :coletar_matricula="dados.plano && dados.plano.id_operadora != 1"
                            :matricula_opcional="true" />
                    </div>

                    <div class="mt-3" v-else-if="dados.paciente && dados.paciente.id_pessoa > 0">
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input label="Nome do Paciente"
                                    type="text"
                                    :rules="['nome']"
                                    :validate="validarCadTemp"
                                    v-model="dados.paciente.st_nome"
                                    required />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input label="Nome Social"
                                    type="text"
                                    :rules="['nomenum']"
                                    :validate="validarCadTemp"
                                    v-model="dados.paciente.st_nome_social" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Sexo"
                                    type="sexo"
                                    required
                                    :validate="validarCadTemp"
                                    v-model="dados.paciente.cadastro.ch_sexo" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Data de Nascimento"
                                    type="date"
                                    required
                                    v-model="dados.paciente.cadastro.dt_nascimento"
                                    :validate="validarCadTemp"
                                    :rules="['nasc']">
                                    <template v-slot:buttonposb>
                                        <div class="input-group-append" v-if="idade">
                                            <span class="input-group-text" id="basic-addon2" title="Idade em anos">{{ idade }}a</span>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="e-mail"
                                    type="email"
                                    v-model="dados.paciente.cadastro.st_email"
                                    :required="dados.plano && ( ( chapp_id_plano && dados.plano.id_plano == chapp_id_plano ) || ( chapp_id_operadora && dados.plano.id_operadora == chapp_id_operadora ) )"
                                    :validate="validarCadTemp" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input label="Telefone"
                                    type="fone"
                                    :validate="validarCadTemp"
                                    v-model="dados.paciente.cadastro.telefones.telefone" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input label="Celular"
                                    type="fone"
                                    :validate="validarCadTemp"
                                    v-model="dados.paciente.cadastro.telefones.celular" />
                            </div>
                        </div>

                        <div class="form-row" v-if="dados.paciente.paciente_unidade">
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    sizing="sm" 
                                    label="No. da Carteira do Plano"
                                    :validate="validarCadTemp"
                                    v-model="dados.paciente.paciente_unidade.st_numero_carteira"  />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input 
                                    sizing="sm"
                                    label="Validade da Carteira"
                                    type="date"
                                    :validate="validarCadTemp"
                                    v-model="dados.paciente.paciente_unidade.dt_validade_carteira" />
                            </div>
                        </div>
                    </div>

                    <az-sub-title class="mt-1" title="Observação" />

                    <div class="form-row">
                        <div class="col col-12"
                            :class="$store.state.options && $store.state.options.marcacoesStats && $store.state.options.marcacoesStats.tele_atendimento ? 'col-md-6' : 'col-md-9'">
                            <az-input sizing="sm" type="text" v-model="st_observacoes" />
                        </div>

                        <div class="col col-12 col-md-3">
                            <az-input
                                sizing="sm"
                                type="select"
                                optionsMode="aql"
                                service="sinalizadores.index"
                                :optionsParm="{ ativos: true }"
                                v-model="sinalizador_atendimento">
                                <template v-slot:button-pre>
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">
                                            <i :class="sinalizador_atendimento 
                                                    ? ( sinalizador_atendimento.st_icon ? sinalizador_atendimento.st_icon : 'fas fa-flag' ) + ' fa-fw text-' + sinalizador_atendimento.st_cor 
                                                    : 'fa-fw fas fa-question text-muted'"
                                                aria-hidden="true"></i>
                                        </span>
                                    </div>
                                </template>
                            </az-input>
                        </div>

                        <div class="col col-12 col-md-3" v-if="$store.state.options && $store.state.options.marcacoesStats && $store.state.options.marcacoesStats.tele_atendimento">
                            <az-input sizing="sm" type="checkbox-group" label="Teleatendimento" v-model="fl_tele_atendimento" />
                        </div>
                    </div>

                    <div v-if="$store.state.user.marc_ms && procedimentos && procedimentos.find(item => item.procedimento && item.procedimento.id_classe_procedimento > 1)">
                        <medico-solicitante
                            ref="medico_solic"
                            v-model="dados"
                            :block_executante="true"
                            :alter_proc="false"
                            :validate="validarCadTemp" />
                    </div>

                    <div class="mt-3" v-if="procedimentos && procedimentos.filter(item => item.extra).length">
                        <div class="form-row" v-for="(proc_extra, iex) in procedimentos.filter(item => item.extra)" :key="iex">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    type="label"
                                    sizing="sm"
                                    :label="proc_extra.procedimento.search" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    type="time"
                                    sizing="sm"
                                    v-model="proc_extra.hora" />
                            </div>
                            <div class="col col-12 col-md-3 small text-muted">
                                Extra
                            </div>
                        </div>
                    </div>

                    <div v-if="dadosRemarcacao && procedimentos && procedimentos.length && procedimentos[0].repetir" class="mt-3 mb-1 d-flex flex-column">
                        <button type="button" class="btn btn-danger" @click="procedimentos[0].repetir = false">
                            Remarcar apenas essa ocorrência da repetição
                        </button>
                    </div>

                    <div v-if="!dadosRemarcacao && procedimentos && procedimentos.length && procedimentos[0].repetir" class="mt-3 mb-1">
                        <!-- && dados.paciente && dados.paciente.id_pessoa > 0 -->
                        <div class="form-row">
                            <div class="col col-12" :class="procedimentos[0].repetir_mais ? 'col-md-6' : ''">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Marcar outra recorrência ao concluir"
                                    v-model="procedimentos[0].repetir_mais" />
                            </div>

                            <div class="col col-12 col-md-6" v-if="procedimentos[0].repetir_mais">
                                <az-input
                                    sizing="sm"
                                    type="button-group"
                                    :optionsList="[
                                        { id: 'M', search: 'Mesmo Profissional' },
                                        { id: 'O', search: 'Outro Profissional' }
                                    ]"
                                    v-model="procedimentos[0].repetir_prof" />
                            </div>
                        </div>
                    </div>

                    <repetir-agenda
                        :id_medico="procedimentos[0].medico.id_pessoa"
                        :marcacao="procedimentos[0]"
                        v-if="!data && procedimentos.length && procedimentos[0].repetir"
                        v-model="procedimentos[0].repeticao" />

                    <!-- Endereço -->
                    <div v-if="dados && dados.paciente && procedimentos[0].regiao_cd && exibir_endereco" class="alert alert-secondary d-flex justify-content-between mt-3">
                        <div>
                            <i class="fa-solid fa-map-location-dot mr-2"></i>
                            {{ exibir_endereco }}
                        </div>
                        <div>
                            <a href="#" @click.prevent="copiar_texto(exibir_endereco, 'Endereço Copiado')" class="text-primary">
                                <i class="fas fa-copy"></i>
                            </a>
                        </div>
                    </div>

                    <!-- Campos Customizados -->
                    <div v-if="campos_customizados_base && campos_customizados_base.js_campos.length" class="row">
                        <div class="col col-12">
                            <az-sub-title :title="campos_customizados_base.st_titulo" />
                            <formulario
                                sizing="sm"
                                :gutters="true"
                                v-model="campos_customizados_base.js_campos"
                                :saved="saved"
                                :validate="validarCadTemp"
                                mode="fixed"
                                :config="true" />
                        </div>
                    </div>

                    <!-- Formulários de Pré-Atendimento -->
                    <div class="mt-3" v-if="pre_atendimentos && pre_atendimentos.length">
                        <pre-atendimento-edit 
                            v-model="pre_atendimentos" 
                            :validate="validarCadTemp" />
                    </div>

                    <!-- Outros Pacientes / Coleta Domiciliar -->

                    <div v-if="procedimentos[0].regiao_cd">
                        <outros-pacientes-coleta-dom ref="outros_cd" 
                            :plano="procedimentos[0].plano"
                            :id_unidade_operacao="procedimentos[0].unidade_operacao.id_unidade_operacao"
                            v-model="procedimentos[0]" />
                    </div>

                    <div v-else-if="procedimentos[0].procedimento.cfm">
                        <outros-pacientes-coleta-dom 
                            ref="outros_cd" 
                            :plano="procedimentos[0].plano"
                            :id_unidade_operacao="procedimentos[0].unidade_operacao.id_unidade_operacao"
                            :familia="true"
                            :complementos="procedimentos[0].procedimento.js_complementos"
                            v-model="procedimentos[0]" />
                    </div>

                    <template v-else>

                        <!-- Adição de Outros Procedimentos -->

                        <ul class="nav nav-tabs mt-3" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation" v-for="(marcado, index) in lista_selecionados" :key="index">
                                <a class="nav-link" :class="index ? '' : 'active'" :id="'proc-tab-' + index" data-toggle="tab" :href="'#proc-t-' + index" role="tab" aria-controls="home" aria-selected="true">
                                    <span :class="marcado.procedimento.st_sigla ? '' : 'small'">
                                        {{ marcado.procedimento.st_sigla ? marcado.procedimento.st_sigla : marcado.procedimento.search }}
                                    </span>
                                    <div class="small text-muted" v-if="marcado.data">
                                        {{ $util.getFormatDate(marcado.data) }}
                                        <span class="badge badge-secondary ml-1" v-if="marcado.outros_procedimentos && marcado.outros_procedimentos.length" title="Outros procedimentos.">
                                            {{ marcado.outros_procedimentos.length }}
                                        </span>
                                        <span class="badge badge-info ml-1" v-if="marcado.consumos && marcado.consumos.length" title="Outros mat/med/taxas.">
                                            {{ marcado.consumos.length }}
                                        </span>
                                    </div>
                                </a>
                            </li>
                        </ul>

                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade" :class="index ? '' : 'show active'" :id="'proc-t-' + index" role="tabpanel" aria-labelledby="home-tab" v-for="(marcado, index) in lista_selecionados" :key="index">
                                
                                <div class="mt-3 mb-5">

                                    <template v-if="marcado.outros_procedimentos">
                                        <div v-for="(proced, ipx) in marcado.outros_procedimentos" :key="ipx">
                                            <az-input
                                                sizing="sm"
                                                :edicao="false"
                                                v-model="proced.search">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="removerElemento(marcado.outros_procedimentos, ipx)">
                                                            <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append input-group-sm"  v-if="proced.duracao">
                                                        <span class="input-group-text small">
                                                            {{ proced.duracao }} min
                                                        </span>
                                                    </div>
                                                    <div class="input-group-append input-group-sm"  v-if="proced.js_complementos && proced.js_complementos.length">
                                                        <div class="input-group-append">
                                                            <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                {{ proced.st_regiao ? proced.st_regiao  : 'Região...' }}
                                                            </button>
                                                            <div class="dropdown-menu dropdown-menu-scroll" aria-labelledby="dropdownMenuButton">
                                                                <a class="dropdown-item" 
                                                                    href="#" v-for="(regiao, irx) in proced.js_complementos" 
                                                                    :key="irx"
                                                                    @click.prevent="regiao_add(proced, regiao)" :class="regiao_tem(proced, regiao) ? 'active' : ''">
                                                                    {{ regiao }}
                                                                </a>
                                                            </div>
                                                        </div>

                                                        <select class="form form-control" v-if="false" v-model="proced.st_regiao">
                                                            <option>Região...</option>
                                                            <option v-for="(comp, icx) in proced.js_complementos" :key="icx" :value="comp">{{ comp }}</option>
                                                        </select>
                                                    </div>
                                                    <div class="input-group-prepend" v-if="proced.in_quantidade > 1">
                                                        <span class="input-group-text">
                                                            x{{ proced.in_quantidade }}
                                                        </span>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>

                                    </template>
                                    <az-input
                                        placeholder="Adicionar procedimento..."
                                        sizing="sm"
                                        icon="fas fa-plus fa-fw"
                                        type="autocomplete"
                                        optionsMode="aql"
                                        service="procedimentos.index"
                                        :optionsParm="{
                                            agenda: true,
                                            agenda_add: true,
                                            ativos: true,
                                            id_medico: marcado.medico ? marcado.medico.id_pessoa : null,
                                            id_operadora: marcado.plano ? marcado.plano.id_operadora : null, 
                                            id_plano: marcado.plano ? marcado.plano.id_plano : null, 
                                            cc: cc ? 1 : 0, 
                                            infusao: infusao ? 1 : 0, 
                                        }"
                                        v-model="novoProcedimento"
                                        :procsigla="true"
                                        ref="info_procedimento2"
                                        @selecionado="incluirProcedimento(marcado)" />

                                    <template v-if="marcado.outros_procedimentos && marcado.outros_procedimentos.length > 0">
                                        <div class="d-flex justify-content-between">
                                            <div class="btn-group dropup mb-2">
                                                <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                    :class="marcado.slots > 1 ? 'btn-primary' : 'btn-secondary'">
                                                    Ocupar 
                                                    <template v-if="marcado.slots">
                                                        {{ marcado.slots ? marcado.slots : 1 }}
                                                        {{ marcado.slots > 1 ? 'horários' : 'horário' }} da agenda
                                                    </template>

                                                    <template v-if="marcado.slots && marcado.tam_slot">
                                                        | {{ marcado.tam_slot * ( marcado.slots ? marcado.slots : 1 )  }} min
                                                    </template>
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item" href="#" @click="marcado.slots = ''" :class="!marcado.slots ? 'active' : ''">
                                                        Ocupação Padrão
                                                    </a>
                                                    <a class="dropdown-item" href="#" @click="marcado.slots = 1" :class="marcado.slots == 1 ? 'active' : ''">
                                                        Ocupar 1 horário da agenda
                                                        <template v-if="marcado.tam_slot">
                                                            | {{ marcado.tam_slot }} min
                                                        </template>
                                                    </a>
                                                    <a class="dropdown-item" href="#" v-for="idx in 17" :key="idx"
                                                        @click="marcado.slots = idx + 1" :class="marcado.slots == idx + 1 ? 'active' : ''">
                                                        Ocupar {{ idx + 1 }} horários da agenda
                                                        <template v-if="marcado.tam_slot">
                                                            | {{ marcado.tam_slot * ( idx + 1 ) }} min
                                                        </template>
                                                    </a>
                                                </div>
                                            </div>
                                            <div>
                                                <span v-if="tempo_total(marcado)" class="small">
                                                    <template v-if="!marcado.tam_slot || ( marcado.slots == Math.ceil( tempo_total(marcado) / marcado.tam_slot ) )">
                                                        <span class="text-muted">
                                                            Tempo Total Previsto: {{ tempo_total(marcado) }} min
                                                        </span>
                                                    </template>
                                                    <template v-else>
                                                        <a href="#" class="card-link" @click.prevent="marcado.slots = Math.ceil( tempo_total(marcado) / marcado.tam_slot )">
                                                            Tempo Total Previsto: {{ tempo_total(marcado) }} min | {{ Math.ceil( tempo_total(marcado) / marcado.tam_slot ) }} horários
                                                        </a>
                                                    </template>
                                                </span>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-if="marcado.outros_itens && marcado.outros_itens.length">
                                        <ul class="list-group">
                                            <li class="list-group-item" v-for="(item, iix) in lista_outros_itens" :key="iix">
                                                <a href="#" @click.prevent="novoProcedimento = item; incluirProcedimento(marcado)">
                                                    <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                                    {{ item.search }}
                                                </a>
                                            </li>
                                        </ul>
                                    </template>

                                    <hr>

                                    <!-- Consumos -->

                                    <template v-if="marcado.consumos">
                                        <div class="form-row" v-for="(consumo, icx) in marcado.consumos" :key="icx">
                                            <div class="col col-12 col-md-9">
                                                <az-input
                                                    sizing="sm"
                                                    :edicao="false"
                                                    v-model="consumo.search">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend">
                                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="removerElemento(marcado.consumos, ipx)">
                                                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    label="Qtd"
                                                    :compact="true"
                                                    sizing="sm"
                                                    type="number"
                                                    :min=1
                                                    v-model="consumo.in_quantidade">
                                                </az-input>
                                            </div>
                                        </div>
                                    </template>

                                    <az-input
                                        class="mb-3"
                                        sizing="sm"
                                        icon="fas fa-cart-plus fa-fw"
                                        buttonToolTip="Incluir material, medicamento ou taxa..."
                                        type="autocomplete"
                                        optionsMode="aql"
                                        optionsName="consumo.index"
                                        service="consumo.index"
                                        :optionsParm="{ id_operadora: marcado.plano ? marcado.plano.id_operadora : 1 }"
                                        :optionsSync="true"
                                        placeholder="Incluir material, medicamento ou taxa..."
                                        v-model="novoComponente"
                                        @selecionado="incluirComponente (marcado)"  />

                                    <br><br><br><br><br>

                                </div>

                            </div>
                        </div>

                    </template>

                    <div class="mt-3 mb-5" v-if="false && lista_selecionados.length == 1">
                        <template v-if="lista_selecionados[0].outros_procedimentos">
                            <div v-for="(proced, ipx) in lista_selecionados[0].outros_procedimentos" :key="ipx">
                                <az-input
                                    sizing="sm"
                                    :edicao="false"
                                    v-model="proced.search">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="removerElemento(procedimentos[0].outros_procedimentos, ipx)">
                                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                    <template v-slot:buttonposb v-if="proced.js_complementos && proced.js_complementos.length">
                                        <div class="input-group-append input-group-sm">
                                            <select class="form form-control" v-model="proced.st_regiao">
                                                <option>Região...</option>
                                                <option v-for="(comp, icx) in proced.js_complementos" :key="icx" :value="comp">{{ comp }}</option>
                                            </select>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </template>
                        <az-input
                            placeholder="Adicionar procedimento..."
                            sizing="sm"
                            icon="fas fa-plus fa-fw"
                            type="autocomplete"
                            optionsMode="aql"
                            service="procedimentos.index"
                            :optionsParm="{
                                agenda: true,
                                agenda_add: true,
                                ativos: true,
                                id_medico: lista_selecionados[0].medico ? lista_selecionados[0].medico.id_pessoa : null,
                                id_operadora: lista_selecionados[0].plano ? lista_selecionados[0].plano.id_operadora : null, 
                                id_plano: lista_selecionados[0].plano ? lista_selecionados[0].plano.id_plano : null, 
                                cc: cc ? true : false, 
                                infusao: infusao ? true : false, 
                            }"
                            v-model="novoProcedimento"
                            ref="info_procedimento2"
                            @selecionado="incluirProcedimento()" />

                        <template v-if="lista_selecionados[0].outros_procedimentos && lista_selecionados[0].outros_procedimentos.length > 0">
                            <div class="btn-group dropup mb-2">
                                <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                    :class="lista_selecionados[0].slots > 1 ? 'btn-primary' : 'btn-secondary'">
                                    Ocupar {{ lista_selecionados[0].slots ? lista_selecionados[0].slots : 1 }}
                                    {{ lista_selecionados[0].slots > 1 ? 'horários' : 'horário' }} da agenda
                                </button>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <a class="dropdown-item" href="#" @click="lista_selecionados[0].slots = 1" :class="( lista_selecionados[0].slots ? lista_selecionados[0].slots : 1 ) == 1 ? 'active' : ''">
                                        Ocupar 1 horário da agenda
                                    </a>
                                    <a class="dropdown-item" href="#" v-for="idx in lista_selecionados[0].outros_procedimentos.length" :key="idx"
                                        @click="lista_selecionados[0].slots = idx + 1" :class="lista_selecionados[0].slots == idx + 1 ? 'active' : ''">
                                        Ocupar {{ idx + 1 }} horários da agenda
                                    </a>
                                </div>
                            </div>
                        </template>

                        <template v-if="lista_selecionados[0].outros_itens && lista_selecionados[0].outros_itens.length">
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(item, iix) in lista_outros_itens" :key="iix">
                                    <a href="#" @click.prevent="novoProcedimento = item; incluirProcedimento()">
                                        <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                        {{ item.search }}
                                    </a>
                                </li>
                            </ul>
                        </template>

                        <br><br><br><br><br>

                    </div>

                    <pre v-if="1 == 0">{{ procedimentos }}</pre>

                </div>

                <div class="modal-footer">
                    <!-- 
                        && ( procedimentos[0].procedimento.id_classe_procedimento == 17
                        || procedimentos[0].procedimento.id_classe_procedimento == 28 )
                    -->
                    <button type="button" class="btn btn-outline-secondary" @click="procedimentos[0].repetir = !procedimentos[0].repetir"
                        v-if="procedimentos.length == 1 && ( !dadosRemarcacao || !dadosRemarcacao.blockrepetir )">
                        Recorrência...
                    </button>
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" @click="manter_reserva()">Reservar</button>
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">Voltar</button>
                    <az-submit @click="marcar()">Confirmar</az-submit>
                </div>
            </div>
        </div>
    </div>

    <!-- Resumo da Marcação Realizada -->
    <div class="modal fade" id="resumoModal" tabindex="-1" role="dialog" aria-labelledby="resumoModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content" v-if="resumo">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel" v-if="hora_selecionada">
                        Resumo
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <ProcedimentosSolicitados
                        v-model="resumo.procedimentos"
                        :cores="cores">
                    </ProcedimentosSolicitados>

                    <div class="mt-3" v-if="resumo.cadastro_temporario">
                        <CadastroTemporario :edicao="false" v-model="resumo.cadastro_temporario"></CadastroTemporario>
                    </div>

                    <p class="alert alert-sucess">Marcação realizada!</p>

                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Pacientes... -->
    <lista-pacientes ref="listaPac" 
        :listaproc="listaproc" 
        :marcacoes="procedimentos" 
        :block_filtro_regiao="!filtro_por_regiao"
        :id_paciente="( dados && dados.paciente ) ? dados.paciente.id_pessoa : null"
        :procedimentos="procedimentos"
        :datas="datas"
        :cores="cores" 
        :cc="cc"
        :infusao="infusao"
        @selecionar="selecionar_horario_lista_detalhe">

        <!-- Lista de Procedimentos no detalhamento do dia -->
        <template v-slot:procedimentos>
            <procedimentos-solicitados
                v-model="procedimentos"
                :removeOnUnSelect="false"
                :link_edit="true"
                :sticky="false"
                @removido="refresh_instrucoes()" 
                @editar="editar_proc" 
                @selecionar="mudanca_selecao_proc"
                @sticky="toggle_sticky()"
                @marcar_medicos="filtrar_unico_medico(true)"
                @refresh_detalhes="refresh_detalhes()"
                :cores="cores"
                :detalhe_marcacao="true" >

                <div v-if="procedimentos 
                    && procedimentos.filter(item => item.selected).length > 1 
                    && tem_medico_unico"
                    class="alert alert-light" :class="sticky ? 'p-2 small' : ''">
                    <div class="custom-control custom-switch mb-2 mb-md-0">
                        <input type="checkbox" class="custom-control-input" id="marcacaoUnicaSwitch2"
                            v-model="marcacao_unico_profissional" @click="trocar_unico_prof()">
                        <label class="custom-control-label" for="marcacaoUnicaSwitch2">
                            Marcação única com o mesmo profissional
                        </label>
                    </div>
                </div>

                <div v-if="horarios_selecionados" class="d-flex flex-column mt-3 mx-2">
                    <button class="btn btn-dark" @click="exibir_confirmacao()">
                        <i class="far fa-calendar-check mr-2"></i>
                        Confirmar
                    </button>
                </div>
            </procedimentos-solicitados>
        </template>
        <!-- Fim lista de procedimentos -->
        
    </lista-pacientes>

    <!-- Modal A Partir de -->
    <div class="modal fade" id="aPartirDeModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">A partir de...</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <az-input
                        type="date"
                        v-model="a_partir_de" />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    <az-submit @click="buscarHorariosAPartirDe(a_partir_de)">Buscar</az-submit>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Médicos do Procedimento -->
    <div class="modal fade" id="medicosProcModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-scrollable" role="document">
            <div class="modal-content" v-if="proc_edit">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Profissionais
                        <span class="badge badge-secondary">
                            {{ medicosSelecionados.filter (item => item).length }} / {{ medicos.length }}
                        </span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-info mb-3" v-if="proc_edit">{{ proc_edit.procedimento.search }}</div>

                    <template v-if="proc_edit.hora">
                        Agendado para:
                        <div>
                            <i class="fa fa-calendar-plus-o fa-fw mr-2" aria-hidden="true"></i>
                            {{ $util.getFormatDate(proc_edit.data) }}
                        </div>
                        <div>
                            <i class="fas fa-clock fa-fw mr-2"></i>
                            {{ proc_edit.hora }}
                        </div>

                        <button type="button" class="btn btn-sm btn-outline-danger mt-3" @click="cancelar_selecao_horario(proc_edit)">
                            <i class="fa fa-times mr-2" aria-hidden="true"></i>
                            Cancelar Seleção
                        </button>
                    </template>

                    <template v-else>
                        <div class="custom-control custom-switch mb-2 mb-md-0">
                            <input type="checkbox" class="custom-control-input" id="medicoSwitchAll"
                                v-model="medicosTodos" @click="marcar_medicos_todos ()">
                            <label class="custom-control-label" for="medicoSwitchAll">Todos</label>
                        </div>
                        <div class="custom-control custom-switch mb-2 mb-md-0" v-for="(md, id) in medicos" :key="id">
                            <input type="checkbox" class="custom-control-input" :id="'medicoSwitch' + id"
                                v-model="medicosSelecionados[id]" value="abc">
                            <label class="custom-control-label" :class="md.tem_proc ? 'font-weight-bold' : 'font-weight-light text-muted'" :for="'medicoSwitch' + id">
                                <a href="#" @click.prevent="marcar_medicos_todos(id)" class="card-link">
                                    {{ md.st_nome_exibicao }}
                                </a>
                                <span class="badge badge-secondary ml-2" v-if="md.ocupados">
                                    {{ md.ocupados }}
                                </span>
                            </label>
                        </div>

                        <button type="button" class="btn btn-sm btn-outline-danger mt-3" @click="remover_da_lista(proc_edit)"
                            v-if="procedimentos && procedimentos.filter(proc => !proc.conjunto).length > 1">
                            <i class="fa fa-times mr-2" aria-hidden="true"></i>
                            Remover da Lista
                        </button>
                    </template>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                </div>
            </div>
        </div>
    </div>

    <confirmar-marcacao ref="confmarc"></confirmar-marcacao>

    <marcacao-vincular-autorizacao ref="vincularAutorizacao" @selecionar="marcar_revisao" />

    <manter-reserva ref="manter_reserva" />

    <template v-if="acao_anexar && marcacao_anexo">
      <az-file-upload
        ref="upload"
        :multiple="true"
        @refresh="carregar_arquivos()"
        :arquivos="marcacao_anexo.arquivos"
        :parms="{ 
          model_type: marcacao_anexo.id_marcacao 
            ? 'marcacao' : ( marcacao_anexo.id_cadastro_temporario ? 'cadastroTemporario' : 'pessoa' ), 
          model_id: marcacao_anexo.id_marcacao 
            ? marcacao_anexo.id_marcacao : ( marcacao_anexo.id_cadastro_temporario ? marcacao_anexo.id_cadastro_temporario : marcacao_anexo.id_pessoa ), 
          id_paciente: marcacao_anexo.id_paciente ? marcacao_anexo.id_paciente : marcacao_anexo.id_pessoa,
          tipo_especial: marcacao_anexo.id_marcacao ? null : 'anexo', 
        }" />
    </template>

</div>
</template>

<script>
import _ from 'lodash';
import * as moment from 'moment';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import CadastroTemporario from './CadastroTemporario.vue';
import AzInstrucoes from '../../util/AzInstrucoes.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import ProcedimentosSolicitados from './ProcedimentosSolicitados.vue';
import HistoricoMarcacoes from './HistoricoMarcacoes.vue';
import ListaPacientes from './ListaPacientes.vue';
import PacotesDoPaciente from '../../shared/PacotesDoPaciente.vue';
import AzLoading from '../../util/AzLoading.vue';
import { setInterval } from 'timers';
import RepetirAgenda from './RepetirAgenda.vue';
import Formulario from '../consultorio/Formulario.vue';
import ProcedimentosOrcados from './ProcedimentosOrcados.vue';
import VisitaMedico from './VisitaMedico.vue';
import PreAtendimentoEdit from '../recepcao/PreAtendimentoEdit.vue';
import MedicoSolicitante from '../../shared/MedicoSolicitante.vue';
import ConfirmarMarcacao from './ConfirmarMarcacao.vue';

import CelulaDadosPaciente from "../../shared/table/CelulaDadosPaciente.vue";

import AdicionarProcedimento from './AdicionarProcedimento.vue';
import SelecaoRecursos from '../../shared/SelecaoRecursos.vue';

import OutrosPacientesColetaDom from './OutrosPacientesColetaDom.vue';
import MarcacaoVincularAutorizacao from './MarcacaoVincularAutorizacao.vue';

import Documento from '../consultorio/Documento.vue';

import Avatar from 'vue-avatar'

import AzFileUpload from '../../util/AzFileUpload.vue';
import VueMarkdown from 'vue-markdown'
import ManterReserva from './ManterReserva.vue';

export default {
    data() {
        return {

            dados: {
                unidade_operacao: "",
                tipo_consulta: null,
                st_regiao: "", 
                regiao_cd: "", 
            },
            fluxo: null,
            procedimentos: [],
            cadastro_temporario: {
                st_nome: "",
                dt_nascimento: "",
                st_telefone: "",
                st_celular: "",
                st_cod_pais: "", 
            },
            buscando: false,
            horarios: null,
            teste: null,
            hora_selecionada: null,
            horario_selecionado: null,
            buscadoAte: null,

            st_observacoes: null,
            fl_tele_atendimento: false,
            sinalizador_atendimento: "",
            extra: false,
            ordem_chegada: false, 

            podeMarcar: true,

            historicoMarcacoes: null,
            historicoLegado: null,
            historicoAutorizacao: null,

            faixaInicio: 0,
            faixaFim: 24,
            diasDaSemana: [true, true, true, true, true, true, true],
            diasTodos: true,
            medicosSelecionados: [],
            medicosTodos: true,
            unidadesTodas: true,
            unidadesSelecionadas: [],

            pacienteProcStats: null,
            pacienteMedicoStats: null,
            listaMedicos: [],
            subespecialidades: null,

            faixaHorarios: {},
            espontaneaHora: null,

            tmaInicio: null,
            tmaFim: null,
            tmaInterval: null,

            resumo: null,

            cores: [ 'success', 'info', 'warning', 'secondary', 'danger', 'primary', 'verde-escuro', 'purple', 'orange', 'vermelho', 'rosa', 'teal' ],
            anime: true,

            validarCadTemp: false,
            aviso_final: null,
            msg_final: null,

            dadosRemarcacao: null,
            trocarmedico: false,
            espera: null,

            exibir_filtro: {
                unidade: false,
                medico: false,
                dia: false
            },

            campos_customizados_base: null,
            saved: true,
            slots: 1, 

            //

            canceltoken_paciente: null,
            buscando_paciente: null,
            buscando_procedimento: null,

            dt_prazo_revisao: null,
            medico_revisao: null,
            unidade_revisao: null, 
            revisao_filtro: true,
            revisao_filtro_unidade: true, 

            remarcar_filtro: true,
            remarcar_filtro_unidade: true, 

            lista_medicos_agenda: [],
            novoProcedimento: null,

            dt_valid_termino_autorizacao: null,
            marcacao_unico_profissional: false, 

            a_partir_de: null,
            hide_proc: false,
            sticky: false, 

            proc_edit: null, 
            outras_agendas: [], 

            ofertado: false, 
            info_oferta: false, 
            orc_convert_unidades: false, 

            adicao_procedimento_pos: false, 
            listaproc: true, 

            tempo_busca: 0, 
            datas: [], 

            marcacao_alterar_proc: null, 

            adicoes: [], 

            novoComponente: "", 
            confirm_docs: null, 

            selecao: { 
                dia: null, 
            }, 

            recursos: null, 
            regioes: null, 
            procedimento_recursos: null,  
            filtro_por_regiao: true, 

            block_sel_medico: false, 
            chapp_id_plano: null, 
            chapp_id_operadora: null, 

            lista_adicao: [], 

            //

            acao_anexar: false, 
            marcacao_anexo: null, 
            force_exibir_campos_customizados: false, 

        }
    },

    props: {
        data: {
            type: String,
            default: ""
        },
        hora: {
            type: String,
            default: ""
        },
        hg: {
            type: String,
            default: ""
        },
        modalName: {
            type: String,
            default: ""
        },
        tipoFluxo: {
            type: String,
            default: "marcacao",
        },
        remarcacao: {
            default: null,
        },
        adicao: {
            default: null,
        },
        id_paciente: {
            default: null,
        },
        marcar_paciente: {
            default: null,
        },
        id_unidade_operacao: {
            default: null,
        },
        id_recepcao: {
            default: null,
        },
        origem: {
            default: null,
        },
        autorizacao: {
            default: null,
        },
        orcamento: {
            default: null,
        },
        id_requisicao_procedimento: {
            default: null,
        },
        tem_atend_outro: {
            default: false,
        },
        retorno: {
            default: false,
        },
        cc: { 
            default: false, 
        },
        infusao: { 
            default: false, 
        },
        id_infusao: { 
            default: null, 
        },
        dados_infusao: { 
            default: null, 
        },
        adicao_outro: { 
            default: null, 
        },
        params: { 
            default: null, 
        }
    },

    components: {
        AzInput,
        AzInstrucoes,
        AzEmptyState,
        AzSubTitle,
        AzSubmit,
        CadastroTemporario,
        ProcedimentosSolicitados,
        HistoricoMarcacoes,
        ListaPacientes,
        PacotesDoPaciente,
        AzLoading,
        RepetirAgenda,
        CelulaDadosPaciente,
        Formulario,
        ProcedimentosOrcados,
        Avatar,
        AdicionarProcedimento,
        VisitaMedico,
        PreAtendimentoEdit, 
        MedicoSolicitante, 
        SelecaoRecursos, 
        ConfirmarMarcacao, 
        OutrosPacientesColetaDom, 
        MarcacaoVincularAutorizacao, 
        AzFileUpload, 
        VueMarkdown, 
        ManterReserva, 
        Documento, 
    },

    watch: {
        fluxo: function () {
            this.$emit('fluxo', this.fluxo);
        },

        diasDaSemana: function (newValue) {

            let teste = newValue.findIndex(i => {
                        return !i;
                    });

            this.diasTodos = !( teste >= 0);

        },

        unidadesSelecionadas: function (newValue) {

            let teste = newValue.findIndex(i => {
                        return !i;
                    });

            this.unidadesTodas = !( teste >= 0);

        },

        medicosSelecionados: function (newValue) {

            let teste = newValue.findIndex(i => {
                        return !i;
                    });

            this.medicosTodos = !( teste >= 0);

        }
    },

    computed: {
        tem_resumo_final: function () { 
            if ( this.resumo && this.resumo.resumofinal ) { 
                return true; 
            }

            return false;
        },

        lista_regioes: function () { 
            let id_uo = this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : this.id_unidade_operacao;

            if ( !id_uo || !this.regioes ) { 
                return [];
            }

            return this.regioes.filter(regiao => !regiao.lista_teste_unidades || regiao.lista_teste_unidades[id_uo]);
        },

        voltar_ao_concluir: function () { 
            return ( this.remarcacao || this.autorizacao || this.adicao || this.id_infusao );
        },

        informa_regiao: function () { 
            return this.fluxo 
                && !this.data 
                && this.$store.state.unidade.unidade_operacaos.length > 1 
                && this.dados 
                && this.dados.unidade_operacao 
                && this.dados.unidade_operacao.st_nome.indexOf('COLETA DOM') >= 0 
                && this.regioes 
                && this.regioes.length > 0;
        },

        block_medico: function () { 
            return ( ( !this.data || this.origem == 'confirm' ) && this.block_sel_medico ) ? true : false;
        },

        consultorio: function () { 
            return this.$route.name == 'corcamento';
        },

        idade: function () { 
            if ( !this.dados || !this.dados.paciente || !this.dados.paciente.cadastro || !this.dados.paciente.cadastro.dt_nascimento )
                return;

            let today = moment();
            let birthdateMoment = moment(this.dados.paciente.cadastro.dt_nascimento, 'YYYY-MM-DD');
            
            return today.diff(birthdateMoment, 'years');
        },
        
        exibir_endereco: function() { 

            if ( !this.dados || !this.dados.paciente || !this.dados.paciente.cadastro || !this.dados.paciente.cadastro.endereco ) { 
                return;
            }

            return this.dados.paciente.cadastro.endereco.st_logradouro
                + ( this.dados.paciente.cadastro.endereco.st_numero ? ', No. ' + this.dados.paciente.cadastro.endereco.st_numero : '' )
                + ( this.dados.paciente.cadastro.endereco.st_complemento ? ', ' + this.dados.paciente.cadastro.endereco.st_complemento : '' )
                + ( this.dados.paciente.cadastro.endereco.st_bairro ? ', ' + this.dados.paciente.cadastro.endereco.st_bairro : '' );

        },

        lista_sinalizadores: function () { 
            if ( !this.pacienteProcStats || !this.pacienteProcStats.sinalizadores || !this.dados || !this.dados.paciente )
                return [];

            return this.pacienteProcStats.sinalizadores.filter(item => item.id_pessoa == this.dados.paciente.id_pessoa
                && item.sinalizador_completo    
                && item.sinalizador_completo.st_acao_especial == 'bloquear-marcacao');
        },

        is_adicao_direta: function () { 
            return ( this.data && !this.espontaneaHora && !this.hora ) ? true : false;
        },

        pre_atendimentos: { 
            get () { 
                return _.uniqBy(
                    this.lista_selecionados.flatMap(item => _.map(item.doc_pre_atends, item => item)),
                    'id_modelo_prontuario'
                );
            },

            set () { 
                //
            },
        },

        lista_selecionados: function () {
            if ( !this.procedimentos )
                return [];

            return this.procedimentos.filter(item => item.selected);
        },

        lista_outros_itens: function () {
            if ( this.lista_selecionados.length != 1 || !this.lista_selecionados[0].outros_itens )
                return [];

            return this.lista_selecionados[0].outros_itens.filter(item => !this.lista_selecionados[0].outros_procedimentos ||
                !this.lista_selecionados[0].outros_procedimentos.find(op => op.id_procedimento == item.id_procedimento)
            );
        },

        lista_unidades: function () {
            // this.$store.state.unidade.unidade_operacaos
            return _.orderBy(
                this.$util.unidades_com_tags(false, true).filter(item => !item.fl_unidade_adm),
                'st_nome'
            );
        },

        id_unidade_operacao_selecionado: function () {
            return this.id_unidade_operacao
                ? this.id_unidade_operacao
                : ( this.dados && this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null );
        },

        tem_tele_atendimento: function () {
            return this.$store.state.options && this.$store.state.options.marcacoesStats && this.$store.state.options.marcacoesStats.tele_atendimento;
        },

        info_revisao_manual: function () {
            return this.$store.state.options && this.$store.state.options.marcacoesStats && this.$store.state.options.marcacoesStats.info_revisao;
        },

        horarios_selecionados: function () {
            return this.procedimentos.filter(item => item.selected && !item.conjunto)
                .findIndex(item => !item.hora) < 0
                && this.procedimentos.filter(item => item.hora).length;
        },

        tem_horario_selecionado: function () {
            return this.procedimentos.find(item => item.selected && item.hora);
        },

        tempo: function () {

            let now = moment(this.tmaFim, "HH:mm:ss");
            let end = moment(this.tmaInicio, "HH:mm:ss");
            let diff = now.diff(end);
            //var duration = moment.duration(now.diff(end)); // .humanize();

            let duration = moment.utc(diff).format("mm:ss");

            return duration;

        },

        medicos: function () {

            if ( !this.horarios )
                return [];

            let lista = _.uniqBy(
                _.map(
                    _.filter(this.horarios, item => item.medico),
                    item => item.medico
                ),
                (item) => {
                    return item.id_pessoa;
                }
            ).map(item => {
                let lista; 

                if ( this.procedimentos && this.procedimentos.length == 1 && this.procedimentos[0].procedimento.id_classe_procedimento == 1 ) { 

                    lista = _.filter(this.horarios, horario => horario.status == 'ocupado' 
                            && horario.medico 
                            && horario.medico.id_pessoa == item.id_pessoa
                            && horario.marcacao 
                            && horario.marcacao.id_procedimento == this.procedimentos[0].procedimento.id_procedimento 
                    );

                } else { 

                    lista = _.filter(this.horarios, horario => horario.status == 'ocupado' && horario.medico && horario.medico.id_pessoa == item.id_pessoa);

                }

                if ( lista ) { 
                    item.ocupados = lista.length;    
                    item.ocupados_por_data = _.mapValues(
                        _.groupBy(lista, item => item.data),
                        items => items.length
                    );
                }

                return item;
            });

            lista = _.orderBy(lista, 'st_nome_exibicao');

            return lista;

        },

        unidades: function () {

            if ( !this.horarios )
                return [];

            return _.uniqBy(
                _.map(this.horarios, function (item) {
                    return item.unidade_operacao ? item.unidade_operacao : { id_unidade_operacao: null };
                }),
                function (item) {
                    return item.id_unidade_operacao;
                }
            ).filter(item => item.id_unidade_operacao);

        },

        horarios_filtrados: function () { 

            if ( !this.horarios )
                return 'Sem horários...';
            
            // Médicos

            const todos_medicos_selecionados = ( this.medicosSelecionados.findIndex(item => !item) < 0 );
            let lista_medicos = {};

            if ( !todos_medicos_selecionados ) { 
                this.medicos.forEach((item, index) => { 
                    lista_medicos[item.id_pessoa] = index;
                });
            }

            // Unidades

            const todas_unidades_selecionadas = ( this.unidadesSelecionadas.findIndex(item => !item) < 0 );
            let lista_unidades = {};

            if ( !todas_unidades_selecionadas ) { 
                this.unidades.forEach((item, index) => { 
                    lista_unidades[item.id_unidade_operacao] = index;
                });
            }

            // Filtro

            let filtro_dia = _.filter(this.horarios, item => {
                return this.diasDaSemana[item.ds] &&
                    this.procedimentos[item.index] && 
                    this.procedimentos[item.index].selected &&
                    (
                        !this.revisao_filtro || !this.medico_revisao ||
                        item.medico.id_pessoa == this.medico_revisao.id_pessoa
                    ) &&
                    (
                        !this.revisao_filtro_unidade || !this.unidade_revisao ||
                        item.id_unidade_operacao == this.unidade_revisao.id_unidade_operacao
                    ) &&
                    (
                        !this.remarcacao || !this.remarcar_filtro || !this.dadosRemarcacao ||
                        item.medico.id_pessoa == this.dadosRemarcacao.id_medico
                    ) &&
                    (
                        !this.remarcacao || !this.remarcar_filtro_unidade || !this.dadosRemarcacao ||
                        item.id_unidade_operacao == this.dadosRemarcacao.id_unidade_operacao
                    ) &&
                    (
                        !this.medicosSelecionados.length ||
                        todos_medicos_selecionados || 
                        this.medicosSelecionados[lista_medicos[item.medico.id_pessoa]]
                    ) &&
                    (
                        !this.unidadesSelecionadas.length ||
                        todas_unidades_selecionadas || 
                        this.unidadesSelecionadas[lista_unidades[item.id_unidade_operacao]]
                    ) && 
                    ( item.hora && parseInt(item.hora.substr(0,2), 10) >= this.faixaInicio ) &&
                    ( item.hora && parseInt(item.hora.substr(0,2), 10) <= this.faixaFim ) &&
                    ( item.status == 'livre' || item.status == 'infusao' );
            });

            // Ordem

            filtro_dia = _.orderBy(filtro_dia, ['data', 'index', 'hora'], ['asc', 'asc', 'asc']);

            return filtro_dia;

        },

        exibicao: function () {

            if ( !this.horarios )
                return 'Sem horários...';
            
            let filtro_dia = this.horarios_filtrados;         

            // Agrupamento

            let dias = filtro_dia.reduce((result, item) => {

                // Get app object corresponding to current item from result (or insert if not present)
                var app = result[item.data] = result[item.data] || {};

                // Get type array corresponding to current item from app object (or insert if not present)
                var type = app[item.procedimento.st_procedimento + item.index] =
                    app[item.procedimento.st_procedimento + item.index] || [];

                // Add current item to current type array
                type.push(item);

                // Return the result object for this iteration
                return result;

                }, {});

            return dias;

        },

        procStats: function () {

            return this.pacienteProcStats && this.pacienteProcStats.procedimentos &&
                    this.pacienteProcStats.procedimentos.length ?
                    this.pacienteProcStats.procedimentos :
                    ( this.$store.state.options.marcacoesStats ?
                        this.$store.state.options.marcacoesStats.procedimentos : null );

        },

        tem_medico_unico: function () { 
            return ( 
                _.uniqBy(this.procedimentos.filter(proc => proc.selected), item => { 
                    return _.get(item, 'medico.id_pessoa') + '|' + _.get(item, 'plano.id_plano');
                })
                .length > 1 
            ) ? false : true;
        },

        unidade_operacao_selecionada: function() { 
            if ( !this.id_unidade_operacao )
                return;

            return this.$util.unidade_operacao(this.id_unidade_operacao);
        },
    },

    methods: {
        copiar_resumo () { 

            let texto = ""; 

            texto = 'Paciente: ' + ( this.resumo.paciente ? this.resumo.paciente.st_nome : ( this.resumo.cadastro_temporario ? this.resumo.cadastro_temporario.st_nome : '---' ) ) + '\n';

            if ( this.resumo.lista_resumo && this.resumo.lista_resumo.length ) { 

                this.resumo.lista_resumo.forEach(proced => {
                    texto += '----------------------------------\n';
                    texto += proced.procedimento.search 
                        + ' \n' + ( proced.medico ? proced.medico.st_nome_exibicao : '' ) 
                        + ' \n' + this.$util.getFormatDate(proced.dt_inicio) + ' ' + proced.dt_inicio.slice(11,16) + ' - ' + this.$util.getFormatDate(proced.dt_inicio, 'dddd')
                        + ' \n' + 'No.: M' + proced.id_marcacao 
                            + ' ' + ( proced.unidade_operacao && proced.unidade_operacao.st_sigla ? '(' + proced.unidade_operacao.st_sigla + ')' : '' ) 
                        + '\n';
                });

                if ( this.resumo.resumo_unidades && this.resumo.resumo_unidades.length ) { 
                    texto += '----------------------------------\n';
                    this.resumo.resumo_unidades.forEach(unidade => {
                        texto += unidade.st_nome + ( unidade.st_sigla ? ' (' + unidade.st_sigla + ')' : '' ) + '\n';
                        if ( unidade.endereco ) { 
                            texto += unidade.endereco.exibir + '\n';
                        }
                        if ( unidade.st_email ) { 
                            texto += 'e-mail: ' + unidade.st_email + '\n';
                        }
                        if ( unidade.telefone_unidade_operacaos && unidade.telefone_unidade_operacaos.length ) { 
                            texto += 'Telefones: ' + unidade.telefone_unidade_operacaos.map(tel => this.$util.formatMask(tel.telefone.st_numero, 'tel')).join(', ') + '\n';
                        }
                    });
                }   

            }

            this.copiar_texto (texto, 'Resumo da marcação copiado!'); 

                /*
                    <div v-if="resumo.resumo_unidades && resumo.resumo_unidades.length" class="text-left">
                        <div class="alert alert-light" v-for="(unidade, iux) in resumo.resumo_unidades" :key="iux">
                            <div>
                                <strong>{{ unidade.st_nome }}</strong>
                            </div>
                            <div v-if="unidade.endereco">
                                {{ unidade.endereco.exibir }}
                            </div>
                            <div v-if="unidade.st_email">
                                <strong>e-mail:</strong>
                                <span>
                                    {{ unidade.st_email }}
                                </span>
                            </div>
                            <div v-if="unidade.telefone_unidade_operacaos && unidade.telefone_unidade_operacaos.length">
                                <strong>Telefones:</strong>
                                <span v-for="(tel, itx) in unidade.telefone_unidade_operacaos" :key="itx" class="mr-4">
                                    {{ $util.formatMask(tel.telefone.st_numero, 'tel') }}
                                </span>
                            </div>
                        </div>
                    </div>
                */

            this.copiar_texto (texto, 'Resumo da marcação copiado!'); 


        },

        novoDocumento(marcacao) {
          this.$refs.documento.novoDocumento(marcacao);
        },

        cancelar_senha (marcacao) { 
            if ( !confirm('Confirma o cancelamento da senha?' ) ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'agendas', 
                func: 'destroy',
                no_validate: true, 
                dados: { 
                    id: marcacao.id_marcacao,
                    motivo: 'Cancelamento de senha',
                },
                callback: () => { 
                    this.$emit('refresh');
                    $('.modal').modal('hide');
                }
            });
        },

        tempo_total (item) { 
            let tempo = item.duracao ? item.duracao : 0; 

            if ( item.outros_procedimentos && item.outros_procedimentos.length ) { 
                tempo += item.outros_procedimentos.reduce((total, proc) => total + ( proc.duracao ? proc.duracao : 0 ), 0);
            }

            return tempo;
        },

        manter_reserva () { 
            this.$refs.manter_reserva.abrir(this.procedimentos, this.dados.paciente, this.reiniciar);
        },

        //

        abrir_anexar_arquivo(marcacao) { 
            console.log('anexar', marcacao);

            this.marcacao_anexo = marcacao;
            this.acao_anexar = true;

            // Ajuste para carregar os arquivos sempre que clicar no botão
            this.carregar_arquivos(true);
            return;

        },

        carregar_arquivos (abrir = false) {

            this.$store.commit('loading', true);

            if ( this.marcacao_anexo.id_marcacao ) {

                this.$util.loadItem(this, {
                    service: 'arquivos',
                    func: 'links',
                    parms: {
                        id: this.marcacao_anexo.id_marcacao,
                        type: 'marcacao',
                    }
                })
                .then(res => {
                    this.marcacao_anexo.arquivos = res;

                    if ( abrir ) {
                        this.$nextTick(() => {
                        this.$refs.upload.abrir();
                        });
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

            } else if ( this.marcacao.id_cadastro_temporario ) { 

                this.$util.loadItem(this, {
                    service: 'arquivos',
                    func: 'links',
                    parms: {
                        id: this.marcacao_anexo.id_cadastro_temporario,
                        type: 'cadastroTemporario',
                    }
                })
                .then(res => {
                    this.marcacao_anexo.arquivos = res;

                    if ( abrir ) {
                        this.$nextTick(() => {
                        this.$refs.upload.abrir();
                        });
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

            } else { 

                this.$util.loadItem(this, {
                    service: 'arquivos',
                    func: 'links',
                    parms: {
                        id: this.marcacao_anexo.id_pessoa,
                        type: 'pessoa',
                    }
                })
                .then(res => {
                    this.marcacao_anexo.arquivos = res;

                    if ( abrir ) {
                        this.$nextTick(() => {
                            this.$refs.upload.abrir();
                        });
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

            }

        },


        //

        selecionar_autorizacao_adicao_direta() { 
            console.log('aut_adicao_direta', this.dados);
            if ( this.$refs.instruc_conf ) { 
                this.$refs.vincularAutorizacao.abrir([this.dados], true);
            } else if ( this.$refs.instrucoes && this.$refs.instrucoes.checar_agenda_com_solic_aut() ) { 
                alert('Solicitação não identificada.');
            }
        },

        imprimir_resumo () { 
            const configPrint = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"
                ]
            };

            this.$htmlToPaper("resumo-final", configPrint, () => {
              console.log("imprimir resumo");
            });
        },

        avancar_aviso_final() { 

            this.aviso_final = null;
            $(".modal").modal('hide');

            this.$emit('refresh', this.resumo);

            if ( this.voltar_ao_concluir ) {
                this.$router.go(-1);
                return;
            }

        },

        verPerfil(paciente) { 
            $('.modal').modal('hide');
            this.$root.perfil(paciente);
        },

        extrair_endereco (cadastro) { 
            if ( cadastro && cadastro.endereco ) { 
                let endereco = cadastro.endereco.st_logradouro;

                if ( cadastro.endereco.st_numero ) { 
                    endereco += ', No. ' + cadastro.endereco.st_numero;
                }

                if ( cadastro.endereco.st_complemento ) { 
                    endereco += ', ' + cadastro.endereco.st_complemento;
                }

                if ( cadastro.endereco.st_bairro ) { 
                    endereco += ', ' + cadastro.endereco.st_bairro;
                }

                if ( cadastro.endereco.in_cep ) { 
                    endereco += ', CEP: ' + cadastro.endereco.in_cep;
                }

                return endereco; 
            }

            return; 
        },

        agrupar_horarios_unidade (item) { 
            let unidade = _.get(item, 'unidade_operacao.search');

            if ( item.coleta_dom ) { 
                return unidade + " - " + item.local_nome;
            } 

            return unidade;
        },

        is_coopeder() { 
            return (
                (this.$store.state.dominio == 'coopeder' || this.$store.state.dominio == 'teste') &&
                (this.$refs && this.$refs.info_paciente && this.$refs.info_paciente.search && this.$refs.info_paciente.search.length >= 4)
            );
        },
        
        migrar_paciente() {
            this.$util.atualizar(this, { 
                service: 'pacientes',
                func: 'coopeder_migrar_paciente',
                toast: false,
                dados: { 
                    search: this.$refs.info_paciente.search
                },
                callback: (res) => {
                    if(res && res.error) {
                        this.$toast.add({
                            severity: "error",
                            summary: "Erro",
                            detail: res.msg ? res.msg : 'Erro ao migrar paciente',
                            life: 5000
                        });
                    } else {
                        this.$toast.add({
                            severity: "success",
                            summary: "Sucesso",
                            detail: res.msg ? res.msg : 'Paciente migrado com sucesso',
                            life: 5000
                        });
                        
                        this.$refs.info_paciente.search = '';
                        this.$refs.info_paciente.search = res.cpf;
                        this.$refs.info_paciente.searchAutoComplete();
                    }
                }
            });

        },

        confirmar_marcacao (marcacao) { 
            this.$refs.confmarc.abrir(marcacao);
        },

        navegarDias (event) { 
            switch (event.srcKey) {
                case 'down':
                    if ( this.selecao.dia === null ) { 
                        this.selecao.dia = 0;
                    } else { 
                        this.selecao.dia ++; 
                    }        
                    break;

                case 'up':
                    if ( !this.selecao.dia ) { 
                        this.selecao.dia = null;
                    } else { 
                        this.selecao.dia --; 
                    }        
                    break;
            }
        },

        copiar_texto (texto, titulo = null) { 
          this.$util.copiar_clipboard(this, texto, titulo);
        },

        traduzir_tipo_consulta (tipo) { 
            switch (tipo) {
                case 'R': return 'Revisão';
                case 'I': return 'Inicial';
                case 'S': return 'Subsequente';
                case 'P': return 'Pré-Natal';
                default: return '-'; 
            }
        },

        clonar (proc) { 
            $('.modal').modal('hide');

            proc.repetir = false;
            proc.repeticao = null;

            let novo = _.cloneDeep(proc);
            novo.data = null;
            novo.hora = null;
            novo.hg = null;
            novo.vg = null; 
            novo.repetir = false;
            novo.repeticao = null;
            novo.index = this.procedimentos.length;

            let novos_horarios = _.cloneDeep(this.horarios.filter(item => item.index == proc.index));

            novos_horarios = novos_horarios.map(item => { 
                item.index = novo.index;
                return item;
            });

            this.horarios = this.horarios.concat(novos_horarios);

            this.procedimentos.forEach(item => { 
                item.selected = false;
            });

            this.procedimentos.push(novo);
        },

        selecionarAdicao (adicao) { 
            this.$util.load(this, { 
                service: 'procedimentos',
                func: 'show',
                parms: { 
                    id: adicao.id_procedimento,
                },
                loadTo: res => { 
                    this.dados.procedimento = res;
                    this.selecionarProcedimento(this.dados.procedimento);

                    this.$util.load(this, { 
                        service: 'medicos',
                        func: 'show',
                        parms: { 
                            id: adicao.id_medico,
                        },
                        loadTo: res => { 
                            this.dados.medico = res;
                            this.selecionarMedico (this.dados.medico);
                        }
                    })
                }
            });
        },

        // Métodos para seleção da Região
        regiao_tem (proc, texto) { 
            if ( !proc )
                return false;

            let items = proc.st_regiao ? proc.st_regiao.split(', ') : [];
            return items.find(item => item == texto) ? true : false; 
        },

        regiao_add (proc, texto) { 
            let items = proc.st_regiao ? proc.st_regiao.split(', ') : [];

            let index = items.findIndex(item => item == texto);

            if ( index >= 0 ) { 
                items.splice(index, 1);
            } else { 
                items.push(texto);
            }
                
            proc.st_regiao = items.join(', ');
        },

        selecionar_regiao (pacote, final = false) { 
            if ( final ) { 
                let proc = _.first(this.procedimentos.filter(item => item.selected));
                proc.st_regiao = pacote.st_regiao;

                return;
            }

            if ( !this.dados.procedimento ) { 

                let procedimento = _.cloneDeep(pacote.procedimento);
                
                this.selecionarProcedimento (procedimento);

                this.dados.st_regiao = pacote.st_regiao;

            } else if ( this.dados.procedimento.id_procedimento != pacote.procedimento.id_procedimento ) { 

                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: 'Seleção de Região: Procedimento diferente.',
                    life: 5000
                });     

            } else { 

                this.dados.st_regiao = pacote.st_regiao;

            }
        },
        //

        trocar_unico_prof() { 
            this.filtrar_unico_medico(null, !this.marcacao_unico_profissional);
        },

        refresh_detalhes (unico = null) { 
            if ( !($("#listaPacientesModal").data('bs.modal') || {})._isShown )
                return;

            this.$nextTick(() => { 
                this.listaPacientes(null, unico);
            });
        },

        remover_da_lista (proc) { 
            proc.selected = false;
            proc.conjunto = true;
            proc.conjunto_index = null;

            $('.modal').modal('hide');
        },

        selecionar_horario_lista_detalhe(item) { 

            if ( this.marcacao_unico_profissional || this.procedimentos.filter(item => item.selected).length == 1 ) { 

                let horarios = _.uniqBy(
                    _.filter(
                        this.horarios_filtrados, 
                        hor => hor.medico.id_pessoa == item.id_medico
                            && hor.data == item.data
                            && hor.hora == item.hora
                            && hor.id_agenda == item.id_agenda
                            && hor.status == 'livre'
                    ),
                    'hora'
                );

                if ( horarios.length ) { 
                    this.selecionar_horario(horarios[0]);
                } else { 
                    console.log('HF', this.horarios_filtrados);
                    console.log('Horários', horarios);
                    alert('Horários não identificados.');
                    // $(".modal").modal('hide');
                    // this.selecionar_hora(horarios);
                }

            } else { 

                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: 'Selecione o procedimento.',
                    life: 5000
                });     
                return;

            }

        },

        selecionar_horario_lista (item) { 
            $(".modal").modal('hide');

            if ( this.marcacao_unico_profissional || this.procedimentos.filter(item => item.selected).length == 1 ) { 

                let horarios = _.uniqBy(
                    _.filter(
                        this.horarios_filtrados, 
                        hor => hor.medico.id_pessoa == item.id_medico
                            && hor.data == item.data
                            && hor.base == item.base
                            && hor.id_agenda == item.id_agenda
                            && hor.status == 'livre'
                    ),
                    'hora'
                );

                this.selecionar_hora(horarios);

            } else { 

                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: 'Selecione o procedimento.',
                    life: 5000
                });     
                return;

            }
        },

        cancelar_selecao_horario (proc) { 
            proc.hora = null;
            proc.data = null;
            proc.medico = null;
            proc.id_unidade_operacao = null;
            proc.unidade = null;
            proc.outros_procedimentos = [];
            proc.selected = true;

            if ( proc.index || proc.index === 0 ) { 

                this.procedimentos.filter(item => item.conjunto_index == proc.index)
                    .forEach(item => { 
                        item.conjunto = false;
                        item.conjunto_index = null;
                        item.selected = true;
                    });

            }

            this.$forceUpdate();
            $('#medicosProcModal').modal('hide');
        },

        mudanca_selecao_proc () { 
            if ( this.marcacao_unico_profissional ) { 
                this.marcacao_unico_profissional = false;
            }

            this.medicosTodos = false;
            this.marcar_medicos_todos();

            this.$nextTick(() => { 
                this.verificar_medico_proc();
            });
        },

        toggle_sticky () { 
            this.sticky = !this.sticky;
            this.$util.setCookie('ccsticky', ( this.sticky ? 'S' : 'N' )); 
        },

        verificar_medico_proc () { 

            if ( this.horarios ) { 

                const proc_selecs = _.mapKeys(
                    this.procedimentos.filter(proc => proc.selected)
                        .map(proc => proc.procedimento.id_procedimento),
                    proc => proc
                );
                 
                _.forEach(this.medicos, (item) => {
                    item.tem_proc_selec = this.horarios.find(hor => proc_selecs[hor.procedimento.id_procedimento]  
                        && hor.medico.id_pessoa == item.id_pessoa) ? true : false;
                });

                this.$forceUpdate();

            } 

        },

        editar_proc (proc) { 
            //let edit_proc = _.cloneDeep(proc);
            //edit_proc.procedimento_equipamentos = [];
            proc.procedimento_equipamentos = null;

            console.log('editar_proc', proc);

            if ( this.horarios ) { 
                _.forEach(this.medicos, (item) => {
                    item.tem_proc = this.horarios.find(hor => hor.procedimento.id_procedimento == proc.procedimento.id_procedimento 
                        && hor.medico.id_pessoa == item.id_pessoa) ? true : false;
                });

                this.$forceUpdate();

                this.proc_edit = proc;

                $('#medicosProcModal').modal('show');
            } else { 
                this.dados = proc;
                this.$forceUpdate();
            }
        },

        orcamento_selecionado (dados) { 
            this.dados.plano = dados.plano;

            if ( dados.unidade_operacao ) { 
                this.dados.unidade_operacao = this.lista_unidades.find(und => und.id_unidade_operacao == dados.unidade_operacao.id_unidade_operacao);
            } else { 
                this.dados.unidade_operacao = "";
            }

            if ( dados.procedimentos ) { 
                this.procedimentos = dados.procedimentos;
            }
        },

        buscarHorariosDe () { 
            this.a_partir_de = moment(this.buscadoAte).add(1, 'd').format('YYYY-MM-DD');
            $('#aPartirDeModal').modal('show');
        },

        buscarHorariosAPartirDe() { 
            if ( !this.a_partir_de ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Informe a data inicial.',
                    life: 5000
                });     
                return;
            } else if ( this.a_partir_de < this.buscadoAte ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'A data informada não poder ser inferior a ' + this.$util.getFormatDate(this.buscadoAte),
                    life: 5000
                });    
                return; 
            } else if ( this.a_partir_de < this.$util.hoje() ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'A data informada não poder ser inferior a hoje.',
                    life: 5000
                });    
                return; 
            }

            $('.modal').modal('hide');

            this.buscadoAte = moment(this.a_partir_de).add(-1, 'd').format('YYYY-MM-DD');
            this.buscarHorarios();
        },

        filtrar_unico_medico(filtrar = null, unico = null) { 
            if ( !this.horarios || !this.procedimentos )   
                return;

            if ( filtrar ) { 
                this.medicosTodos = false;
                this.marcar_medicos_todos();
            }

            if ( !this.marcacao_unico_profissional || filtrar ) { 

                let tmp = [];

                _.forEach(this.medicos, (item, index) => {

                    let procs = _.uniqBy(
                        _.filter(this.horarios_filtrados, hor => hor.medico.id_pessoa == item.id_pessoa),
                        'procedimento.id_procedimento'
                    );

                    tmp[index] = ( procs.length == this.procedimentos.filter(item => item.selected).length );
                });

                this.medicosSelecionados = tmp;

            } else { 

                this.medicosTodos = false;
                this.marcar_medicos_todos();

            }

            this.$nextTick(() => { 
                this.refresh_detalhes(unico);
            })
        },

        dataTerminoAutorizacaoDiff(dataMarcacao, dataAutorizacao) {
            let dataMarcacaoMoment = moment(dataMarcacao, 'YYYY-MM-DD HH:mm:ss');
            let dataAutorizacaoMoment = moment(dataAutorizacao, 'YYYY-MM-DD HH:mm:ss');

            return dataAutorizacaoMoment.diff(dataMarcacaoMoment, 'days');
        },

        incluirProcedimento(marcado = null) {
            if ( this.novoProcedimento && Array.isArray(this.novoProcedimento) ) {
                let lista = _.cloneDeep(this.novoProcedimento);

                lista.forEach(proc => { 
                    this.novoProcedimento = proc;
                    this.incluirProcedimento();
                });
                return;
            }

            if ( !marcado && this.procedimentos && this.procedimentos.length && this.lista_selecionados.length == 1 ) { 
                marcado = this.lista_selecionados[0];
            }

            if ( !marcado ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Procedimento não identificado.",
                    life: 3000
                });
                return;
            }

            if ( this.novoProcedimento && this.procedimentos && this.procedimentos.length && marcado) {
                if ( !marcado.outros_procedimentos )
                    marcado.outros_procedimentos = [];

                let item_novo = {
                    in_quantidade: 1,
                    id_procedimento: this.novoProcedimento.id_procedimento,
                    search: this.novoProcedimento.search, 
                    st_codigo_cbhpm: this.novoProcedimento.st_codigo_cbhpm, 
                    st_codigo_sus: this.novoProcedimento.st_codigo_sus, 
                    js_complementos: this.novoProcedimento.js_complementos,
                    st_regiao: "", 
                };

                if ( _.get(this.novoProcedimento, 'medico_procedimento_unidades.0.in_tempo_atendimento') ) { 
                    item_novo.duracao = _.get(this.novoProcedimento, 'medico_procedimento_unidades.0.in_tempo_atendimento');
                }

                marcado.outros_procedimentos.push(item_novo);

                // console.log('marcado', marcado);
            }

            this.$nextTick(() => {
                this.novoProcedimento = "";
            });
        },

        incluirComponente(marcado = null) {
            if ( !marcado && this.procedimentos && this.procedimentos.length && this.lista_selecionados.length == 1 ) { 
                marcado = this.lista_selecionados[0];
            }

            if ( !marcado ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Procedimento não identificado.",
                    life: 3000
                });
                return;
            }

            if ( this.novoComponente && this.procedimentos && this.procedimentos.length && marcado) {
                if ( !marcado.consumos ) { 
                    marcado.consumos = [];
                    this.$forceUpdate();
                }

                marcado.consumos.push({
                    in_quantidade: 1,
                    id_material: this.novoComponente.id_material,
                    id_medicamento: this.novoComponente.id_medicamento,
                    id_taxa: this.novoComponente.id_taxa,
                    search: this.novoComponente.search, 
                });
            }

            this.$nextTick(() => {
                this.novoComponente = "";
            });
        },

        hover(id, inIt) {
            if ( inIt ) {
                $('#' + id).removeClass('text-nowrap');
                $('#' + id).removeClass('text-truncate');
            } else {
                $('#' + id).addClass('text-nowrap');
                $('#' + id).addClass('text-truncate');
            }
        },

        agrupar_func(lista, func) {
            return _.groupBy(lista, item => func(item));
        },

        agrupar(lista, campo) {
            return _.groupBy(lista, item => _.get(item, campo));
        },

        get_medico(id, info = null) {
            let medico = this.lista_medicos_agenda.find(item => item.id_pessoa == id)
            return info ? _.get(medico, info) : medico;
        },

        get_ocupados(id, chave = 'ocupados') {
            let medico = this.medicos.find(item => item.id_pessoa == id)
            return _.get(medico, chave);
        },

        refresh_instrucoes () {
            if ( this.$refs.instruc_conf ) {
                if ( this.procedimentos.length )
                    this.$refs.instruc_conf.buscar_procedimento(this.dados);
                else
                    this.$refs.instruc_conf.reset();
            }

        },

        limite_revisao(data) {

            if ( this.dt_prazo_revisao && data <= this.dt_prazo_revisao ) {
                let datas = Object.keys(this.exibicao);
                return datas.find(item => item > data && item <= this.dt_prazo_revisao) ? false : true;
            }

            return false;

        },

        definir_tipo_consulta(tipo) {
            this.dados.tipo_consulta = tipo;
        },

        marcar_revisao (marcacao) {
            this.procedimentos = [];
            this.$refs.instruc_conf.reset();

            this.dados.id_solicitacao_autorizacao = marcacao.id_solicitacao_autorizacao;

            if ( !marcacao.manter_medico ) { 
                this.dados.procedimento = marcacao.procedimento;
                this.dados.medico = marcacao.medico;
            } else { 
                if ( this.$refs.instruc_conf ) { 
                    this.$refs.instruc_conf.buscar_procedimento(this.dados);
                }
            }

            if(marcacao.dt_valid_termino) {
                this.dt_valid_termino_autorizacao = marcacao.dt_valid_termino ;
            } else{
                this.dt_valid_termino_autorizacao = null;
            }

            if ( marcacao.js_secundarios && marcacao.js_secundarios.length ) {
                this.dados.outros_procedimentos = marcacao.js_secundarios.map((item) => { 
                    if ( item && item.st_procedimento && !item.search ) { 
                        item.search = item.st_procedimento;
                    }

                    return item;
                });
            }

            this.$nextTick(() => {
                this.refresh_instrucoes();
                this.buscarHorarios();
            });
        },

        atualizarHoraRepeticao() {
            if ( this.dados.repeticao )
                this.dados.repeticao.hora = this.espontaneaHora;
        },

        toggle_repeticao(dados) {
            dados.repetir = !dados.repetir;
            this.$forceUpdate();
        },

        local_dia(items) {
            const local = _.uniqBy(items.filter(item => item.status == 'livre'), 'local_nome');
            //return local;
            return local.length == 1 ? local[0].local_nome : '';
        },

        filtro_collapse(id) {
            $('#' + id).collapse('toggle');
        },

        medicosParaMarcar (lista) {
            return _.uniqBy(lista, item => item.medico.id_pessoa + '-' + item.id_unidade_operacao);
        },

        log (dado) {
            console.warn(dado);
        },

        identificar_paciente (id_paciente, existente = true) {

            this.$store.commit("loading", true);

            this.$util.loadItem(this, {
                service: "pacientes",
                func: "show",
                parms: {
                    id: id_paciente,
                }
            })
            .then(res => {
                this.dados.paciente = res;
                this.fluxo = 2;

                if ( this.data ) {
                    this.selecionarPaciente(existente);
                    if ( this.$refs.instruc_conf )
                        this.$refs.instruc_conf.$forceUpdate();
                }
            })
            .finally(() => {
                this.$store.commit("loading", false);
            });

        },

        selecionarPaciente (existente = false) {

            this.$nextTick(() => {

                if ( !this.dados.paciente ) {
                    this.dados.plano = null;
                    return;
                } 

                if ( this.buscando_paciente ) {
                    if ( this.buscando_paciente == this.dados.paciente.id_pessoa )
                        return;
                    else if ( this.canceltoken_paciente )
                        this.canceltoken_paciente.cancel('#BC#');
                }

                this.buscando_paciente = this.dados.paciente.id_pessoa;

                if ( !existente ) {
                    this.focusOn ('info_plano');

                    if ( !this.dados.plano ) { 

                        if ( _.get(this.dados, 'paciente.paciente_unidade.plano.id_operadora') == 1
                            && _.get(this.dados, 'paciente.paciente_unidade.plano.id_plano') == 1
                            && _.get(this.dados, 'paciente.st_id_externo') ) {

                            this.dados.plano = null;

                        } else if ( !_.get(this.dados, 'paciente.paciente_unidade.plano.fl_ativo') ) { 

                            this.dados.plano = null;

                        } else {

                            this.dados.plano = this.dados.paciente.paciente_unidade.plano;

                        }

                    }

                }

                let query = { q: [
                    {
                        name: 'marcacoes.stats',
                        id: 'stats_pac',
                        parms: {
                            id_paciente: this.dados.paciente.id_pessoa,
                            id_unidade_operacao: this.dados.unidade_operacao 
                                ? this.dados.unidade_operacao.id_unidade_operacao
                                : null, 
                        }
                    }
                ]};

                this.canceltoken_paciente = this.axios.CancelToken.source();

                if ( this.dados.paciente.id_pessoa < 0 ) {
                    
                    this.$util.loadItem(this, { 
                        service: 'cadastros_temporarios', 
                        func: 'show',
                        parms: {
                            id: this.dados.paciente.id_cadastro_temporario,
                        }
                    })
                    .then(res => { 
                        this.cadastro_temporario = res;
                    });
                    
                }

                this.axios.post('/aql?a=marcacoes.stats&p=' + this.dados.paciente.id_pessoa, query, {
                        cancelToken: this.canceltoken_paciente.token
                    })
                    .then(res => {
                        if ( res.data.stats_pac.status == 200 ) {
                            this.pacienteProcStats = res.data.stats_pac.data;
                            this.historicoMarcacoes = res.data.stats_pac.data.marcacoes;
                            this.historicoLegado = res.data.stats_pac.data.legado;
                            this.historicoAutorizacao = res.data.stats_pac.data.autorizacao;
                            this.dt_valid_termino_autorizacao = null;

                            if ( this.$refs.historico ) {
                                this.$nextTick(() => {
                                    this.$refs.historico.verificar_aba();
                                });
                            }
                        }
                    })
                    .finally(() => {
                        this.buscando_paciente = null;
                        this.canceltoken_paciente = null;
                    });

            });

        },

        tmaCount () {
            this.tmaFim = moment().format('HH:mm:ss');
        },

        startFluxo (fluxo) {

            this.tmaInicio = moment().format('HH:mm:ss');
            this.tmaFim = this.tmaInicio;
            this.fluxo = fluxo;
            this.dados.unidade_operacao = "";
            this.dados.regiao_cd = "";

            if ( this.lista_unidades && this.lista_unidades.length == 1 ) { 
                this.dados.unidade_operacao = this.lista_unidades[0];
            }

            if ( this.tmaInterval ) {
                clearInterval ( this.tmaInterval );
            }

            this.tmaInterval = setInterval(() => {
                this.tmaFim = moment().format('HH:mm:ss');
            }, 1000);

            if ( fluxo == 1 ) {

                if ( this.$store.state.user.id_plano ) { 

                    this.$util.loadItem(this, { 
                        service: 'planos',
                        func: 'show',
                        parms: { 
                            id: this.$store.state.user.id_plano,
                        }
                    })
                    .then(res => { 
                        this.selecionarPlano(res);
                    });

                    return;

                }

                this.$nextTick(() => {
                    this.focusOn('info_plano');
                });

            } else {

                this.$nextTick(() => {
                    this.focusOn('info_paciente');
                });

            }

        },

        selecionarPlano (plano) {

            if ( !plano ) {
                if ( this.$refs.instruc_conf ) {
                    this.$refs.instruc_conf.reset ();
                }
                return;
            }

            if ( plano.id_operadora > 1 && _.get(plano, 'operadora.status_operadora.ch_status') == 'S' ) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Operadora ' + plano.operadora.st_operadora + ' com atendimento suspenso.',
                    life: 5000
                });

                this.dados.plano = null;
                return;
            }

            this.dados.plano = plano;
            this.$forceUpdate();

            this.$nextTick(() => {
                this.focusOn('info_procedimento');
            });

            if ( this.$refs.instruc_conf )
                this.$refs.instruc_conf.buscar_plano(this.dados);

            if ( this.orcamento ) {

                this.$refs.orcamento.recalcular();

            } else if ( this.data ) { 

                let recep = this.$util.recepcao();

                this.adicoes = recep ? recep.adicoes.filter(item => !item.st_tipo || item.st_tipo == 'A')
                    .filter(item => !item.fl_preferencial) : [];

            }

        },

        selecionarProcedimento (procedimento, add = false) {

            if ( Array.isArray(procedimento) ) { 
                this.lista_adicao = procedimento;

                let item = this.lista_adicao.shift();

                // procedimento.forEach(proc => { 
                    this.selecionarProcedimento(item, true);
                    this.adicionarProcedimento ();
                //});
                return;
            }

            this.dados.st_regiao = "";
            this.dados.tipo_consulta = null;
            this.dados.procedimento = procedimento;
            this.dados.procedimento_recursos = null;
            this.procedimento_recursos = null;
            this.listaMedicos = [];

            const adicao_direta = ( this.data && !this.espontaneaHora && !this.hora && this.origem != 'confirm' ) ? true : false;

            if ( this.data ) {
                this.dados.repetir = false;
                this.dados.repeticao = {
                    base: this.data,
                    hora: this.hora, 
                };
            }

            if ( add )
                return;

            this.$nextTick(() => {
                if ( this.block_medico ) { 
                    if ( this.$refs.btn_add ) { 
                        setTimeout(() => {
                            this.$refs.btn_add.focus();
                        }, 1);
                    }
                } else { 
                    this.focusOn('info_medico');
                }
            });

            if ( this.$refs.instruc_conf )
                this.$refs.instruc_conf.buscar_procedimento(this.dados);

            let query = { q: [] };

            if ( procedimento ) {

                if ( procedimento && procedimento.id_procedimento == this.buscando_procedimento ) {
                    return;
                }

                this.buscando_procedimento = procedimento.id_procedimento;

                query.q.push({
                        name: 'marcacoes.stats',
                        id: 'stats_proc',
                        parms: {
                            id_plano: this.dados.plano ? this.dados.plano.id_plano : null,
                            id_procedimento: procedimento.id_procedimento,
                            adicao_direta: adicao_direta,
                            id_unidade_operacao: this.dados.unidade_operacao 
                                    ? this.dados.unidade_operacao.id_unidade_operacao
                                    : this.id_unidade_operacao, 
                            id_regiao_cd: this.dados.regiao_cd ? this.dados.regiao_cd.id_regiao_cd : null,
                            cc: this.cc ? true : false, 
                            infusao: this.infusao ? true : false, 
                            orcamento: this.orcamento ? true : false, 
                            recursos: true, 
                        }
                    });

            }

            if ( this.dados.paciente ) {

                query.q.push({
                        name: 'marcacoes.stats',
                        id: 'stats_proc_pac',
                        parms: {
                            id_paciente: this.dados.paciente.id_pessoa,
                            id_procedimento: procedimento ? procedimento.id_procedimento : null,
                            id_unidade_operacao: this.dados.unidade_operacao 
                                    ? this.dados.unidade_operacao.id_unidade_operacao
                                    : null, 
                            cc: this.cc ? true : false, 
                            infusao: this.infusao ? true : false, 
                        }
                    });

            }

            if ( this.origem == 'confirm' ) { 

                query.q.push({
                        name: 'marcacoes.campos_customizados',
                        id: 'campos_custom',
                        parms: {},
                    });

                query.q.push({
                        name: 'agendas.get_doc_pre_atends',
                        id: 'docs',
                        parms: {
                            procedimento: procedimento,
                            id_unidade_operacao: this.id_unidade_operacao, 
                            plano: this.dados.plano,
                        },
                    });

            }

            if ( query.q.length ) {

                this.axios.post('/aql?a=marcacoes.stats&proc=1', query)
                    .then(res => {
                        if ( res.data.stats_proc && res.data.stats_proc.status == 200 ) {

                            this.listaMedicos = res.data.stats_proc.data.medicos;

                            if ( this.origem == 'confirm' ) { 

                                if ( this.listaMedicos && this.listaMedicos.length && this.dados && this.dados.medico && this.dados.medico.id_pessoa ) { 

                                    let teste = this.listaMedicos.find(med => med.id_pessoa == this.dados.medico.id_pessoa);

                                    if ( !teste ) { 
                                        this.dados.medico = null; 
                                    }

                                }

                            }

                            this.subespecialidades = res.data.stats_proc.data.classes;
                            this.procedimento_recursos = res.data.stats_proc.data.recursos;
                            // this.dados.procedimento.procedimento_equipamentos = res.data.stats_proc.data.recursos;
                            this.dados.procedimento_equipamentos = res.data.stats_proc.data.recursos;

                            let teste_valor = res.data.stats_proc.data.valor;
                            let bloq_valor = false;

                            if ( procedimento 
                                && this.dados.plano 
                                && this.dados.plano.id_operadora != 1 
                                && !_.get(this.dados.plano, 'operadora.fl_sus')
                                && teste_valor 
                                && !_.get(teste_valor, 'zerado')
                                && !_.get(teste_valor, 'valor.id_item_tabela') ) { 

                                this.$toast.add({
                                    severity: "error",
                                    summary: this.dados.plano.search,
                                    detail: "Procedimento não encontrado em tabela de preço: " + procedimento.search,
                                    life: 8000
                                });

                                bloq_valor = true;

                            }

                            if ( this.dados.procedimento && this.dados.procedimento.id_procedimento == procedimento.id_procedimento ) { 
                            
                                this.dados.procedimento.bloq_valor = bloq_valor;

                                if ( res.data.stats_proc.data.valor_taxa_coleta ) {
                                    this.dados.procedimento.valor_taxa_coleta = res.data.stats_proc.data.valor_taxa_coleta;
                                }

                            }
                            
                        }

                        if ( res.data.stats_proc_pac && res.data.stats_proc_pac.status == 200 ) {
                            this.pacienteMedicoStats = res.data.stats_proc_pac.data.medicos;
                        }

                        if ( res.data.docs && res.data.docs.status == 200 ) {
                            this.confirm_docs = res.data.docs.data.docs;
                        }

                        if ( res.data.campos_custom && res.data.campos_custom.status == 200 ) {
                            this.campos_customizados_base = res.data.campos_custom.data;

                            if ( this.campos_customizados_base
                                && this.campos_customizados_base.js_campos
                                && this.dadosRemarcacao 
                                && this.dadosRemarcacao.js_outros_campos ) { 

                                this.$utilform.preencher_campos(
                                    this.campos_customizados_base.js_campos, 
                                    this.dadosRemarcacao.js_outros_campos
                                );

                            }
                        }
                    })
                    .finally(() => {
                        this.buscando_procedimento = null;
                    });

            }

        },

        selecionarMedico (medico) {

            this.dados.medico = medico;

            this.$nextTick(() => {
                this.focusOn('adicionar');
            });

            if ( medico && this.data && !this.hora ) {

                if ( $('#campo-cadastro-temporario select').length ) {
                    $('#campo-cadastro-temporario select')[0].focus();
                }

                if ( this.$route.path == '/recepcao' && this.data == this.$util.hoje() ) { 
                    this.espontaneaHora = this.$util.agora().slice(0,5);    
                } else { 
                    this.espontaneaHora = "";    
                }

                this.buscando = true;

                let query = { q: [
                    {
                        name: 'medicos.horarios',
                        id: 'horarios',
                        parms: {
                            id_medico: medico.id_pessoa,
                            id_procedimento: this.dados.procedimento ? this.dados.procedimento.id_procedimento : -1,
                            id_operadora: this.dados.plano ? this.dados.plano.id_operadora : null,
                            id_plano: this.dados.plano ? this.dados.plano.id_plano : null,
                            data: this.data,
                            id_unidade_operacao: this.id_unidade_operacao,
                            origem: this.$route.path,
                        }
                    }
                ]};

                this.axios.post('/aql?a=medicos.horarios', query)
                    .then(res => {
                        if ( res.data.horarios.status == 200 ) {
                            this.faixaHorarios = res.data.horarios.data;

                            if ( this.faixaHorarios && this.faixaHorarios.abrir_campos_customizados ) { 
                                this.force_exibir_campos_customizados = true; 
                                this.campos_customizados_base = null; 

                                this.$nextTick(() => { 
                                    if ( this.faixaHorarios && this.faixaHorarios.campos_customizados ) { 
                                        this.campos_customizados_base = this.faixaHorarios.campos_customizados;
                                    }
                                });

                                
                            }
                        }
                    })
                    .finally(() => {
                        this.buscando = false;
                    });

            }

        },

        enterNoProcedimento () {

            if ( !this.dados.procedimento && this.procedimentos.length && !this.orcamento ) {
                this.buscarHorarios ();
            } else if ( this.dados.procedimento && this.dados.procedimento.id_especialidade == 2 && this.orcamento ) {
                this.adicionarProcedimento ();
            }

        },

        enterNoMedico () {

            if ( !this.dados.procedimento && this.procedimentos.length ) {
                this.buscarHorarios ();
            } else if ( this.dados.procedimento ) {
                this.adicionarProcedimento ();
            }

        },

        focusOn (item) {

            /*
            if ( item == 'info_medico' && !this.dados.procedimento && this.procedimentos.length ) {
                this.buscarHorarios ();
                return;
            }

            if ( item == 'adicionar' ) {
                if ( this.dados.procedimento ) {
                    this.adicionarProcedimento ()
                } else {
                    this.buscarHorarios ();
                }
                return;
            }
            */

            if ( this.$refs[item] && this.$refs[item].$refs && this.$refs[item].$refs.input ) {
                this.$refs[item].$refs.input.focus ();
            }

        },

        voltar (add = false) {

            if ( this.autorizacao ) { // this.remarcacao ||
                this.$router.go(-1);
                return;
            }

            if ( this.horario_selecionado ) {
                this.horario_selecionado = null;
            }

            if ( this.hora_selecionada ) {
                this.hora_selecionada = null;
            }

            if ( this.horarios ) {

                if ( !add ) { 

                    this.horarios = null;
                    this.buscadoAte = null;

                    let query = { q: [{ name: 'agendas.liberar_reservas', id: 'liberar' }]};
                    this.axios.post('/aql', query);

                    this.procedimentos.forEach(element => {
                        element.base = null;
                        element.data = null;
                        element.hora = null;
                        element.ordem_chegada = null;
                        element.extra = null;
                    });

                    this.adicao_procedimento_pos = false;

                } else { 

                    this.buscadoAte = moment().add(-1, 'd').format('YYYY-MM-DD');
                    this.adicao_procedimento_pos = true;

                }

                return;
            }

            this.reiniciar ();

        },

        grupo_hora_selecione () {

            return _.groupBy(this.hora_selecionada, 'hora');

        },

        grupo_medico_selecione () {

            return this.cc 
                ? _.groupBy(this.hora_selecionada, item => item.local_nome)
                : _.groupBy(this.hora_selecionada, item => item.medico.id_pessoa);

        },

        marcar_dias_todos () {

            if ( !this.diasTodos )
                this.diasDaSemana = [true, true, true, true, true, true, true];
            else
                this.diasDaSemana = [false, false, false, false, false, false, false];

        },

        marcar_medicos_todos (id = null) {

            let base = !this.medicosTodos;
            let tmp = [];

            if ( id === 0 || id ) { 
                base = false;
            }

            _.forEach(this.medicos, function (item, index) {
                tmp[index] = base;
            });

            if ( id === 0 || id ) { 
                tmp[id] = true;
            }

            this.medicosSelecionados = tmp;

            this.verificar_medico_proc();

        },

        marcar_unidade_todas () {

            let base = !this.unidadesTodas;
            let tmp = [];

            _.forEach(this.unidades, function (item, index) {
                tmp[index] = base;
            });

            this.unidadesSelecionadas = tmp;

        },

        hora_sem_teto(hora) {
            return hora.findIndex(item => !item.teto) >= 0;
        },

        selecionar_hora (hora) {

            if ( hora.length > 0 && hora[0].bloqueado ) {
                alert('Bloqueado!');
                return;
            }

            let id_procedimento = _.get(hora, '0.procedimento.id_procedimento');

            if ( id_procedimento ) { 
                let teste = this.$refs.instrucoes.pode_marcar_proc(id_procedimento);

                if ( teste && teste.pode === false ) { 
                    this.$toast.add({
                        severity: "warn",
                        summary: "Atenção",
                        detail: 'Restrição para marcação desse procedimento: ' + _.get(hora, '0.procedimento.st_procedimento')
                            + ' - ' + teste.msg,
                        life: 5000
                    });
                    return;
                }
            }

            console.log('hora_selec', hora);
            
            this.slots = ""; 

            if ( this.procedimentos ) { 
                let proc = this.procedimentos[_.get(hora, '0.index')];
                
                if ( _.get(proc, 'qt_pac') > 0 ) { 
                    this.slots = parseInt(_.get(proc, 'qt_pac')) + 1;    
                }
            }

            if ( _.get(hora, '0.ordem_chegada') && _.get(hora, '0.slots') > 1 ) { 
                this.slots = _.get(hora, '0.slots');
            }

            this.hora_selecionada = hora;
            
            $('[data-toggle="tooltip"]').tooltip('hide');
            $('#minutoModal').modal('show');

        },

        selecionar_horario (horario, unidade = null) {

            if ( horario.teto ) {

                if ( horario.teto_livre ) {
                    if ( !confirm('Confirma agendamento? \n' + horario.teto) )
                        return;
                } else {
                    this.$toast.add({
                        severity: "warn",
                        summary: "Atenção",
                        detail: horario.teto,
                        life: 5000
                    });
                    return;
                }

            }

            if ( horario.restricao ) {

                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: horario.restricao.msg,
                    life: 5000
                });

                return;
            }

            if ( horario.ordem_chegada && horario.vagas && this.slots > 1 ) { 

                if ( horario.vagas - horario.marcados - this.slots < 0 ) { 
                    this.$toast.add({
                        severity: "warn",
                        summary: "Atenção",
                        detail: "Vagas não disponíveis. \n"
                            + "Vagas: " + horario.vagas + " \n"
                            + "Ocupadas: " + horario.marcados + " \n"
                            + "Selecionadas: " + this.slots + " \n",
                        life: 5000
                    }); 
                    return;
                }

            }

            console.log('hor', horario);

            if ( this.procedimentos[horario.index].procedimento.id_classe_procedimento == 1 ) { 
                const teste = this.procedimentos.find((item, idx) => { 
                    return idx != horario.index 
                        && item.procedimento 
                        && item.procedimento.id_classe_procedimento == 1  
                        && item.data == horario.data
                        && item.hora == horario.hora;
                });

                if ( teste ) { 

                    this.$toast.add({
                        severity: "warn",
                        summary: "Atenção",
                        detail: 'Procedimento ' + teste.procedimento.search 
                            + ' já agendado para esse horário: '
                            + this.$util.getFormatDate(horario.data) + ' ' + horario.hora,
                        life: 5000
                    });

                    return;

                }
            }

            this.horario_selecionado = horario;

            $('[data-toggle="tooltip"]').tooltip('hide');

            this.$store.commit("loading", true);

            // Marcação unificada... Outros procedimentos...

            if ( this.marcacao_unico_profissional ) { 
                
                this.procedimentos.forEach((item, idx) => { 

                    if ( !( item.selected && !item.hora ) ) { 
                        return; 
                    }

                    if ( idx === horario.index ) { 
                        return; 
                    }

                    item.selected = false;
                    item.conjunto = true;
                    item.conjunto_index = horario.index;

                    let novo = _.cloneDeep(item.procedimento);

                    if ( !this.procedimentos[horario.index].outros_procedimentos )
                        this.procedimentos[horario.index].outros_procedimentos = [];

                    let remarc = item.id_remarcacao ? { remarc: item.id_remarcacao } : {};

                    this.procedimentos[horario.index].outros_procedimentos.push({
                        in_quantidade: item.in_quantidade > 1 ? item.in_quantidade : 1,
                        id_procedimento: novo.id_procedimento,
                        search: novo.search,
                        js_complementos: novo.js_complementos, 
                        st_regiao: item.st_regiao, 
                        duracao: 0, 
                        ...remarc, 
                    });

                });

                this.$forceUpdate();

            }

            //

            let query = { q: [
                {
                    name: 'agendas.reservar',
                    id: 'reservar',
                    parms: {
                        data: horario.data,
                        hora: horario.hora,
                        hg: horario.hg, 
                        vg: horario.vg, 
                        medico: horario.medico,
                        ordem_chegada: horario.ordem_chegada ? true : false,
                        extra: horario.extra ? true : false,
                        paciente: this.dados.paciente,
                        plano: this.procedimentos[horario.index].plano,
                        procedimento: this.procedimentos[horario.index].procedimento,
                        ch_tipo_consulta: this.procedimentos[horario.index].tipo_consulta,
                        teste: this.procedimentos[horario.index],
                        remarcacao: this.procedimentos[horario.index].id_remarcacao 
                            ? this.procedimentos[horario.index].id_remarcacao 
                            : this.remarcacao,
                        id_unidade_operacao: horario.id_unidade_operacao,
                        id_agenda: horario.id_agenda,
                        slots: this.slots, 
                        outros_procedimentos: this.procedimentos[horario.index].outros_procedimentos,
                    }
                }
            ]};

            this.axios.post('/aql?a=agendas.reservar', query)
                .then(res => {
                    if ( res.data.reservar.status == 200 ) {

                        if ( res.data.reservar.data.duracoes && this.procedimentos[horario.index] && this.procedimentos[horario.index].outros_procedimentos ) { 
                            this.procedimentos[horario.index].outros_procedimentos.forEach(item => { 
                                let duracao = _.get(res.data.reservar.data.duracoes, item.id_procedimento);
                                if ( duracao ) { 
                                    item.duracao = duracao;
                                }
                            });
                        }

                        if ( res.data.reservar.data.slots ) { 
                            this.slots = res.data.reservar.data.slots;
                        }

                        if ( !this.cc ) { 
                            this.procedimentos[horario.index].medico = horario.medico;
                            this.procedimentos[horario.index].medico.instrucao = res.data.reservar.data.st_instrucao;
                        }

                        if ( this.dadosRemarcacao
                            && this.dadosRemarcacao.doc_pre_atends
                            && this.dadosRemarcacao.doc_pre_atends.length
                            && res.data.reservar.data.doc_pre_atends 
                            && res.data.reservar.data.doc_pre_atends.length ) { 

                            this.dadosRemarcacao.doc_pre_atends.forEach(item => {
                                if ( item.js_conteudo ) { 
                                    let valores = this.$utilform.obter_campos(item.js_conteudo);

                                    res.data.reservar.data.doc_pre_atends.forEach(dpa => { 
                                        if ( dpa.doc_pre_atend && dpa.doc_pre_atend.js_conteudo ) { 
                                            this.$utilform.preencher_campos(dpa.doc_pre_atend.js_conteudo, valores);
                                        }
                                    });
                                }
                            });
                            
                        }

                        this.procedimentos[horario.index].index = horario.index;
                        this.procedimentos[horario.index].base = horario.base;
                        this.procedimentos[horario.index].data = horario.data;
                        this.procedimentos[horario.index].hora = horario.hora;
                        this.procedimentos[horario.index].hg = horario.hg;
                        this.procedimentos[horario.index].vg = horario.vg;
                        this.procedimentos[horario.index].ordem_chegada = horario.ordem_chegada ? true : false;
                        this.procedimentos[horario.index].extra = horario.extra ? true : false;
                        this.procedimentos[horario.index].id_unidade_operacao = horario.id_unidade_operacao;
                        this.procedimentos[horario.index].unidade = unidade;
                        this.procedimentos[horario.index].repetir = false;
                        this.procedimentos[horario.index].repetir_mais = false;
                        this.procedimentos[horario.index].repetir_prof = 'M';
                        this.procedimentos[horario.index].repeticao = { base: horario.data, hora: horario.hora };
                        this.procedimentos[horario.index].local_nome = horario.local_nome;
                        this.procedimentos[horario.index].id_local = horario.id_local;
                        this.procedimentos[horario.index].id_agenda = horario.id_agenda;
                        this.procedimentos[horario.index].proc_instrucao = res.data.reservar.data.proc_instrucao;
                        this.procedimentos[horario.index].doc_pre_atends = res.data.reservar.data.doc_pre_atends;
                        this.procedimentos[horario.index].tele = horario.tele;
                        this.procedimentos[horario.index].slots = this.slots; //  ? this.slots : 1;
                        this.procedimentos[horario.index].duracao = res.data.reservar.data.duracao;
                        this.procedimentos[horario.index].tam_slot = horario.tam_slot; 

                        if ( horario.ordem_chegada && horario.vagas ) { 
                            this.procedimentos[horario.index].vagas = horario.vagas;
                            this.procedimentos[horario.index].marcados = horario.marcados;
                        }

                        if ( horario.coleta_dom ) { 
                            if ( !this.dados.endereco ) {
                                this.dados.endereco = { cidade: {} };
                            }

                            this.dados.coleta_dom = true;
                        }

                        // @@@@

                        if ( this.dadosRemarcacao && this.dadosRemarcacao.repeticao ) {

                            this.procedimentos[horario.index].repetir = true;

                            this.dadosRemarcacao.repeticao.base = horario.data;
                            this.dadosRemarcacao.repeticao.hora = horario.hora;

                            this.procedimentos[horario.index].repeticao = _.cloneDeep(this.dadosRemarcacao.repeticao);

                        }

                        /*
                        if ( this.dadosRemarcacao 
                            && this.dt_prazo_revisao 
                            && this.procedimentos[horario.index].tipo_consulta == 'R'
                            && horario.data > this.dt_prazo_revisao ) {

                            this.procedimentos[horario.index].tipo_consulta == 'S';

                        }
                        */

                        if ( res.data.reservar.data.outros_itens ) {
                            if ( this.remarcacao ) {
                                if ( this.procedimentos[horario.index].desagrupar ) { 
                                    //
                                } else { 
                                    this.procedimentos[horario.index].outros_procedimentos = res.data.reservar.data.outros_itens;
                                }
                            } else {
                                this.procedimentos[horario.index].outros_itens = res.data.reservar.data.outros_itens;
                            }
                        }

                        if ( res.data.reservar.data.consumos_itens ) {
                            if ( this.remarcacao ) {
                                if ( this.procedimentos[horario.index].desagrupar ) { 
                                    //
                                } else { 
                                    this.procedimentos[horario.index].consumos = res.data.reservar.data.consumos_itens;
                                }
                            } else {
                                this.procedimentos[horario.index].consumos = res.data.reservar.data.consumos_itens;
                            }
                        }

                        this.$nextTick(() => { 
                            this.$forceUpdate ();
                        });
                        
                        $('#minutoModal').modal('hide');

                        if ( this.marcacao_unico_profissional ) { 
                            // this.procedimentos[horario.index].index = horario.index;

                            this.procedimentos.filter(item => item.selected && !item.hora)
                                .forEach(item => { 
                                    item.selected = false;
                                    item.conjunto = true;
                                    item.conjunto_index = horario.index;

                                    let novo = _.cloneDeep(item.procedimento);

                                    if ( !this.procedimentos[horario.index].outros_procedimentos )
                                        this.procedimentos[horario.index].outros_procedimentos = [];

                                    let remarc = item.id_remarcacao ? { remarc: item.id_remarcacao } : {};

                                    let duracao_item = res.data.reservar.data.duracao; 

                                    if ( res.data.reservar.data.duracoes && this.procedimentos[horario.index] && this.procedimentos[horario.index].outros_procedimentos ) { 
                                        duracao_item = _.get(res.data.reservar.data.duracoes, item.id_procedimento, duracao_item);
                                    }

                                    this.procedimentos[horario.index].outros_procedimentos.push({
                                        in_quantidade: item.in_quantidade > 1 ? item.in_quantidade : 1,
                                        id_procedimento: novo.id_procedimento,
                                        search: novo.search,
                                        js_complementos: novo.js_complementos, 
                                        st_regiao: item.st_regiao, 
                                        duracao: duracao_item, 
                                        ...remarc, 
                                    });
                                });

                            this.$forceUpdate();
                        }

                        let falta = _.findIndex (this.procedimentos, item => ( !item.hora || ( item.hora && !item.selected ) ) && !item.conjunto);

                        if ( falta < 0 ) { // || this.marcacao_unico_profissional 
                            this.exibir_confirmacao();
                        }

                    }
                })
                .finally(() => {
                    this.$store.commit("loading", false);

                    this.$nextTick(() => { 
                        this.$refs.listaPac.force_refresh();
                    });
                });

        },

        exibir_confirmacao (lista_de_espera = false) {
            $('.modal').modal('hide');

            this.procedimentos.forEach(item => { 
                if ( !item.selected && !item.conjunto && item.data && item.hora ) { 
                    item.selected = true;
                }
            });

            if ( this.procedimentos.find(item => item.tele) ) { 
                this.fl_tele_atendimento = true;
            } else { 
                this.fl_tele_atendimento = false;
            }

            this.dados.lista_de_espera = lista_de_espera;

            $('#cadastroModal').modal('show');
            setTimeout(() => {
                let campo = $('#campo-cadastro-temporario select');
                if ( campo && campo.length )
                    $('#campo-cadastro-temporario select')[0].focus();
            }, 500);
        },

        adicao_direta () {

            // Validação da restrição
            //

            if ( this.dados.procedimento ) { 
                this.dados.procedimento.id_pacote = null;
            }

            this.adicionarProcedimento ();

            this.procedimentos[0].data = this.data;
            this.procedimentos[0].hora = this.hora ? this.hora : this.espontaneaHora;
            this.procedimentos[0].hg = this.hg ? this.hg : null;
            this.procedimentos[0].medico = this.dados.medico;
            this.procedimentos[0].adicao_direta = ( this.origem == 'confirm' || ( this.data && this.data > this.$util.hoje() ) ) ? false : true;
            this.procedimentos[0].ordem_chegada = this.ordem_chegada ? true : false;
            this.procedimentos[0].extra = this.extra ? true : false;
            this.procedimentos[0].id_unidade_operacao = this.id_unidade_operacao;

            if ( this.dados.id_local ) {
                this.procedimentos[0].id_local = this.dados.id_local;
            }

            if( this.dados.reservar ) { 
                this.manter_reserva(); 
            } else { 
                this.marcar ();
            }

        },

        grupo_hora (horarios) {

            let filtered = _.filter(horarios, (i) => {
                return i.hora && 
                        parseInt(i.hora.substr(0,2), 10) >= this.faixaInicio &&
                        parseInt(i.hora.substr(0,2), 10) <= this.faixaFim &&
                        i.status == 'livre';
            })

            let not_sorted = _.groupBy(filtered, function (i) {
                    return parseInt(i.base, 10);
                });

            let sorted = Object.keys(not_sorted)
                .sort()
                .reduce(function (acc, key) {
                    acc[key] = not_sorted[key];
                    return acc;
                }, {});

            return sorted;

        },

        lista_hora (hora) {

            if ( hora.length && ( hora[0].ordem_chegada || hora[0].extra ) ) {
                return 'Ocupação: ' + hora[0].marcados + ' / ' + hora[0].vagas;
            } else if ( hora.length && ( hora[0].bloqueado ) ) {
                return hora[0].tooltip;
            }

            return hora.reduce ((total, item) => {
                let base = item.hg ? item.hg : item.hora;
                
                return total.indexOf(base) >= 0 
                    ? total 
                    : total + base + '<br>';
            }, "");

        },

        check_marcado (hora) {
            return this.procedimentos[hora[0].index].base == hora[0].base &&
                    this.procedimentos[hora[0].index].data == hora[0].data;
        },

        grupo_hora_chaves (horarios) {

            let not_sorted = _.groupBy(horarios, function (i) {
                    return parseInt(i.base, 10);
                });

            let sorted = Object.keys(not_sorted)
                .sort()
                .reduce(function (acc, key) {
                    acc[key] = not_sorted[key];
                    return acc;
                }, {});

             return sorted;

        },

        reiniciar (dados = {}, marcacao_alterar_proc = null) {

            if ( this.consultorio && this.orcamento ) { 
                this.$router.go(-1);
                return;
            }

            console.log('reiniciar', dados);

            if ( this.id_infusao && ( !dados || !dados.repetir_mais ) ) {
                if ( this.aviso_final ) { 
                    clearTimeout(this.aviso_final);
                    this.aviso_final = null;
                }

                this.$router.go(-1);
                
                return;
            }

            if ( this.origem != 'confirm' && !dados.id_agenda ) { 
                
                if ( this.dados.id_local ) { 
                    dados.id_local = this.dados.id_local;
                }

                if ( this.dados.id_agenda ) { 
                    dados.id_agenda = this.dados.id_agenda;
                }

                if ( this.dados.extra === false || this.dados.extra === true ) { 
                    dados.extra = this.dados.extra;
                }

                if ( this.dados.ordem_chegada === false || this.dados.ordem_chegada === true ) { 
                    dados.ordem_chegada = this.dados.ordem_chegada;
                }

                if ( this.dados.coleta_dom ) { 
                    dados.coleta_dom = this.dados.coleta_dom;
                }

            }

            let uo_default = "";

            if ( this.orcamento ) { 
                let id_uo_ck = this.$util.getCookie('id_unidade_operacao');

                if ( id_uo_ck ) { 
                    uo_default = this.lista_unidades.find(und => und.id_unidade_operacao == id_uo_ck);
                }
            }

            if ( this.lista_unidades && this.lista_unidades.length == 1 ) { 
                uo_default = this.lista_unidades[0];
            }

            let repetir_mais = ( _.get(this.procedimentos, '0.repetir_mais') && dados.repetir_mais ) ? true : false;

            if ( repetir_mais ) { 
                if ( !this.dados.paciente ) { 
                    dados.paciente = null; 
                } else { 
                    dados.paciente = this.dados.paciente;
                }

                dados.plano = this.dados.plano;
                dados.procedimento = this.procedimentos[0].procedimento;

                if ( _.get(this.procedimentos, '0.repetir_prof') == 'M' ) { 
                    dados.medico = this.procedimentos[0].medico;
                }
            }

            this.procedimento_recursos = null; 
            this.confirm_docs = null;
            this.espera = null;
            this.fluxo = null;
            this.validarCadTemp = false;
            this.procedimentos = [];
            this.ofertado = false;
            this.adicao_procedimento_pos = false;
            this.marcacao_alterar_proc = marcacao_alterar_proc; 
            this.dados = {
                selected: false, 
                hora: "",
                procedimento: null,
                medico: null, 
                repetir: false,
                unidade_operacao: uo_default,
                tipo_consulta: null,
                repeticao: {
                    base: "",
                    hora: "",
                },
                st_regiao: "", 
                ...dados,
                medico_solicitante: {}, 
                procedimento_equipamentos: null, 
            };
            this.hora_selecionada = null;
            this.horarios = null;
            this.pacienteMedicoStats = null;
            this.pacienteProcStats = null;
            this.subespecialidades = null;
            this.historicoMarcacoes = null;
            this.historicoLegado = null;
            this.historicoAutorizacao = null;
            this.espontaneaHora = "";
            this.st_observacoes = "";
            this.sinalizador_atendimento = "";
            this.extra = dados.extra ? true : false;
            this.ordem_chegada = dados.ordem_chegada ? true : false;
            this.buscadoAte = null;

            if ( !this.remarcacao && !this.autorizacao && !this.adicao && !repetir_mais ) { 
                this.cadastro_temporario = {
                    st_cod_pais: "55",
                };
            }

            if ( this.marcacao_alterar_proc && this.marcacao_alterar_proc.cadastro_temporario ) { 
                this.cadastro_temporario = _.cloneDeep(this.marcacao_alterar_proc.cadastro_temporario);
            }

            if ( this.orcamento ) {
                this.startFluxo(1);
                this.$refs.orcamento.reset();
                this.dados.unidade_operacao = uo_default;
            } else if ( repetir_mais ) { 

                if ( this.id_infusao ) { 
                    this.$nextTick(() => {
                        if ( dados.data_base ) {  
                            this.buscadoAte = dados.data_base; 
                        }
                        this.preparar_marcar_infusao();
                    });

                    return;
                }

                this.$nextTick(() => { 
                    this.startFluxo(dados.paciente ? 2 : 1);
                    this.buscarHorarios();
                });
            }

            if ( this.tmaInterval ) {
                clearInterval ( this.tmaInterval );
                this.tmaInterval = null;
            }

            this.dt_valid_termino_autorizacao = null;

        },

        adicionarProcedimento (consumos = null, in_quantidade = null) {

            const ofertado = this.ofertado;

            if ( this.dados.selected ) { 

                this.dados = _.cloneDeep(this.dados);
                this.dados.selected = false;
                this.dados.medico = null;
                this.dados.procedimento = null;
                this.dados.procedimento_equipamentos = null;
                this.dados.tipo_consulta = null;
                this.dados.st_regiao = "";

                this.subespecialidades = null;
                
                this.$forceUpdate();

                this.hide_proc = true

                this.$nextTick(() => { 
                    this.hide_proc = false;

                    this.$nextTick(() => { 
                        this.focusOn('info_procedimento');
                    });
                });

                return;

            }

            if ( !this.podeMarcar && !this.data && !this.orcamento ) {
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: 'Restrição para marcação. Reveja os itens selecionados.',
                    life: 5000
                });

                return;
            }

            if ( this.dados.procedimento && this.dados.procedimento.bloq_valor ) { 

                this.$toast.add({
                    severity: "error",
                    summary: this.dados.plano.search,
                    detail: "Procedimento não pode ser adicionado, pois não foi encontrado em tabela de preço: " + this.dados.procedimento.search,
                    life: 8000
                });

                return;

            }

            if ( this.lista_sinalizadores && this.lista_sinalizadores.length ) { 

                const texto = this.lista_sinalizadores.map(item => item.sinalizador_completo.st_acao_mensagem
                    ? item.sinalizador_completo.st_acao_mensagem
                    : item.sinalizador_completo.search )
                    .join(' / ');

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: this.dados.paciente.st_nome + ' => ' + texto,
                    life: 8000
                });

                return;

            }


            // Centro Cirúrgico...

            if ( this.cc && this.dados.procedimento && !this.dados.medico ) { 

                this.$toast.add({
                    severity: "error",
                    summary: this.dados.procedimento.search,
                    detail: "Necessário selecionar o profissional para o procedimento.",
                    life: 8000
                });

                return;

            }

            // Recursos

            if ( this.dados.procedimento_equipamentos && this.dados.procedimento_equipamentos.length ) { 

                if ( this.dados.procedimento_equipamentos.find(item => !item.equipamento) ) { 

                    this.$toast.add({
                        severity: "error",
                        summary: this.dados.procedimento.search,
                        detail: "Necessário selecionar o recurso necessário para o procedimento.",
                        life: 5000
                    });

                    return;

                }

                this.dados.procedimento_equipamentos = this.dados.procedimento_equipamentos.filter(item => !item.excluido);
                
            }

            // 

            if ( this.informa_regiao && !this.dados.regiao_cd ) { 
                    
                this.$toast.add({
                    severity: "error",
                    summary: 'Coleta Domiciliar',
                    detail: "Necessário informar a região de coleta para avançar na marcação.",
                    life: 5000
                });

                return;

            }

            //

            if ( this.dados && this.dados.procedimento && this.dados.procedimento.fl_recurso > 0 && this.dados.procedimento_equipamentos === null ) { 

                this.$toast.add({
                    severity: "error",
                    summary: 'Adicionar Procedimento',
                    detail: "Recurso não identificado.",
                    life: 5000
                });

                return;

            }
            
            let procedimento = _.cloneDeep (this.dados);

            // if ( procedimento.fl_recurso > 0 && procedimento.da)

            if ( in_quantidade > 1 ) { 
                procedimento.in_quantidade = in_quantidade;
            }

            // Tratamento de Pacote na Marcação...

            if ( procedimento.procedimento && procedimento.procedimento.st_regiao ) { 
                procedimento.st_regiao = procedimento.procedimento.st_regiao;
            }

            if ( procedimento.procedimento && procedimento.procedimento.id_pacote ) { 

                this.$store.commit('loading', true);

                this.$util.loadItem(this, { 
                    service: 'procedimentos',
                    func: 'show',
                    parms: { 
                        id: procedimento.procedimento.id_procedimento,
                        id_plano: procedimento.plano ? procedimento.plano.id_plano : 1, 
                        with: [
                            'comboProcedimentos.procedimento.especialidade',
                            'comboProcedimentos.procedimento.pacote',
                            'pacote'
                        ],
                    }
                })
                .then(res => { 
                    
                    if ( res.pacote 
                        && !this.is_adicao_direta 
                        && res.pacote.fl_combo 
                        && !res.pacote.fl_combo_pacote 
                        && res.pacote.fl_marcacao_combinada 
                        && res.combo_procedimentos && res.combo_procedimentos.length ) { 

                        res.combo_procedimentos.forEach(proc => { 

                            if ( !procedimento.combo ) { 
                                procedimento.combo = { 
                                    id_procedimento: procedimento.procedimento.id_procedimento,
                                    search: procedimento.procedimento.search, 
                                }
                            }

                            procedimento.procedimento = proc.procedimento;
                            this.dados = _.cloneDeep(procedimento);

                            if ( !_.get(this.dados.procedimento, 'pacote.fl_marcacao_combinada') ) { 
                                this.dados.procedimento.id_pacote = null;
                            }

                            this.ofertado = ofertado;
                            
                            this.adicionarProcedimento();
                        });

                    } else { 

                        this.dados = _.cloneDeep(procedimento);

                        if ( this.dados.procedimento ) { 
                            this.dados.procedimento.id_pacote = null;
                        }

                        this.ofertado = ofertado;
                            
                        this.adicionarProcedimento();

                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

                return 'PACOTE';
            }

            //

            procedimento.selected = true;
            procedimento.novo = true;
            procedimento.hora = null;
            procedimento.subespecialidades = this.subespecialidades
                ? this.subespecialidades.filter(sub => sub.selecionado)
                    .map(sub => sub.tag)
                : null;

            if ( !procedimento.repetir ) {
                procedimento.repetir = false;
                procedimento.repeticao = { base: procedimento.data, hora: procedimento.hora };
            }

            procedimento.doc_pre_atends = null;
            procedimento.ofertado = this.ofertado; 

            if ( this.data ) {
                this.procedimentos = [];
            }

            procedimento.index = this.procedimentos.length;

            if ( consumos ) { 
                procedimento.consumos = _.cloneDeep(consumos);
            }

            this.procedimentos.push(procedimento);

            if ( this.orcamento ) {
                this.$refs.orcamento.incluirProcedimento(procedimento.procedimento, procedimento.medico, procedimento.index, this.continuar_lista);
            } else { 
                this.continuar_lista();   
            }

            if ( !this.data ) {

                this.dados.medico = null;
                this.dados.procedimento = null;
                this.dados.procedimento_equipamentos = null;
                this.dados.tipo_consulta = null;
                this.subespecialidades = null;
                this.ofertado = false;

                this.hide_proc = true

                this.$nextTick(() => { 
                    this.hide_proc = false;

                    this.$nextTick(() => { 
                        this.focusOn('info_procedimento');
                    });
                });

            }

        },

        continuar_lista () { 
            console.log('continuar', this.lista_adicao.length, this.lista_adicao);

            if ( this.lista_adicao && this.lista_adicao.length ) { 
                let item = this.lista_adicao.shift();

                this.selecionarProcedimento(item, true);
                this.adicionarProcedimento ();
            }
        },

        removerElemento (lista, index) {
            lista.splice(index, 1);
        },

        removerProcedimento (index) {

            this.procedimentos.splice(index, 1);

        },

        buscarHorarios () {

            this.selecao.dia = null;

            let procedimentoAdicionado = false;

            if ( !this.procedimentos.length ) {
                procedimentoAdicionado = true;
                this.adicionarProcedimento ();
            }

            if ( !this.procedimentos.length )
                return;

            this.buscando = true;

            if ( !this.podeMarcar ) {

                this.buscando = false;

                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: 'Restrição para marcação. Reveja os itens selecionados.',
                    life: 5000
                });

                if ( this.$refs.instruc_conf && this.$refs.instruc_conf.checar_agenda_com_solic_aut() ) { 
                    this.$refs.vincularAutorizacao.abrir(this.procedimentos);
                } else if ( this.$refs.instrucoes && this.$refs.instrucoes.checar_agenda_com_solic_aut() ) { 
                    this.$refs.vincularAutorizacao.abrir(this.procedimentos);
                }

                return;
            }

            if ( this.data ) {
                this.buscando = false;
                return;
            }

            let buscaAdicional = !!this.buscadoAte;
            let completar_busca = false;
            let lista_instrucoes;
            
            if ( !buscaAdicional ) {
                this.dt_prazo_revisao = ( ( this.dadosRemarcacao && this.dadosRemarcacao.ch_tipo_consulta == 'R' ) ? this.dadosRemarcacao.dt_prazo_revisao : null );
                this.medico_revisao = null;
                this.unidade_revisao = null;
                this.revisao_filtro = false;
                this.revisao_filtro_unidade = false;
                this.marcacao_unico_profissional = false;
                this.outras_agendas = [];
            }

            if ( !buscaAdicional && this.$refs.instruc_conf )
                lista_instrucoes = this.$refs.instruc_conf.lista();

            let inicio = this.buscadoAte ?
                moment(this.buscadoAte).add(1, 'd').format('YYYY-MM-DD') :
                moment().format('YYYY-MM-DD');

            if ( 1 == 0 && !buscaAdicional && this.procedimentos.length > 5 && !this.buscadoAte ) { 
                this.buscadoAte = moment().add(4, 'd').format('YYYY-MM-DD');
                // completar_busca = true;
            } else {
                this.buscadoAte = this.buscadoAte ?
                    moment(this.buscadoAte).add(6, 'd').format('YYYY-MM-DD') :
                    moment().add(6, 'd').format('YYYY-MM-DD');
            }

            if ( this.remarcacao && this.trocarmedico && this.dadosRemarcacao && !this.buscadoAte ) {
                this.buscadoAte = this.dadosRemarcacao.dt_inicio.substr(0, 10);
            }

            let query = { q: [] };

            // .filter(item => item.novo || !this.adicao_procedimento_pos)

            this.procedimentos.forEach((item, index) => {
                    query.q.push({
                        name: 'agendas.index',
                        id: 'horarios.' + index,
                        parms: {
                            inicio: inicio,
                            fim: this.buscadoAte,
                            medico: ( item.medico ? item.medico.id_pessoa : "" ),
                            procedimento: ( item.procedimento ? item.procedimento.id_procedimento : "" ),
                            plano: ( item.plano ? item.plano.id_plano : "" ),
                            paciente: ( item.paciente ? item.paciente.id_pessoa : "" ),
                            livres: true,
                            group: 'none',
                            index: index,
                            para_marcar: true,
                            unidade_operacao: this.dados.unidade_operacao ? this.dados.unidade_operacao.id_unidade_operacao : null,
                            id_regiao_cd: item.regiao_cd ? item.regiao_cd.id_regiao_cd : null, // this.dados.regiao_cd ? this.dados.regiao_cd.id_regiao_cd : null,
                            block_filtro_regiao: !this.filtro_por_regiao, 
                            revisao: item.tipo_consulta == 'R' ? true : false,
                            tipo_consulta: item.tipo_consulta,  
                            id_especialidade: ( item.procedimento ? item.procedimento.id_especialidade : null ),
                            subespecialidades: item.subespecialidades,
                            qt_procs: this.procedimentos.length,
                            id_marcacao_remarcacao: item.id_remarcacao
                                ? item.id_remarcacao
                                : ( 
                                    ( this.remarcacao && this.dadosRemarcacao ) 
                                        ? this.dadosRemarcacao.id_marcacao
                                        : null
                                ), 
                            adicao: this.adicao_procedimento_pos,
                            block_busca: !item.novo && this.adicao_procedimento_pos, 
                            combo: false, // item.combo ? true : false, 
                            cc: this.cc ? true : false, 
                            infusao: this.infusao ? true : false, 
                            infusao_data: ( this.dados && this.dados.infusao && this.dados.infusao.in_qt_data ) ? this.dados.infusao.in_qt_data : null,
                            recursos: ( item.procedimento_equipamentos ) 
                                ? item.procedimento_equipamentos.filter(item => !item.excluido) 
                                : null, 
                            id_solicitacao_autorizacao: item.id_solicitacao_autorizacao, 
                        }
                    })

                    item.index = index;
                    item.novo = false;
                });

            let cacheMedicos = [];
            let cacheUnidades = [];

            if ( buscaAdicional ) {

                cacheMedicos = _.cloneDeep(this.medicos);

                _.forEach(cacheMedicos, (medico, key) => {
                    medico.selecionado = this.medicosSelecionados[key];
                });

                cacheUnidades = _.cloneDeep(this.unidades);

                _.forEach(cacheUnidades, (unidade, key) => {
                    unidade.selecionado = this.unidadesSelecionadas[key];
                });

            }

            this.tempo_busca = 0;

            let timer_busca = setInterval(() => {
                this.tempo_busca = Math.round( ( this.tempo_busca + 0.362 ) * 10 ) / 10 ;
            }, 362);

            let sel_aut = false;

            this.axios.post ('/aql?a=horarios', query)
                .then(res => {

                    let todos = [];

                    _.forEach (res.data, (item) => {

                        if ( _.get(item, 'data.sel_sol_aut') ) { 
                            sel_aut = true; 
                        }
                        
                        if ( item.data && item.data.parms ) { 

                            let proc = this.procedimentos.find(pp => pp.index === item.data.parms.index
                                && pp.procedimento.id_procedimento == item.data.parms.procedimento );

                            if ( proc ) { 
                                proc.rest_nao_cobre = item.data.parms.rest_nao_cobre ? true : false;
                                proc.rest_aut_prev = item.data.parms.rest_aut_prev ? true : false;
                            }
    
                        }

                        todos = _.concat(todos, _.values(item.data.agendas));

                        if ( item.data && item.data.parms && item.data.parms.dt_prazo_revisao ) {
                            this.dt_prazo_revisao = item.data.parms.dt_prazo_revisao;
                            this.medico_revisao = item.data.parms.medico_revisao;
                            this.unidade_revisao = item.data.parms.unidade_revisao;
                            this.revisao_filtro = true;
                            this.revisao_filtro_unidade = true;
                        }

                        if ( item.data.medicos ) {
                            this.lista_medicos_agenda = this.lista_medicos_agenda.concat(item.data.medicos);
                        }

                        if ( !this.outras_agendas || !this.outras_agendas.length && item.data.outras_agendas ) { 
                            this.outras_agendas = item.data.outras_agendas.filter(outra =>  {
                                return !this.procedimentos.find(proc => proc.id_remarcacao == outra.id_marcacao);
                            });
                        }

                        if ( this.procedimentos && this.procedimentos.length == 1 && item.data && item.data.parms && item.data.parms.fim ) { 
                            if ( item.data.parms.fim < this.buscadoAte ) { 
                                this.buscadoAte = item.data.parms.fim;
                            }
                        }
                    });

                    this.adicao_procedimento_pos = false;

                    if ( buscaAdicional && this.horarios ) {
                        this.horarios = _.concat(this.horarios, todos);
                    } else {
                        this.horarios = todos;
                    }

                    this.datas = _.uniq(
                        this.horarios.map(item => { 
                            return moment(item.data, 'YYYY-MM-DD').format('YYYY-MM-DD');
                        })
                    );

                    this.horarios = this.horarios.map(item => { 
                        item.ds = moment(item.data, 'YYYY-MM-DD').format('d');
                        return item;
                    });

                    let med = [];
                    let medTodos = true;
                    let und = [];
                    let undTodos = true;

                    _.forEach(this.medicos, medico => {
                        let cache = cacheMedicos.find(item => item.id_pessoa == medico.id_pessoa);

                        if ( cache ) {
                            med.push(cache.selecionado);

                            if ( !cache.selecionado ) {
                                medTodos = false;
                            }
                            return;
                        }

                        med.push(true);
                    });

                    _.forEach(this.unidades, unidade => {

                        let cache = cacheUnidades.find(item => item.id_unidade_operacao == unidade.id_unidade_operacao);

                        if ( cache ) {
                            und.push(cache.selecionado);

                            if ( !cache.selecionado ) {
                                undTodos = false;
                            }
                            return;
                        }

                        und.push(true);

                    });

                    this.medicosSelecionados = med;
                    this.medicosTodos = medTodos;

                    this.unidadesSelecionadas = und;
                    this.unidadesTodas = undTodos;

                    if ( res.data['horarios.0'] ) { 
                        this.campos_customizados_base = res.data['horarios.0'].data.campos_customizados;

                        if ( this.campos_customizados_base 
                            && this.campos_customizados_base.js_campos 
                            && this.dadosRemarcacao 
                            && this.dadosRemarcacao.js_outros_campos ) { 

                            this.$utilform.preencher_campos(
                                this.campos_customizados_base.js_campos, 
                                this.dadosRemarcacao.js_outros_campos
                            );

                        }
                    }

                    this.$nextTick(() => {

                        if ( procedimentoAdicionado ) {
                            this.$refs.instrucoes.buscar_plano(this.dados);
                            this.$refs.instrucoes.buscar_procedimento(this.dados);
                        } else if ( this.$refs.instrucoes && lista_instrucoes ) {
                            this.$refs.instrucoes.definir(lista_instrucoes);
                        }

                        this.verificar_medico_proc();

                    });

                })
                .finally(() => {
                    this.buscando = false;

                    if ( completar_busca ) { 
                        this.buscarHorarios();
                    }

                    clearInterval(timer_busca);
                    clearInterval(timer_busca._id);

                    if ( sel_aut ) { 
                        this.$nextTick(() => { 
                            if ( this.procedimentos && this.procedimentos[0] && this.procedimentos[0].paciente ) { 
                                this.voltar();
                                this.$refs.vincularAutorizacao.abrir(this.procedimentos);
                            }
                        });
                    }
                });

        },

        marcar() {

            this.validarCadTemp = true;

            this.$nextTick (() => {

                let invalids = $('.invalid');

                if ( invalids.length && $('.invalid').is(':visible') ) {

                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                } else {

                    let dados;
                    let lista = this.procedimentos.filter(item => item.selected)
                        .map(item => _.cloneDeep(item));

                    // let lista = this.procedimentos.filter(item => item.selected);

                    if ( this.fluxo == 1 || ( this.dados.paciente && this.dados.paciente.id_pessoa < 0 ) ) {

                        dados = {
                                cadastro_temporario: this.cadastro_temporario,
                                procedimentos: lista,
                                st_observacoes: this.st_observacoes, 
                                medico_solicitante: {}, 
                            };

                    } else {

                        dados = {
                                paciente: this.dados.paciente,
                                procedimentos: lista,
                                st_observacoes: this.st_observacoes, 
                                medico_solicitante: {}, 
                            };

                    }

                    if ( this.$refs.outros_cd && dados.procedimentos.length ) { 

                        dados.procedimentos[0].outros_pac = this.$refs.outros_cd.obter_lista();

                        if ( dados.procedimentos[0].slots && dados.procedimentos[0].slots < dados.procedimentos[0].outros_pac.length + 2 ) { 
                            this.$toast.add({
                                severity: "error",
                                summary: "Atenção",
                                detail: "Quantidade de pacientes informados superior ao informado inicialmente. \n" 
                                    + "Informado: " + ( dados.procedimentos[0].slots - 1 ) + " \n" 
                                    + "Lançado: " + ( dados.procedimentos[0].outros_pac.length + 1 ),
                                life: 5000
                            });
                            return;
                        }

                        if ( dados.procedimentos[0].slots && ( dados.procedimentos[0].slots > ( dados.procedimentos[0].outros_pac.length + 2 ) ) ) { 
                            dados.procedimentos[0].slots = dados.procedimentos[0].outros_pac.length + 2;
                        }

                    }

                    if ( dados.procedimentos ) { 

                        let vagas_excedidas = false;

                        dados.procedimentos.forEach(horario => { 

                            if ( horario.ordem_chegada && horario.vagas && horario.slots > 1 ) { 

                                if ( horario.vagas - horario.marcados - horario.slots < 0 ) { 
                                    this.$toast.add({
                                        severity: "warn",
                                        summary: "Atenção",
                                        detail: "Vagas não disponíveis. \n"
                                            + "Vagas: " + horario.vagas + " \n"
                                            + "Ocupadas: " + horario.marcados + " \n"
                                            + "Selecionadas: " + horario.slots + " \n",
                                        life: 5000
                                    }); 
                                    vagas_excedidas = true;
                                }

                            }

                        });

                        if ( vagas_excedidas ) { 
                            return;
                        }

                    }

                    let query = { q: [
                        {
                            name: 'agendas.store',
                            id: 'marcar',
                            parms: {
                                ...dados,
                                fl_tele_atendimento: this.fl_tele_atendimento,
                                inicio: this.tmaInicio,
                                termino: this.tmaFim,
                                remarcacao: this.remarcacao,
                                autorizacao: this.autorizacao,
                                espera: this.espera,
                                lista_de_espera: this.dados.lista_de_espera ? true : false,
                                origem: this.origem,
                                campos_customizados: this.campos_customizados_base,
                                id_recepcao: this.id_recepcao,
                                id_sinalizador_atendimento: _.get(this.sinalizador_atendimento, 'id_sinalizador_atendimento'),
                                doc_pre_atends: ( this.origem == 'confirm' && this.confirm_docs ) ? this.confirm_docs : this.pre_atendimentos, 
                                id_marcacao_alterar_proc: this.marcacao_alterar_proc ? this.marcacao_alterar_proc.id_marcacao : null,  
                                id_infusao: this.dados.infusao ? this.dados.infusao.id_infusao : null, 
                                in_qt_ciclo: this.dados.infusao ? this.dados.infusao.in_qt_ciclo : null, 
                                in_qt_dia: this.dados.infusao ? this.dados.infusao.in_qt_dia : null, 
                                id_orcamento: this.dados.id_orcamento, 
                                medico_solicitante: this.dados.medico_solicitante, 
                                dt_solicitacao: this.dados.dt_solicitacao,
                                id_cid: this.dados.id_cid, 
                            }
                        }
                    ]};

                    this.buscando = true;
                    this.$store.commit('loading', true);

                    this.axios.post ('/aql?a=agendas.store', query)
                        .then(res => {
                            if ( res.data.marcar.status == 200 ) {

                                if ( res.data.marcar.data.id_cadastro_temporario ) { 
                                    this.cadastro_temporario.id_cadastro_temporario = res.data.marcar.data.id_cadastro_temporario;
                                }

                                let uo = ( this.procedimentos && this.procedimentos.length ) ? this.procedimentos[0].id_unidade_operacao : '?';
                                let action = this.remarcacao ? 'remarcar' : 'marcar';
                                let label = this.fl_tele_atendimento ? 'teleatendimento' :  ( 'UN:' + uo );

                                this.$gtag.event(action, {
                                    'event_category': window.redir,
                                    'event_label': label,
                                    'value': 1
                                });

                                this.resumo = res.data.marcar.data;

                                if ( this.modalName )
                                    $(this.modalName).modal('hide');


                                $('#cadastroModal').modal('hide');

                                this.msg_final = this.dados.lista_de_espera ? 'Inclusão Realizada!' : '';

                                let res_final = res.data.marcar.data.resumofinal;

                                this.aviso_final = setTimeout(() => {
                                    if ( !res_final ) { 
                                        this.avancar_aviso_final(); 
                                    } else { 
                                        console.log('res_final', res_final);
                                    }

                                    /*
                                    this.aviso_final = null;
                                    $(".modal").modal('hide');

                                    this.$emit('refresh', this.resumo);

                                    if ( this.voltar_ao_concluir ) {
                                        this.$router.go(-1);
                                        return;
                                    }
                                    */
                                }, 1500);

                                if ( this.dados_infusao && this.dados_infusao.lista && this.dados_infusao.lista.length > 1 ) { 

                                    clearTimeout(this.aviso_final);
                                    this.aviso_final = null;

                                    let dif_dias = this.dados_infusao.lista[1].dia - this.dados_infusao.in_qt_dia;

                                    this.dados_infusao.lista = this.dados_infusao.lista.slice(1);
                                    this.dados_infusao.in_qt_dia = this.dados_infusao.lista[0].dia;
                                    this.dados_infusao.in_qt_data = this.dados_infusao.lista[0].prev_data;

                                    if ( !this.dados_infusao.in_qt_data ) { 

                                        this.dados_infusao.in_qt_data = moment(this.procedimentos[0].data, 'YYYY-MM-DD')
                                            .add(dif_dias, 'd')
                                            .format('YYYY-MM-DD');

                                    }

                                    this.procedimentos[0].repetir_mais = true; 

                                    this.reiniciar({ repetir_mais: true, repetir_prof: 'M', data_base: this.procedimentos[0].data });
                                    
                                } else { 

                                    if ( _.get(this.procedimentos, '0.repetir_mais') ) { 
                                        this.reiniciar({ repetir_mais: true });
                                    } else { 
                                        this.reiniciar ();
                                    }

                                }

                            }
                        })
                        .finally(() => {
                            this.buscando = false;
                            this.$store.commit('loading', false);
                        });

                }

            });

        },

        // Funções de Formatação de Data/Hora.

        getFormatDate (date, format) {
            return moment(date, 'YYYY-MM-DD').format(format);
        },

        getHumanDay (date) {
            return moment(date, 'YYYY-MM-DD').format('dddd');
        },

        getHumanDate (date) {
            return moment(date, 'YYYY-MM-DD').format('DD') + ' de ' +
                moment(date, 'YYYY-MM-DD').format('MMMM') +
                ( moment(date, 'YYYY-MM-DD').format('YYYY') == new Date().getFullYear() ? '' :
                    ' de ' + moment(date, 'YYYY-MM-DD').format('YYYY') );
        },

        getHumanDuration (date) {
            let end = moment().startOf('day');
            return moment.duration(moment(date, 'YYYY-MM-DD').diff(end)).humanize(true);
        },

        listaPacientes(ref = null, unico = null) {
            if ( this.$store.state.user.id_plano ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: 'Acesso não disponível.',
                    life: 5000
                });     

                return;
            }

            this.$refs.listaPac.abrir(
                ref, 
                this.procedimentos, 
                this.medicos.filter ((item, key) => {
                    return this.medicosSelecionados[key];
                }),
                false,
                ( unico !== null ) ? unico : ( this.tem_medico_unico && this.marcacao_unico_profissional )
            );
        },

        marcarPaciente(id) {

            let query = { q: [
                {
                    name: 'pacientes.show',
                    id: 'paciente',
                    parms: {
                        id: id,
                    }
                }
            ]};

            this.axios.post('/aql?a=pacientes.show', query)
                .then(res => {
                    if ( res.data.paciente.status == 200 ) {
                        this.startFluxo(2);

                        this.dados.paciente = res.data.paciente.data;
                        this.selecionarPaciente();

                        this.dados.plano = res.data.paciente.data.plano;
                        this.selecionarPlano(this.dados.plano);
                    }
                });

        },

        preparar_marcar_infusao () { 

            this.$util.loadItem(this, {
                service: 'infusoes',
                func: 'show',
                parms: {
                    id: this.id_infusao,
                    id_plano: this.dados_infusao ? this.dados_infusao.id_plano : null, 
                    agenda: true, 
                },
                configs: [
                    'infusao-agenda-block-medico', 
                ]
            })
            .then(res => {

                this.startFluxo(2);

                this.cadastro_temporario = null;

                this.dados.infusao = { 
                    ...res,
                    ...( this.dados_infusao ? this.dados_infusao : {} ) 
                };

                this.dados.paciente = res.paciente;
                this.selecionarPaciente(true);

                this.dados.plano = res.plano;
                this.selecionarPlano(this.dados.plano);

                if ( res.procedimento ) { 
                    this.dados.procedimento = res.procedimento;
                    this.selecionarProcedimento(this.dados.procedimento);
                }

                if ( res.medico && !( this.$store.state.contexto['infusao-agenda-block-medico'] == 1 ) ) { 
                    this.dados.medico = res.medico;
                    this.selecionarMedico(this.dados.medico);

                    this.buscarHorarios ();
                }

            });

        }

    },

    beforeMount () { 
        if ( this.$route.path == '/call-center' ) { 
            this.sticky = ( this.$util.getCookie('ccsticky') == 'S' ); 
        }
    },

    mounted () {

        this.loadOptions ('marcacoes.stats', 'marcacoesStats', { para_marcacao: true })
            .then(res => {
                this.info_oferta = res.info_oferta;
                this.orc_convert_unidades = res.orc_convert_unidades;
                this.recursos = res.recursos;
                this.regioes = res.regioes;
                this.block_sel_medico = res.block_sel_medico;
                this.chapp_id_plano = res.chapp_id_plano;
                this.chapp_id_operadora = res.chapp_id_operadora;

                if ( this.dados && this.dados.regiao_cd && this.dados.regiao_cd.id_regiao_cd ) { 
                    let regiao = this.regioes.find(reg => reg.id_regiao_cd == this.dados.regiao_cd.id_regiao_cd);

                    if ( regiao ) { 
                        this.dados.regiao_cd = regiao;

                        if ( this.procedimentos && this.procedimentos.length == 1 ) { 
                            if ( _.get(this.procedimentos, '0.regiao_cd') ) { 
                                this.procedimentos[0].regiao_cd = regiao;
                            }
                        }
                    }
                }
            });

        this.espera = this.$route.params.espera;

        if ( this.remarcacao ) {

            let params = this.params ? this.params : this.$route.params;
            let desagrupar = params.desagrupar ? params.desagrupar : null;

            this.trocarmedico = params.trocarmedico;

            let lista = Array.isArray(this.remarcacao)
                ? this.remarcacao
                : [this.remarcacao];

            if ( lista.length > 1 || this.cc ) { 
                this.remarcar_filtro = false;
            }

            let query = { q: [] }

            lista.forEach((item, idx) => { 
                query.q.push({
                    name: 'marcacoes.show',
                    id: 'marcacao.' + idx,
                    parms: {
                        id: item,
                        para_remarcacao: true,
                    }
                });
            });

            this.axios.post('/aql?a=remarcacao', query)
                .then(res => {

                    lista.forEach((item, idx) => { 

                        const chave = "marcacao." + idx;

                        if ( res.data[chave].status == 200 ) {
                            this.startFluxo(res.data[chave].data.paciente ? 2 : 1);

                            if ( this.$route.params.blockrepetir ) { 
                                res.data[chave].data.repeticao = null; 
                                res.data[chave].data.blockrepetir = true;
                            }

                            this.cadastro_temporario = res.data[chave].data.cadastro_temporario;
                            this.dadosRemarcacao = res.data[chave].data;
                            this.dadosRemarcacao.qtd = lista.length;
                            this.dadosRemarcacao.desagrupar = ( desagrupar && desagrupar[idx] ? true : false );
                            
                            if ( _.get(res.data[chave].data, 'js_outros_campos.id_regiao_cd') &&  _.get(params, 'manter_coleta_dom') !== false ) { 
                                this.dados.unidade_operacao = res.data[chave].data.unidade_operacao;
                                this.dados.regiao_cd = { 
                                    id_regiao_cd: _.get(res.data[chave].data, 'js_outros_campos.id_regiao_cd'),
                                    search: res.data[chave].data.nome_regiao_cd, 
                                };
                            } else if ( _.get(params, 'manter_mesma_unidade') ) {
                                this.dados.unidade_operacao = res.data[chave].data.unidade_operacao;
                            }

                            this.dt_prazo_revisao = ( this.dadosRemarcacao.ch_tipo_consulta == 'R' ? this.dadosRemarcacao.dt_prazo_revisao : null );

                            this.dados.id_remarcacao = res.data[chave].data.id_marcacao;
                            this.dados.id_solicitacao_autorizacao = res.data[chave].data.id_solicitacao_autorizacao;
                            this.dados.desagrupar = this.dadosRemarcacao.desagrupar;

                            this.dados.paciente = res.data[chave].data.paciente;
                            this.selecionarPaciente(true);

                            this.dados.plano = res.data[chave].data.plano;
                            this.selecionarPlano(this.dados.plano);

                            this.dados.procedimento = res.data[chave].data.procedimento;
                            
                            if ( res.data[chave].data.id_procedimento_combo ) {
                                this.dados.combo = { 
                                    id_procedimento: res.data[chave].data.id_procedimento_combo,
                                    search: 'Combo', 
                                };
                            } else { 
                                this.dados.combo = null
                            }

                            this.selecionarProcedimento(this.dados.procedimento);

                            //

                            if ( res.data[chave].data.eqps && res.data[chave].data.eqps.length ) { 
                                res.data[chave].data.eqps.forEach(eq => { 
                                    eq.st_tipo = 'E';
                                    eq.excluido = false; 
                                });
                                
                                this.dados.procedimento_equipamentos = res.data[chave].data.eqps;
                            }

                            //

                            if ( params.medico ) {
                                this.dados.medico = params.medico;
                                this.selecionarMedico(this.dados.medico);
                            }

                            //

                            if ( lista.length >= 1 
                                && res.data[chave].data.js_outros_procedimentos 
                                && ( !desagrupar || !desagrupar[idx] ) ) { 
                                this.dados.outros_procedimentos = res.data[chave].data.js_outros_procedimentos;
                            } else { 
                                this.dados.outros_procedimentos = [];
                            }

                            if ( res.data[chave].data.ch_tipo_consulta == 'R' ) { 
                                this.definir_tipo_consulta('R');
                            } else { 
                                this.definir_tipo_consulta('');
                            }

                            // console.log(idx, this.dados);

                            if ( lista.length > 1 || ( desagrupar && desagrupar.find(item => item) ) ) { 
                                
                                this.adicionarProcedimento ();

                                if ( lista.length >= 1 
                                    && res.data[chave].data.js_outros_procedimentos 
                                    && ( desagrupar && desagrupar[idx] )  ) { 
                                
                                    res.data[chave].data.js_outros_procedimentos.forEach(proc => { 

                                        this.dados.id_remarcacao = res.data[chave].data.id_marcacao;
                            
                                        this.dados.paciente = res.data[chave].data.paciente;
                                        this.selecionarPaciente(true);

                                        this.dados.plano = res.data[chave].data.plano;
                                        this.selecionarPlano(this.dados.plano);

                                        proc.desagrupar = true;

                                        this.dados.procedimento = proc;
                                        this.dados.outros_procedimentos = [];
                                        
                                        if ( res.data[chave].data.id_procedimento_combo ) {
                                            this.dados.combo = { 
                                                id_procedimento: res.data[chave].data.id_procedimento_combo,
                                                search: 'Combo', 
                                            };
                                        } else { 
                                            this.dados.combo = null;
                                        }

                                        this.selecionarProcedimento(this.dados.procedimento);

                                        this.adicionarProcedimento ();

                                    });

                                }

                                if ( idx == lista.length - 1 ) { 
                                    setTimeout(() => { 
                                        this.buscarHorarios ();
                                    }, 1000);
                                }

                            } else { 

                                this.buscarHorarios ();

                            }

                            this.st_observacoes = res.data[chave].data.st_observacoes;
                            this.fl_tele_atendimento = res.data[chave].data.fl_tele_atendimento;

                        }

                    });
                });

        } else if ( this.autorizacao ) {

            this.$util.loadItem(this, {
                service: 'solicitacao_autorizacoes',
                id: this.autorizacao,
                parms: {
                    para_agendar: true,
                },
            })
            .then(res => {

                this.startFluxo(res.paciente ? 2 : 1);

                this.cadastro_temporario = res.cadastro_temporario;
                //this.dadosRemarcacao = res;

                this.dados.id_solicitacao_autorizacao = !isNaN(this.autorizacao) ? this.autorizacao : this.autorizacao.id_solicitacao_autorizacao;
                this.dados.paciente = res.paciente;

                this.selecionarPaciente(true);

                this.dados.plano = res.plano;
                this.selecionarPlano(this.dados.plano);

                if ( res.combo && !_.get(res, 'combo.pacote.fl_marcacao_combinada') ) { 
                    this.dados.procedimento = res.combo;    
                } else { 
                    
                    this.dados.procedimento = res.procedimento;

                    if ( res.js_secundarios && res.js_secundarios.length ) { 

                        this.dados.outros_procedimentos = res.js_secundarios.filter(sec => sec.in_status != 3 && sec.in_status != 5)
                            .map(item => { 
                                let ret = { 
                                    in_quantidade: item.in_quantidade > 1 ? item.in_quantidade : 1,
                                    id_procedimento: item.procedimento ? item.procedimento.id_procedimento : item.id_procedimento,
                                    search: item.procedimento ? item.procedimento.search : item.search, 
                                    js_complementos: [],
                                    st_regiao: "", 
                                };

                                if ( item.fl_block_valor ) { 
                                    ret.fl_block_valor = true;
                                }

                                if ( item.dc_valor_procedimento || item.dc_valor_procedimento === 0 ) { 
                                    ret.dc_valor_procedimento = item.dc_valor_procedimento;
                                }

                                return ret;
                            });

                    }

                }
                
                this.selecionarProcedimento(this.dados.procedimento);

                if ( this.$route.params.outro_medico_selecionado ) {
                    this.dados.medico = this.$route.params.outro_medico_selecionado;
                    this.selecionarMedico(this.dados.medico);
                } else if ( res.medico && !this.$route.params.outro_medico ) {
                    this.dados.medico = res.medico;
                    this.selecionarMedico(this.dados.medico);
                }

                this.buscarHorarios ();

            });

        } else if ( this.id_requisicao_procedimento ) {

            this.$util.loadItem(this, {
                service: 'pep',
                func: 'requisicao_para_marcar',
                parms: {
                    id_requisicao_procedimento: this.id_requisicao_procedimento,
                },
            })
            .then(res => {

                this.startFluxo(2);

                this.cadastro_temporario = null;

                this.dados.paciente = res.paciente;
                this.selecionarPaciente(true);

                this.dados.plano = res.plano;
                this.selecionarPlano(this.dados.plano);

                //this.dados.procedimento = res.procedimento;
                //this.selecionarProcedimento(this.dados.procedimento);

                //this.buscarHorarios ();

            });

        } else if ( this.orcamento ) {

            this.startFluxo(1);

        } else if ( this.espera ) {

            this.$util.loadItem(this, {
                service: 'lista_esperas',
                parms: {
                    id: this.espera,
                }
            })
            .then(res => {

                this.startFluxo(res.paciente ? 2 : 1);

                this.cadastro_temporario = res.cadastro_temporario;
                this.dadosRemarcacao = res;

                this.dados.paciente = res.paciente;
                this.selecionarPaciente(true);

                this.dados.plano = res.plano;
                this.selecionarPlano(this.dados.plano);

                this.dados.procedimento = res.procedimento;
                this.selecionarProcedimento(this.dados.procedimento);

                this.dados.medico = res.medico;
                this.selecionarMedico(this.dados.medico);

                this.buscarHorarios ();

            });

        } else if ( this.adicao ) {

            let query = { q: [
                {
                    name: 'marcacoes.show',
                    id: 'marcacao',
                    parms: {
                        id: this.adicao,
                        para_remarcacao: true,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => {
                    if ( res.data.marcacao.status == 200 ) {
                        this.startFluxo(res.data.marcacao.data.paciente ? 2 : 1);

                        this.cadastro_temporario = res.data.marcacao.data.cadastro_temporario;
                        this.dadosRemarcacao = res.data.marcacao.data;

                        this.dados.paciente = res.data.marcacao.data.paciente;
                        this.selecionarPaciente(true);

                        this.dados.plano = res.data.marcacao.data.plano;
                        this.selecionarPlano(this.dados.plano);

                        if ( this.retorno ) { 
                            
                            this.dados.procedimento = res.data.marcacao.data.procedimento;
                            this.selecionarProcedimento(this.dados.procedimento);

                            if ( res.data.marcacao.data.atendimento && res.data.marcacao.data.atendimento.medico ) { 
                                this.dados.medico = res.data.marcacao.data.atendimento.medico;
                                this.selecionarMedico(this.dados.medico);

                                this.buscarHorarios ();
                            }

                        }
                    }
                });

        } else if ( this.marcar_paciente ) {

            this.marcarPaciente(this.marcar_paciente);

        } else if ( this.$route.params.info_orcamento ) { 

            const info_orcamento = this.$route.params.info_orcamento;
            const agenda_procs = this.$route.params.agenda_procs;

            console.log('io', info_orcamento);
            console.log('ap', agenda_procs);

            this.startFluxo(info_orcamento.id_paciente ? 2 : 1);

            if ( this.fluxo == 1 ) { 

                if ( !this.dados.cadastro_temporario ) { 
                    this.dados.cadastro_temporario = {
                        st_cod_pais: "55",
                    };
                }

                if ( info_orcamento.cadastro_temporario ) { 
                    this.dados.cadastro_temporario = info_orcamento.cadastro_temporario;
                    this.cadastro_temporario = { ...info_orcamento.cadastro_temporario };
                    
                } else { 
                    this.dados.cadastro_temporario.st_nome = info_orcamento.st_nome;
                    this.dados.cadastro_temporario.st_email = info_orcamento.st_email;
                    this.dados.cadastro_temporario.st_celular = info_orcamento.st_celular;
                
                    if ( !this.cadastro_temporario ) { 
                        this.cadastro_temporario = {
                            st_cod_pais: "55",
                        };
                    }

                    this.cadastro_temporario.st_nome = info_orcamento.st_nome;
                    this.cadastro_temporario.st_email = info_orcamento.st_email;
                    this.cadastro_temporario.st_celular = info_orcamento.st_celular;
                    this.cadastro_temporario.st_cpf = info_orcamento.st_cpf;

                }

            } else { 

                this.dados.paciente = info_orcamento.paciente;
                this.selecionarPaciente(true);

            }

            if ( info_orcamento.id_unidade_operacao ) { 
                this.dados.unidade_operacao = info_orcamento.unidade_operacao;
            }
            
            if ( info_orcamento.plano ) { 
                this.selecionarPlano(info_orcamento.plano);
            }

            if ( info_orcamento.js_outros_campos && info_orcamento.js_outros_campos.qt_pac > 0 ) { 
                this.dados.qt_pac = info_orcamento.js_outros_campos.qt_pac;
            }

            if ( info_orcamento.js_outros_campos && info_orcamento.js_outros_campos.id_regiao_cd > 0 ) { 
                if ( this.regioes ) { 
                    let regiao = this.regioes.find(reg => reg.id_regiao_cd == info_orcamento.js_outros_campos.id_regiao_cd);

                    if ( regiao ) { 
                        this.dados.regiao_cd = regiao;
                    }
                } else { 
                    this.dados.regiao_cd = { 
                        id_regiao_cd: info_orcamento.js_outros_campos.id_regiao_cd,
                    };
                }
            }

            if ( info_orcamento.js_procedimentos ) { 

                let primeiro = _.first(info_orcamento.js_procedimentos);

                if ( 1==0 && primeiro && primeiro.procedimento.id_especialidade == 2 ) { 

                    this.selecionarProcedimento(primeiro.procedimento);
                    this.adicionarProcedimento(primeiro.atendimento_procedimento_consumos, primeiro.in_quantidade);

                    this.procedimentos[0].outros_procedimentos = info_orcamento.js_procedimentos.slice(1)
                        .map(item => { 
                            let ret = { 
                                in_quantidade: item.in_quantidade > 1 ? item.in_quantidade : 1,
                                id_procedimento: item.procedimento.id_procedimento,
                                search: item.procedimento.search, 
                                js_complementos: [],
                                st_regiao: "", 
                            };

                            if ( item.fl_block_valor ) { 
                                ret.fl_block_valor = true;
                            }

                            if ( item.dc_valor_procedimento || item.dc_valor_procedimento === 0 ) { 
                                ret.dc_valor_procedimento = item.dc_valor_procedimento;
                            }

                            return ret;
                        });

                } else { 

                    let proc_lab = null;

                    info_orcamento.js_procedimentos.forEach(proc => { 

                        if ( ( proc.procedimento.id_especialidade == 2 ) && proc_lab ) { 

                            let ret = { 
                                in_quantidade: proc.in_quantidade > 1 ? proc.in_quantidade : 1,
                                id_procedimento: proc.procedimento.id_procedimento,
                                search: proc.procedimento.search, 
                                js_complementos: [],
                                st_regiao: "", 
                            };

                            if ( proc.fl_block_valor ) { 
                                ret.fl_block_valor = true;
                            }

                            if ( proc.dc_valor_procedimento || proc.dc_valor_procedimento === 0 ) { 
                                ret.dc_valor_procedimento = proc.dc_valor_procedimento;
                            }

                            if ( !proc_lab.outros_procedimentos ) { 
                                proc_lab.outros_procedimentos = [];
                            }

                            proc_lab.outros_procedimentos.push(ret);

                            return;

                        }

                        if ( agenda_procs && agenda_procs.length ) { 
                            if ( !agenda_procs.find(ap => ap.id_procedimento == proc.procedimento.id_procedimento && ap.selecionado) ) { 
                                return;
                            }
                        }

                        this.selecionarProcedimento(proc.procedimento);

                        if ( proc.medico ) { 
                            this.selecionarMedico(proc.medico);
                        }

                        this.adicionarProcedimento(proc.atendimento_procedimento_consumos, ( agenda_procs && agenda_procs.length ) ? 1 : proc.in_quantidade);

                        if ( ( proc.procedimento.id_especialidade == 2 ) && !proc_lab ) { 
                            proc_lab = this.procedimentos[this.procedimentos.length - 1];
                        }
                        
                    });

                }
            }

            if ( info_orcamento && info_orcamento.id_orcamento ) { 
                this.dados.id_orcamento = info_orcamento.id_orcamento; 
            }

        } else if ( this.id_infusao ) {

            this.preparar_marcar_infusao();

            /*
            this.$util.loadItem(this, {
                service: 'infusoes',
                func: 'show',
                parms: {
                    id: this.id_infusao,
                    id_plano: this.dados_infusao ? this.dados_infusao.id_plano : null, 
                    agenda: true, 
                },
                configs: [
                    'infusao-agenda-block-medico', 
                ]
            })
            .then(res => {

                this.startFluxo(2);

                this.cadastro_temporario = null;

                this.dados.infusao = { 
                    ...res,
                    ...( this.dados_infusao ? this.dados_infusao : {} ) 
                };

                this.dados.paciente = res.paciente;
                this.selecionarPaciente(true);

                this.dados.plano = res.plano;
                this.selecionarPlano(this.dados.plano);

                if ( res.procedimento ) { 
                    this.dados.procedimento = res.procedimento;
                    this.selecionarProcedimento(this.dados.procedimento);
                }

                if ( res.medico && !( this.$store.state.contexto['infusao-agenda-block-medico'] == 1 ) ) { 
                    this.dados.medico = res.medico;
                    this.selecionarMedico(this.dados.medico);

                    this.buscarHorarios ();
                }

            });
            */

        }

    },

    updated () {
        $('[data-toggle="tooltip"]').tooltip();
    }

}
</script>

<style>
.fixo-topo { 
  position: sticky;
  top: 100px;
  z-index: 1;
}

.modal-dialog2 {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

.atalho {
    opacity: 0.95;
}

.atalho:hover {
	opacity: 1;
}

.atalho:hover i {
    -webkit-transition: opacity 0.2s ease-in;
    -moz-transition: opacity 0.2s ease-in;
    -o-transition: opacity 0.2s ease-in;
    transition: opacity 0.2s ease-in;
    opacity: 0;
}

.atalho:hover div {
	-webkit-transform: translate3d(0,-30px,0);
	transform: translate3d(0,-30px,0);
}

.atalho:hover div {
	-webkit-transition-delay: 0.05s;
	transition-delay: 0.05s;
	-webkit-transition-duration: 0.35s;
	transition-duration: 0.35s;
}

.atalho i,
.atalho div {
	-webkit-transition: -webkit-transform 0.35s;
	transition: transform 0.35s;
}

.az-anime-surgir {
  animation: az-surgir 1s;
}

@keyframes az-surgir {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1) ease-in-out;
  }
}

.az-anime-slide {
    left: -10px;
    animation: az-slide 0.5s forwards;
    animation-delay: 2s;
}

@keyframes az-slide {
    100% { left: 0; }
}

/* Cores Extra */

.text-vermelho { 
  color: #900;  
}

.badge-vermelho { 
  background-color: #900;  
  color: white;
}

.btn-vermelho { 
  background-color: #900;  
  color: white;
}

.btn-outline-vermelho { 
  border-color: #900;
  color: #900;
}

.list-group-item-vermelho { 
  background-color: #90000050;
}

/* Rosa */

.text-rosa { 
  color: #e83e8c;  
}

.badge-rosa { 
  background-color: #e83e8c;  
  color: white;
}

.btn-rosa { 
  background-color: #e83e8c;  
  color: white;
}

.btn-outline-rosa { 
  border-color: #e83e8c;
  color: #e83e8c;
}

.list-group-item-rosa { 
  background-color: #e83e8c50;
}

/* Teal */

.text-teal { 
  color: #20c997;  
}

.badge-teal { 
  background-color: #20c997;  
  color: white;
}

.btn-teal { 
  background-color: #20c997;  
  color: white;
}

.btn-outline-teal { 
  border-color: #20c997;
  color: #20c997;
}

.list-group-item-teal { 
  background-color: #20c99750;
}

/* Purple */

.text-purple { 
  color: #6f42c1;  
}

.badge-purple { 
  background-color: #6f42c1;  
  color: white;
}

.btn-purple { 
  background-color: #6f42c1;  
  color: white;
}

.btn-outline-purple { 
  border-color: #6f42c1;
  color: #6f42c1;
}

.list-group-item-purple { 
  background-color: #6f42c150;
}

/* Orange */

.text-orange { 
  color: #fd7e14;  
}

.badge-orange { 
  background-color: #fd7e14;  
  color: white;
}

.btn-orange { 
  background-color: #fd7e14;  
  color: white;
}

.btn-outline-orange { 
  border-color: #fd7e14;
  color: #fd7e14;
}

.list-group-item-orange { 
  background-color: #fd7e1450;
}

/* Orange */

.text-verde-escuro { 
  color: #405d27;  
}

.badge-verde-escuro { 
  background-color: #405d27;  
  color: white;
}

.btn-verde-escuro { 
  background-color: #405d27;  
  color: white;
}

.btn-outline-verde-escuro { 
  border-color: #405d27;
  color: #405d27;
}

.list-group-item-verde-escuro { 
  background-color: #405d2750;
}

.sticky-info-right {
  height: 100%; /* Full-height: remove this if you want "auto" height */
  width: 160px; /* Set the width of the sidebar */
  position: fixed; /* Fixed Sidebar (stay in place on scroll) */
  z-index: 1; /* Stay on top */
  top: 0; /* Stay at the top */
  right: 0;
  background-color: #111; /* Black */
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 116px;
}

</style>
